"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactType = exports.Contact = exports.ConstructorInfo = exports.ConnectionInfo = exports.ComputeQueryOption = exports.ComputeExpression = exports.ComputeClause = exports.ClockinRuleOverrideModel = exports.ClockinRuleOverride = exports.ClockinRule = exports.ClockinRequest = exports.ClockinHistoryResponse = exports.Clockin = exports.ClassifierType = exports.ClaimsPrincipal = exports.ClaimsIdentity = exports.Claim = exports.ChangePasswordBindingModel = exports.ChangeEmailBindingModel = exports.CashupSummaryDto = exports.CashupSetDto = exports.CashupLineDto = exports.CashupDto = exports.CancellationToken = exports.CallingConventions = exports.ByteReadOnlySpan = exports.ByteReadOnlyMemory = exports.BulkStaffMemberEmailUpdateRequest = exports.Budget = exports.BreakDto = exports.BrandModel = exports.BaseConditionModel = exports.AuthenticateResponse = exports.AuthModule = exports.AuTaxScaleType = exports.AuTaxFileNumberExemptionType = exports.AuPayeesWorkingCondition = exports.AuIncomeType = exports.AsymmetricAlgorithm = exports.Assembly = exports.AsnEncodedData = exports.ApplyQueryOption = exports.ApplyClause = exports.AddressFamily = exports.AddCashupRequest = exports.ActivatedPackageDto = exports.ActivatedLeaveType = exports.Action = exports.CoreApiClient = exports.ClientBase = void 0;
exports.GetSalesTransactionHeadersResponse = exports.GetSalesResponse = exports.GetRefundsResponse = exports.GetPosStaffSalesResponse = exports.GetPosStaffOrdersResponse = exports.GetPosStaffItemSalesResponse = exports.GetPosStaffItemOrdersResponse = exports.GetPosItemsResponse = exports.GetPosItemsOrdersSummaryResponse = exports.GetOrdersResponse = exports.GetMasterItemsResponse = exports.GetItemSuperGroupsResponse = exports.GetItemSalesResponse = exports.GetItemGroupSalesResponse = exports.GetItemGroupOrdersResponse = exports.GetDiscountsResponse = exports.GenericParameterAttributes = exports.FilterQueryOption = exports.FilterClause = exports.FieldInfo = exports.FieldAttributes = exports.EventInfo = exports.EventAttributes = exports.EvaluationTypeModel = exports.EvaluationType = exports.EmploymentType = exports.EmployeeMatchTypeModel = exports.EmployeeMatchPayload = exports.EmployeeMatchCondition = exports.EdmTypeKind = exports.EdmSchemaElementKind = exports.EdmReferentialConstraintPropertyPair = exports.EdmPropertyKind = exports.EdmOnDeleteAction = exports.EdmExpressionKind = exports.EdmContainerElementKind = exports.ETag = exports.DeliveryDetailsModel = exports.DeleteRuleOverrideRequest = exports.DeleteActivatedPackageRequest = exports.DefaultQueryConfigurations = exports.DaysOfTheWeek = exports.CustomAttributeTypedArgument = exports.CustomAttributeNamedArgument = exports.CustomAttributeData = exports.CreatePayRunModel = exports.CreateCloudposDatabaseRequest = exports.Countries = exports.CountQueryOption = exports.CopyRosterRequest = void 0;
exports.IODataQueryValidator = exports.IIdentity = exports.IGetVoidsResponse = exports.IGetVoidsByReasonResponse = exports.IGetTableSummaryResponse = exports.IFilterQueryValidator = exports.IEdmVocabularyAnnotation = exports.IEdmVocabularyAnnotatable = exports.IEdmTypeReference = exports.IEdmType = exports.IEdmTerm = exports.IEdmStructuredType = exports.IEdmStructuralProperty = exports.IEdmSchemaElement = exports.IEdmReferentialConstraint = exports.IEdmProperty = exports.IEdmPathExpression = exports.IEdmNavigationSource = exports.IEdmNavigationPropertyBinding = exports.IEdmNavigationProperty = exports.IEdmModel = exports.IEdmExpression = exports.IEdmEntityContainerElement = exports.IEdmEntityContainer = exports.IEdmDirectValueAnnotationsManager = exports.ICustomAttributeProvider = exports.ICountQueryValidator = exports.IContractResolver = exports.IComputeQueryValidator = exports.IBasePayloadModel = exports.HttpResponse = exports.HttpRequest = exports.HttpContext = exports.HostString = exports.GetTransactionLinesResponse = exports.GetTransactionHeadersResponse = exports.GetTopStaffVoidsResponse = exports.GetTopStaffItemGroupsResponse = exports.GetTipsResponse = exports.GetTillsReponse = exports.GetTendersResponse = exports.GetTenderSurchargesResponse = exports.GetTablesByStaffResponse = exports.GetTableSummaryResponse = exports.GetSurchargesResponse = exports.GetSuppliersResponse = exports.GetStockItemSummariesResponse = exports.GetStockItemGroupsResponse = exports.GetStockItemCostResponse = exports.GetSalesTransactionLinesResponse = void 0;
exports.ModuleHandle = exports.Module = exports.MethodInfo = exports.MethodImplAttributes = exports.MethodBase = exports.MethodAttributes = exports.MemberTypes = exports.MemberInfo = exports.MaritalStatus = exports.ManualPosSaleHeader = exports.LoginRequest = exports.LogicalOperatorType = exports.LoadedUnavailabilityStatus = exports.LoadedUnavailabilityRecordType = exports.LoadedSubscriptionModel = exports.LoadedRevenueGroup = exports.LoadedPreferredHours = exports.LoadedPayRunPayslip = exports.LoadedPayRunEmployee = exports.LoadedPayRun = exports.LoadedLeaveTypeType = exports.LoadedLeaveRequestStatus = exports.LoadedActionType = exports.ListRule = exports.LeaveTypeConditions = exports.LeaveType = exports.LeaveRequestUpdateRequest = exports.LeaveRequest = exports.LayoutKind = exports.KiwisaverStatus = exports.KeySizes = exports.ItemsRevenueGroupModel = exports.ItemSupplierModel = exports.ItemRevenueGroupModel = exports.ItemOperation = exports.ItemModel = exports.ItemJsonPatchDocument = exports.ItemGroupModel = exports.IntPtr = exports.InboundEmailAttachment = exports.ITopQueryValidator = exports.IStaffMemberRequest = exports.ISkipTokenQueryValidator = exports.ISkipQueryValidator = exports.ISession = exports.IServiceProvider = exports.ISelectExpandQueryValidator = exports.IResponseCookies = exports.IPAddress = exports.IOrderByQueryValidator = void 0;
exports.PaytypeResponse = exports.PaytypeDefaultQuantity = exports.PaytypeAutoAdd = exports.Paytype = exports.PayrunOperation = exports.PayrunODataQueryOptions = exports.PayrunLinePaytype = exports.PayrunLineClockin = exports.PayrunLine = exports.PayrunJsonPatchDocument = exports.PayrunFrequency = exports.PayrunETag = exports.Payrun = exports.PayrollSystem = exports.PayrollPayTypeSource = exports.PayrollPayTypeRef = exports.PayrollEmployee = exports.PayRunStatus = exports.PayRunEmployeeStatus = exports.PayClassificationVariationModel = exports.PayClassificationType = exports.PayClassificationRequest = exports.PayClassification = exports.PayAdjustmentRuleSchedule = exports.PayAdjustmentRuleActionReferenceDto = exports.PayAdjustmentRuleActionReference = exports.PayAdjustmentRuleActionDto = exports.PayAdjustmentRuleAction = exports.PayAdjustmentRule = exports.PayAdjustmentPackage = exports.PayAdjustmentLinkedCondition = exports.PayAdjustmentConditionTypeCode = exports.PayAdjustmentConditionType = exports.PathString = exports.ParameterInfo = exports.ParameterAttributes = exports.PackageType = exports.PackageRef = exports.OrderByQueryOption = exports.OrderByNode = exports.OrderByDirection = exports.OrderByClause = exports.OperationType = exports.Oid = exports.ODataRawQueryOptions = exports.ODataQueryContext = exports.ODataPathSegment = exports.NzTaxCode = exports.NzKiwisaverContributionOptions = exports.NewTicketRequestModel = void 0;
exports.RuntimeTypeHandle = exports.RuntimeMethodHandle = exports.RuntimeFieldHandle = exports.RuleTypeModel = exports.RuleType = exports.RuleScheduleRequest = exports.RuleScheduleRepeat = exports.RuleSchedule = exports.RuleRequest = exports.RulePayCodeTypeModel = exports.RulePayCodeType = exports.RuleOverrideTypeModel = exports.RuleOverrideType = exports.RuleActionType = exports.Rule = exports.RosteredShifts = exports.RosteredShiftRequest = exports.RosterRequest = exports.ResidencyStatus = exports.RemunerationType = exports.RelationshipTypes = exports.RangeVariable = exports.QueryString = exports.QueryNodeKind = exports.PutRuleRequest = exports.PutPayTypeRequest = exports.PutPackageRequest = exports.PutItemSuppliersRequest = exports.PutItemRequest = exports.PutActivatedPackageRequest = exports.PublishRosterRequest = exports.PublicKey = exports.PropertyInfo = exports.PropertyAttributes = exports.PriceInformationResponse = exports.PostSyncPayRunModel = exports.PostRuleRequest = exports.PostRuleOverrideRequest = exports.PostPaytypeRequest = exports.PostPaytypeEnabledStaffRequest = exports.PostPaytypeEnabledRolesRequest = exports.PostPayTypeRequest = exports.PostPackageRequest = exports.PostClockinRuleRequest = exports.PostActivatedPackageRequest = exports.PosStaffSurchargesResponse = exports.PosStaffDiscountsResponse = exports.PosItemsStaffOrdersSummary = exports.PosItemsOrdersSummary = exports.PipeWriter = void 0;
exports.SuperRuleCode = exports.SubscriptionProductModel = exports.SubscriptionCustomerModel = exports.SubscriptionCouponModel = exports.SubscriptionComponentModel = exports.SubscriptionCompanyModel = exports.StructLayoutAttribute = exports.StringStringValuesKeyValuePair = exports.StringStringKeyValuePair = exports.StaffRoleResponse = exports.StaffRolePaytypeResponse = exports.StaffRolePaytype = exports.StaffRolePayRule = exports.StaffRolePayAdjustmentRequest = exports.StaffRole = exports.StaffMemberRoleRequestModel = exports.StaffMemberRoleModel = exports.StaffMemberRole = exports.StaffMemberRemunerationSnapshotRequest = exports.StaffMemberRemunerationSnapshot = exports.StaffMemberRemunerationHistoryRequestModel = exports.StaffMemberRemunerationHistory = exports.StaffMemberPaytypeModel = exports.StaffMemberPaytype = exports.StaffMemberPayRule = exports.StaffMemberPayClassificationReference = exports.StaffMemberPayAdjustmentModel = exports.StaffMemberOperation = exports.StaffMemberNz = exports.StaffMemberJsonPatchDocument = exports.StaffMemberIdEmailPair = exports.StaffMemberAuPayrollDetail = exports.StaffMemberAu = exports.StaffMember = exports.SkipTokenQueryOption = exports.SkipTokenHandler = exports.SkipQueryOption = exports.SingleValueNode = exports.ShiftType = exports.SetPreferenceBindingModel = exports.SendgridWebHookResponse = exports.SelectedShifts = exports.SelectItem = exports.SelectExpandQueryOption = exports.SelectExpandClause = exports.SecurityRuleSet = exports.SearchQueryOption = exports.SearchClause = exports.SalesTaxDto = exports.SafeWaitHandle = void 0;
exports.ApiException = exports.Body2 = exports.Body = exports.X509Extension = exports.X509Certificate2 = exports.X500DistinguishedName = exports.WebSocketManager = exports.WaitHandle = exports.VariationUnitType = exports.VariationActionType = exports.UpdateStaffPosMemberRoleRequest = exports.UpdateProfileBindingModel = exports.UpdateEndDateRequest = exports.UnitModel = exports.Unit = exports.UnavailabilityTime = exports.UnavailabilityRecordUpdateRequest = exports.UnavailabilityRecord = exports.TypeObjectKeyValuePair = exports.TypeInfo = exports.TypeAttributes = exports.Type = exports.TransformationNodeKind = exports.TransformationNode = exports.TopQueryOption = exports.TokenResponse = exports.ThirdPartyConnectionCompanyAttachModel = exports.ThirdPartyConnectionAuthoriseModel = exports.SupplierModel = exports.SupplierAlias = exports.Supplier = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const dayjs = require("dayjs");
class ClientBase {
    constructor(config) {
        this.authToken = config.authToken;
        this.companyId = config.companyId;
    }
    transformOptions(options) {
        const authToken = typeof this.authToken === 'function' ? this.authToken() : this.authToken;
        const companyId = typeof this.companyId === 'function' ? this.companyId() : this.companyId;
        options.headers = Object.assign(Object.assign({}, options.headers), { Authorization: `Bearer ${authToken}`, 'x-loaded-company-id': companyId });
        return Promise.resolve(options);
    }
}
exports.ClientBase = ClientBase;
class CoreApiClient extends ClientBase {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Sign In
     * @param body (optional)
     * @return User logged in successfully
     */
    login(body) {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLogin(_response);
        });
    }
    processLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthenticateResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = AuthenticateResponse.fromJS(resultData400);
                return throwException("Invalid username or password.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sign In
     * @param body (optional)
     * @return User logged in successfully
     */
    login22(body) {
        let url_ = this.baseUrl + "/token";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = Object.keys(body).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
        }).join('&');
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLogin22(_response);
        });
    }
    processLogin22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TokenResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = AuthenticateResponse.fromJS(resultData400);
                return throwException("Invalid username or password.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sign In
     * @param body (optional)
     * @return User logged in successfully
     */
    login33(body) {
        let url_ = this.baseUrl + "/token2";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = Object.keys(body).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
        }).join('&');
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLogin33(_response);
        });
    }
    processLogin33(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TokenResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = AuthenticateResponse.fromJS(resultData400);
                return throwException("Invalid username or password.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get third party system Accounts
     * @return OK
     */
    thirdParty() {
        let url_ = this.baseUrl + "/stock/accounts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processThirdParty(_response);
        });
    }
    processThirdParty(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the default freight account
     * @param xeroAccount (optional)
     * @return OK
     */
    defaultFreightAccount(xeroAccount) {
        let url_ = this.baseUrl + "/stock/accounts/set-default-freight-account?";
        if (xeroAccount === null)
            throw new Error("The parameter 'xeroAccount' cannot be null.");
        else if (xeroAccount !== undefined)
            url_ += "xeroAccount=" + encodeURIComponent("" + xeroAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDefaultFreightAccount(_response);
        });
    }
    processDefaultFreightAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * create a package activation record and related rule conditions in the company database
     * @param body (optional)
     * @return OK
     */
    activatePackage(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/activate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processActivatePackage(_response);
        });
    }
    processActivatePackage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a package activation in the company database
     * @param body (optional)
     * @return No Content
     */
    updatePackageActivation(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/activate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdatePackageActivation(_response);
        });
    }
    processUpdatePackageActivation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a rule package activation in the company database
     * @param body (optional)
     * @return No Content
     */
    deletePackageActivation(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/activate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeletePackageActivation(_response);
        });
    }
    processDeletePackageActivation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Find the latest deleted activation of a package in the company database
     * @param packageRef (optional)
     * @return OK
     */
    getLatestDeletedPackageActivation(packageRef) {
        let url_ = this.baseUrl + "/pay-rules/packages/activate/{packageRef}?";
        if (packageRef === null)
            throw new Error("The parameter 'packageRef' cannot be null.");
        else if (packageRef !== undefined)
            url_ += "packageRef=" + encodeURIComponent("" + packageRef) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLatestDeletedPackageActivation(_response);
        });
    }
    processGetLatestDeletedPackageActivation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActivatedPackageDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    cloudpos(body) {
        let url_ = this.baseUrl + "/admin/databases/cloudpos";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCloudpos(_response);
        });
    }
    processCloudpos(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    applicationMenu() {
        let url_ = this.baseUrl + "/application-menu";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processApplicationMenu(_response);
        });
    }
    processApplicationMenu(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a list of all budget entries
     * @return OK
     */
    budgetsAllAll() {
        let url_ = this.baseUrl + "/budgets";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBudgetsAllAll(_response);
        });
    }
    processBudgetsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Budget.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a budget
     * @param body (optional)
     * @return OK
     */
    budgetsPUTPUT(body) {
        let url_ = this.baseUrl + "/budgets";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBudgetsPUTPUT(_response);
        });
    }
    processBudgetsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a budget
     * @param body (optional)
     * @return OK
     */
    budgetsPOSTPOST(body) {
        let url_ = this.baseUrl + "/budgets";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBudgetsPOSTPOST(_response);
        });
    }
    processBudgetsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a budget
     * @param body (optional)
     * @return OK
     */
    budgetsPUTPUT22(id, body) {
        let url_ = this.baseUrl + "/budgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBudgetsPUTPUT22(_response);
        });
    }
    processBudgetsPUTPUT22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all payroll calendars from a third party company
     * @return OK
     */
    calendars() {
        let url_ = this.baseUrl + "/payroll/calendars";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCalendars(_response);
        });
    }
    processCalendars(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a single cashup set by id
     * @return OK
     */
    cashupSets(id) {
        let url_ = this.baseUrl + "/cashup-sets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCashupSets(_response);
        });
    }
    processCashupSets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashupSetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an existing cashup set
     * @param body (optional)
     * @return OK
     */
    updateCashupSet(id, body) {
        let url_ = this.baseUrl + "/cashup-sets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateCashupSet(_response);
        });
    }
    processUpdateCashupSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashupSetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deletes an existing cashup set
     * @return OK
     */
    deleteCashupSet(id) {
        let url_ = this.baseUrl + "/cashup-sets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteCashupSet(_response);
        });
    }
    processDeleteCashupSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a range of cashup sets over a time period
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    cashupSetsAllAll(start, end) {
        let url_ = this.baseUrl + "/cashup-sets?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCashupSetsAllAll(_response);
        });
    }
    processCashupSetsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CashupSetDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new Cashup Set at the current date and time
     * @return OK
     */
    createCashupSet() {
        let url_ = this.baseUrl + "/cashup-sets";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateCashupSet(_response);
        });
    }
    processCreateCashupSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets cashup variance summaries for a time range
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    getSummaries(start, end, interval) {
        let url_ = this.baseUrl + "/cashup-sets/summary?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSummaries(_response);
        });
    }
    processGetSummaries(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CashupSummaryDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Adds an additional till cashup to an existing CashupSet
     * @param body (optional)
     * @return OK
     */
    addCashup(id, body) {
        let url_ = this.baseUrl + "/cashup-sets/{id}/cashups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddCashup(_response);
        });
    }
    processAddCashup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashupDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the end date of an existing cashup set
     * @param body (optional)
     * @return OK
     */
    updateEndDate(id, body) {
        let url_ = this.baseUrl + "/cashup-sets/{id}/update-end-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateEndDate(_response);
        });
    }
    processUpdateEndDate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashupSetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all POS Item Categories
     * @return OK
     */
    getItemCategories() {
        let url_ = this.baseUrl + "/pos/items/categories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetItemCategories(_response);
        });
    }
    processGetItemCategories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets summarized POS orders grouped by item category, and optionally by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    getOrdersByItemCategoryAndInterval(start, end, interval) {
        let url_ = this.baseUrl + "/pos/items/category-orders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrdersByItemCategoryAndInterval(_response);
        });
    }
    processGetOrdersByItemCategoryAndInterval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get sales information for the report period grouped by item category, and optionally by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    getSalesByItemCategoryAndInterval(start, end, interval) {
        let url_ = this.baseUrl + "/pos/items/category-sales?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSalesByItemCategoryAndInterval(_response);
        });
    }
    processGetSalesByItemCategoryAndInterval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get cogs products report
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    cogsProducts(start, end) {
        let url_ = this.baseUrl + "/cogs/products/detail?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCogsProducts(_response);
        });
    }
    processCogsProducts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get cogs summary report
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    cogsSummary(start, end, interval) {
        let url_ = this.baseUrl + "/cogs/products/summary?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCogsSummary(_response);
        });
    }
    processCogsSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get cogs purchases report
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    cogsPurchases(start, end, interval) {
        let url_ = this.baseUrl + "/cogs/purchases?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCogsPurchases(_response);
        });
    }
    processCogsPurchases(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Invites support to this company
     * @param invitedCompanyId (optional)
     * @return OK
     */
    invite(invitedCompanyId) {
        let url_ = this.baseUrl + "/companies/support-invites/invite?";
        if (invitedCompanyId === null)
            throw new Error("The parameter 'invitedCompanyId' cannot be null.");
        else if (invitedCompanyId !== undefined)
            url_ += "invitedCompanyId=" + encodeURIComponent("" + invitedCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processInvite(_response);
        });
    }
    processInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Revoke a support invite to this company
     * @return OK
     */
    revoke() {
        let url_ = this.baseUrl + "/companies/support-invites/revoke";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRevoke(_response);
        });
    }
    processRevoke(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves all Contacts from the linked third party accounting system.
     * @return OK
     */
    contacts() {
        let url_ = this.baseUrl + "/stock/contacts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processContacts(_response);
        });
    }
    processContacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets Discounts grouped by discount type
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posDiscounts(start, end) {
        let url_ = this.baseUrl + "/pos/discounts?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosDiscounts(_response);
        });
    }
    processPosDiscounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetDiscountsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get discount information for the report period and specified staff member, grouped by discount type
     * @param start (optional)
     * @param end (optional)
     * @param posIdentifier (optional)
     * @return OK
     */
    posStaffDiscounts(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/pos/staff/discounts?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' cannot be null.");
        else if (posIdentifier !== undefined)
            url_ += "posIdentifier=" + encodeURIComponent("" + posIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffDiscounts(_response);
        });
    }
    processPosStaffDiscounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PosStaffDiscountsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    downloads(id) {
        let url_ = this.baseUrl + "/downloads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDownloads(_response);
        });
    }
    processDownloads(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all employees from  third party payroll system
     * @return OK
     */
    employees() {
        let url_ = this.baseUrl + "/payroll/employees";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmployees(_response);
        });
    }
    processEmployees(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PayrollEmployee.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new employee in a third party system
     * @param body (optional)
     * @return OK
     */
    employeePOSTPOST(body) {
        let url_ = this.baseUrl + "/payroll/employees";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmployeePOSTPOST(_response);
        });
    }
    processEmployeePOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an employee from a third party system
     * @return OK
     */
    employeeGETGET(id) {
        let url_ = this.baseUrl + "/payroll/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmployeeGETGET(_response);
        });
    }
    processEmployeeGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PayrollEmployee.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an employee in a third party system
     * @param body (optional)
     * @return OK
     */
    employeePUTPUT(id, body) {
        let url_ = this.baseUrl + "/payroll/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmployeePUTPUT(_response);
        });
    }
    processEmployeePUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    expectedVsActual(start, end, interval) {
        let url_ = this.baseUrl + "/gross-profit/expected-vs-actual?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExpectedVsActual(_response);
        });
    }
    processExpectedVsActual(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    features() {
        let url_ = this.baseUrl + "/features";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processFeatures(_response);
        });
    }
    processFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    histories() {
        let url_ = this.baseUrl + "/time/clockins/histories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processHistories(_response);
        });
    }
    processHistories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ClockinHistoryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Export a collection of PurchaseOrders into an accounting system. Update the purchase orders with the Id's returned from Xero so we can link to the invoices
     * @param combine (optional)
     * @param body (optional)
     * @return OK
     */
    exportPurchaseOrders(combine, body) {
        let url_ = this.baseUrl + "/stock/invoices/export/purchaseorders?";
        if (combine === null)
            throw new Error("The parameter 'combine' cannot be null.");
        else if (combine !== undefined)
            url_ += "combine=" + encodeURIComponent("" + combine) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExportPurchaseOrders(_response);
        });
    }
    processExportPurchaseOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Export a collection of PurchaseOrders into an accounting system. Update the purchase orders with the Id's returned from the accounting system so we can link to the invoices
     * @param combine (optional)
     * @param body (optional)
     * @return OK
     */
    exportStatements(combine, body) {
        let url_ = this.baseUrl + "/stock/invoices/export/statements?";
        if (combine === null)
            throw new Error("The parameter 'combine' cannot be null.");
        else if (combine !== undefined)
            url_ += "combine=" + encodeURIComponent("" + combine) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExportStatements(_response);
        });
    }
    processExportStatements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the top item Orders for each staff member, or all orders for a staff member grouped by item
     * @param start (optional)
     * @param end (optional)
     * @param posIdentifier (optional)
     * @return OK
     */
    posStaffItemOrders(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/pos/staff/item-orders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' cannot be null.");
        else if (posIdentifier !== undefined)
            url_ += "posIdentifier=" + encodeURIComponent("" + posIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemOrders(_response);
        });
    }
    processPosStaffItemOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosStaffItemOrdersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a revenue group
     * @param body (optional)
     * @return OK
     */
    updateItemRevenueGroup(posItemId, body) {
        let url_ = this.baseUrl + "/pos/items/{posItemId}/revenue-group";
        if (posItemId === undefined || posItemId === null)
            throw new Error("The parameter 'posItemId' must be defined.");
        url_ = url_.replace("{posItemId}", encodeURIComponent("" + posItemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateItemRevenueGroup(_response);
        });
    }
    processUpdateItemRevenueGroup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update revenue groups
     * @param body (optional)
     * @return OK
     */
    updateItemsRevenueGroup(body) {
        let url_ = this.baseUrl + "/pos/items/revenue-group";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateItemsRevenueGroup(_response);
        });
    }
    processUpdateItemsRevenueGroup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a queryable list of all pos items for this company.
     * @return OK
     */
    posItems() {
        let url_ = this.baseUrl + "/pos/items";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosItems(_response);
        });
    }
    processPosItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosItemsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    budgetAnalysis(start, end, interval) {
        let url_ = this.baseUrl + "/labour/budget-analysis?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBudgetAnalysis(_response);
        });
    }
    processBudgetAnalysis(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    roleAnalysis(start, end) {
        let url_ = this.baseUrl + "/labour/role-analysis?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRoleAnalysis(_response);
        });
    }
    processRoleAnalysis(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    rosterVsActual(start, end, interval) {
        let url_ = this.baseUrl + "/labour/roster-vs-actual?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosterVsActual(_response);
        });
    }
    processRosterVsActual(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    costCentre(start, end, interval) {
        let url_ = this.baseUrl + "/labour/cost-centre?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCostCentre(_response);
        });
    }
    processCostCentre(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of all leave requests made with an option to filter it for a staff member given an id
     * @param staffMemberId (optional)
     * @return OK
     */
    getLeaveRequests(staffMemberId) {
        let url_ = this.baseUrl + "/time/leave-requests?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLeaveRequests(_response);
        });
    }
    processGetLeaveRequests(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(LeaveRequest.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a leave request record in the company db
     * @param body (optional)
     * @return OK
     */
    createLeaveRequest(body) {
        let url_ = this.baseUrl + "/time/leave-requests";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateLeaveRequest(_response);
        });
    }
    processCreateLeaveRequest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveRequest.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a leave requestUpdateRequest made by id from the company db
     * @return OK
     */
    getLeaveRequestById(leaveRequestId) {
        let url_ = this.baseUrl + "/time/leave-requests/{leaveRequestId}";
        if (leaveRequestId === undefined || leaveRequestId === null)
            throw new Error("The parameter 'leaveRequestId' must be defined.");
        url_ = url_.replace("{leaveRequestId}", encodeURIComponent("" + leaveRequestId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLeaveRequestById(_response);
        });
    }
    processGetLeaveRequestById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveRequest.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a leave request record in the company db
     * @param body (optional)
     * @return OK
     */
    updateLeaveRequest(leaveRequestId, body) {
        let url_ = this.baseUrl + "/time/leave-requests/{leaveRequestId}";
        if (leaveRequestId === undefined || leaveRequestId === null)
            throw new Error("The parameter 'leaveRequestId' must be defined.");
        url_ = url_.replace("{leaveRequestId}", encodeURIComponent("" + leaveRequestId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateLeaveRequest(_response);
        });
    }
    processUpdateLeaveRequest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveRequest.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a leave request record's status in the company db
     * @param body (optional)
     * @return OK
     */
    updateLeaveRequestStatus(leaveRequestId, body) {
        let url_ = this.baseUrl + "/time/leave-requests/{leaveRequestId}";
        if (leaveRequestId === undefined || leaveRequestId === null)
            throw new Error("The parameter 'leaveRequestId' must be defined.");
        url_ = url_.replace("{leaveRequestId}", encodeURIComponent("" + leaveRequestId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateLeaveRequestStatus(_response);
        });
    }
    processUpdateLeaveRequestStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveRequest.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Send or resend an existing Leave Request
     * @return OK
     */
    sendLeaveRequest(leaveRequestId) {
        let url_ = this.baseUrl + "/time/leave-requests/{leaveRequestId}/send";
        if (leaveRequestId === undefined || leaveRequestId === null)
            throw new Error("The parameter 'leaveRequestId' must be defined.");
        url_ = url_.replace("{leaveRequestId}", encodeURIComponent("" + leaveRequestId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendLeaveRequest(_response);
        });
    }
    processSendLeaveRequest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveRequest.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a full list of non-deleted leave types from the auth and company db
     * @param staffMemberId (optional)
     * @return OK
     */
    getLeaveTypes(staffMemberId) {
        let url_ = this.baseUrl + "/time/leave-types?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLeaveTypes(_response);
        });
    }
    processGetLeaveTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(LeaveType.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new leave type record in the db
     * @param body (optional)
     * @return OK
     */
    createLeaveType(body) {
        let url_ = this.baseUrl + "/time/leave-types";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateLeaveType(_response);
        });
    }
    processCreateLeaveType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveType.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a single non-deleted leave type from the db
     * @return OK
     */
    getLeaveTypeById(leaveTypeRef) {
        let url_ = this.baseUrl + "/time/leave-types/{leaveTypeRef}";
        if (leaveTypeRef === undefined || leaveTypeRef === null)
            throw new Error("The parameter 'leaveTypeRef' must be defined.");
        url_ = url_.replace("{leaveTypeRef}", encodeURIComponent("" + leaveTypeRef));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLeaveTypeById(_response);
        });
    }
    processGetLeaveTypeById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveType.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a single leave type record in the db
     * @param body (optional)
     * @return OK
     */
    updateLeaveType(leaveTypeRef, body) {
        let url_ = this.baseUrl + "/time/leave-types/{leaveTypeRef}";
        if (leaveTypeRef === undefined || leaveTypeRef === null)
            throw new Error("The parameter 'leaveTypeRef' must be defined.");
        url_ = url_.replace("{leaveTypeRef}", encodeURIComponent("" + leaveTypeRef));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateLeaveType(_response);
        });
    }
    processUpdateLeaveType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveType.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deactivates a leave type for a company
     * @return OK
     */
    deactivateLeaveType(leaveTypeRef) {
        let url_ = this.baseUrl + "/time/leave-types/{leaveTypeRef}";
        if (leaveTypeRef === undefined || leaveTypeRef === null)
            throw new Error("The parameter 'leaveTypeRef' must be defined.");
        url_ = url_.replace("{leaveTypeRef}", encodeURIComponent("" + leaveTypeRef));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeactivateLeaveType(_response);
        });
    }
    processDeactivateLeaveType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Activates a single leave type
     * @param body (optional)
     * @return OK
     */
    activateLeaveType(leaveTypeRef, body) {
        let url_ = this.baseUrl + "/time/leave-types/{leaveTypeRef}/activate";
        if (leaveTypeRef === undefined || leaveTypeRef === null)
            throw new Error("The parameter 'leaveTypeRef' must be defined.");
        url_ = url_.replace("{leaveTypeRef}", encodeURIComponent("" + leaveTypeRef));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processActivateLeaveType(_response);
        });
    }
    processActivateLeaveType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveType.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    subscriptionsAllAll() {
        let url_ = this.baseUrl + "/subscriptions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsAllAll(_response);
        });
    }
    processSubscriptionsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(LoadedSubscriptionModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get details of a customer's subscription
     * @return OK
     */
    subscriptionsGETGET(id) {
        let url_ = this.baseUrl + "/subscriptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsGETGET(_response);
        });
    }
    processSubscriptionsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoadedSubscriptionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the plan of a customer's subscription
     * @param body (optional)
     * @return OK
     */
    subscriptionsPOSTPOST(id, body) {
        let url_ = this.baseUrl + "/subscriptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsPOSTPOST(_response);
        });
    }
    processSubscriptionsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoadedSubscriptionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get details of a customer's subscription if it were to change plan
     * @return OK
     */
    subscriptionsGETGET22(id, plan) {
        let url_ = this.baseUrl + "/subscriptions/{id}/preview/{plan}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (plan === undefined || plan === null)
            throw new Error("The parameter 'plan' must be defined.");
        url_ = url_.replace("{plan}", encodeURIComponent("" + plan));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsGETGET22(_response);
        });
    }
    processSubscriptionsGETGET22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LoadedSubscriptionModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a list of sale headers between two dates
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    getManualPosSaleHeaders(start, end) {
        let url_ = this.baseUrl + "/ManualPosSaleHeaders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetManualPosSaleHeaders(_response);
        });
    }
    processGetManualPosSaleHeaders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Adds a new sale header
     * @param body (optional)
     * @return OK
     */
    addManualPosSaleHeader(body) {
        let url_ = this.baseUrl + "/ManualPosSaleHeaders";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddManualPosSaleHeader(_response);
        });
    }
    processAddManualPosSaleHeader(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a list of sale headers between two dates
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    getManualPosSaleHeaders22(start, end) {
        let url_ = this.baseUrl + "/manual-pos-sale-headers?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetManualPosSaleHeaders22(_response);
        });
    }
    processGetManualPosSaleHeaders22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Adds a new sale header
     * @param body (optional)
     * @return OK
     */
    addManualPosSaleHeader22(body) {
        let url_ = this.baseUrl + "/manual-pos-sale-headers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddManualPosSaleHeader22(_response);
        });
    }
    processAddManualPosSaleHeader22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a specific sale header by id
     * @return OK
     */
    getManualPosSaleHeader(id) {
        let url_ = this.baseUrl + "/ManualPosSaleHeaders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetManualPosSaleHeader(_response);
        });
    }
    processGetManualPosSaleHeader(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a specific sale header by id
     * @param body (optional)
     * @return OK
     */
    updateManualPosSaleHeader(id, body) {
        let url_ = this.baseUrl + "/ManualPosSaleHeaders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateManualPosSaleHeader(_response);
        });
    }
    processUpdateManualPosSaleHeader(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a specific sale header by id
     * @return OK
     */
    getManualPosSaleHeader22(id) {
        let url_ = this.baseUrl + "/manual-pos-sale-headers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetManualPosSaleHeader22(_response);
        });
    }
    processGetManualPosSaleHeader22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a specific sale header by id
     * @param body (optional)
     * @return OK
     */
    updateManualPosSaleHeader22(id, body) {
        let url_ = this.baseUrl + "/manual-pos-sale-headers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateManualPosSaleHeader22(_response);
        });
    }
    processUpdateManualPosSaleHeader22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets summarized POS orders grouped by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    posOrders(start, end, interval) {
        let url_ = this.baseUrl + "/pos/orders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosOrders(_response);
        });
    }
    processPosOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetOrdersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period, grouped by item group
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posItemGroupOrders(start, end) {
        let url_ = this.baseUrl + "/pos/orders/item-groups?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosItemGroupOrders(_response);
        });
    }
    processPosItemGroupOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemGroupOrdersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period and specified item category, grouped by item
     * @param startTime (optional)
     * @param endTime (optional)
     * @param categoryId (optional)
     * @return OK
     */
    posItemOrders(startTime, endTime, categoryId) {
        let url_ = this.baseUrl + "/pos/items/orders?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosItemOrders(_response);
        });
    }
    processPosItemOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosItemsOrdersSummaryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    overview(start, end, interval) {
        let url_ = this.baseUrl + "/gross-profit/overview?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processOverview(_response);
        });
    }
    processOverview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all rule packages
     * @return OK
     */
    packagesGETGET() {
        let url_ = this.baseUrl + "/pay-rules/packages";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesGETGET(_response);
        });
    }
    processPackagesGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new package
     * @param body (optional)
     * @return OK
     */
    packagesPOSTPOST(body) {
        let url_ = this.baseUrl + "/pay-rules/packages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesPOSTPOST(_response);
        });
    }
    processPackagesPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a package
     * @param body (optional)
     * @return OK
     */
    packagesPUTPUT(body) {
        let url_ = this.baseUrl + "/pay-rules/packages";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesPUTPUT(_response);
        });
    }
    processPackagesPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a package by id
     * @param packageRef (optional)
     * @return OK
     */
    packagesGETGET22(packageRef) {
        let url_ = this.baseUrl + "/pay-rules/packages/{packageRef}?";
        if (packageRef === null)
            throw new Error("The parameter 'packageRef' cannot be null.");
        else if (packageRef !== undefined)
            url_ += "packageRef=" + encodeURIComponent("" + packageRef) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesGETGET22(_response);
        });
    }
    processPackagesGETGET22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Disable a rule
     * @param body (optional)
     * @return OK
     */
    packagesPOSTPOST2(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/override";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesPOSTPOST2(_response);
        });
    }
    processPackagesPOSTPOST2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * (Re)Enable a rule
     * @param body (optional)
     * @return OK
     */
    packagesDELETEDELETE(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/override";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPackagesDELETEDELETE(_response);
        });
    }
    processPackagesDELETEDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of pay classifications
     * @return OK
     */
    getPayClassificationList() {
        let url_ = this.baseUrl + "/pay-classifications";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPayClassificationList(_response);
        });
    }
    processGetPayClassificationList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new pay classification
     * @param body (optional)
     * @return OK
     */
    postPayClassification(body) {
        let url_ = this.baseUrl + "/pay-classifications";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPostPayClassification(_response);
        });
    }
    processPostPayClassification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a pay classification
     * @return OK
     */
    getPayClassification(id) {
        let url_ = this.baseUrl + "/pay-classifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPayClassification(_response);
        });
    }
    processGetPayClassification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a pay classification
     * @param body (optional)
     * @return OK
     */
    putPayClassification(id, body) {
        let url_ = this.baseUrl + "/pay-classifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPutPayClassification(_response);
        });
    }
    processPutPayClassification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all payroll earnings rates from a third party company
     * @return OK
     */
    earningsRates() {
        let url_ = this.baseUrl + "/payroll/pay-items/earnings-rates";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEarningsRates(_response);
        });
    }
    processEarningsRates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all pay runs
     * @return OK
     */
    payrollPayRun() {
        let url_ = this.baseUrl + "/payroll/pay-runs";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayRun(_response);
        });
    }
    processPayrollPayRun(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * create a new pay run
     * @param body (optional)
     * @return OK
     */
    create_pay_run(body) {
        let url_ = this.baseUrl + "/payroll/pay-runs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreate_pay_run(_response);
        });
    }
    processCreate_pay_run(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get pay run
     * @return OK
     */
    payrollPayRun2(id) {
        let url_ = this.baseUrl + "/payroll/pay-runs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayRun2(_response);
        });
    }
    processPayrollPayRun2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    payRuns(id, body) {
        let url_ = this.baseUrl + "/payroll/pay-runs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayRuns(_response);
        });
    }
    processPayRuns(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    sync(body) {
        let url_ = this.baseUrl + "/payroll/pay-runs/sync";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSync(_response);
        });
    }
    processSync(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all payroll pay types
     * @return OK
     */
    payrollPayTypesGETGET() {
        let url_ = this.baseUrl + "/payroll/pay-type";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesGETGET(_response);
        });
    }
    processPayrollPayTypesGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * POST a pay type
     * @param body (optional)
     * @return OK
     */
    payrollPayTypesPOSTPOST(body) {
        let url_ = this.baseUrl + "/payroll/pay-type";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesPOSTPOST(_response);
        });
    }
    processPayrollPayTypesPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * PUT a pay type
     * @param body (optional)
     * @return OK
     */
    payrollPayTypesPUTPUT(body) {
        let url_ = this.baseUrl + "/payroll/pay-type";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesPUTPUT(_response);
        });
    }
    processPayrollPayTypesPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all default pay types from a certain payroll system and custom pay types
     * @return OK
     */
    payrollPayTypesGETGET22(payrollSystem) {
        let url_ = this.baseUrl + "/payroll/pay-type/{payrollSystem}";
        if (payrollSystem === undefined || payrollSystem === null)
            throw new Error("The parameter 'payrollSystem' must be defined.");
        url_ = url_.replace("{payrollSystem}", encodeURIComponent("" + payrollSystem));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesGETGET22(_response);
        });
    }
    processPayrollPayTypesGETGET22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all default pay types
     * @return OK
     */
    payrollPayTypesGETGET33() {
        let url_ = this.baseUrl + "/payroll/pay-type/default";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesGETGET33(_response);
        });
    }
    processPayrollPayTypesGETGET33(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * DELETE a pay type
     * @return OK
     */
    payrollPayTypesDELETEDELETE(packageRef) {
        let url_ = this.baseUrl + "/payroll/pay-type/{packageRef}";
        if (packageRef === undefined || packageRef === null)
            throw new Error("The parameter 'packageRef' must be defined.");
        url_ = url_.replace("{packageRef}", encodeURIComponent("" + packageRef));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPayrollPayTypesDELETEDELETE(_response);
        });
    }
    processPayrollPayTypesDELETEDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all POS staff members
     * @param includeDeleted (optional)
     * @return OK
     */
    posStaff(includeDeleted) {
        let url_ = this.baseUrl + "/PosStaff?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaff(_response);
        });
    }
    processPosStaff(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all POS staff members
     * @param includeDeleted (optional)
     * @return OK
     */
    posStaff22(includeDeleted) {
        let url_ = this.baseUrl + "/pos/staff?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaff22(_response);
        });
    }
    processPosStaff22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all POS staff members
     * @return OK
     */
    posStaff33(id) {
        let url_ = this.baseUrl + "/PosStaff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaff33(_response);
        });
    }
    processPosStaff33(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all POS staff members
     * @return OK
     */
    posStaff44(id) {
        let url_ = this.baseUrl + "/pos/staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaff44(_response);
        });
    }
    processPosStaff44(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period and specified staff member, grouped by item group
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffItemGroupOrders(start, end) {
        let url_ = this.baseUrl + "/PosStaffItemGroupOrders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemGroupOrders(_response);
        });
    }
    processPosStaffItemGroupOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PosItemsStaffOrdersSummary.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period and specified staff member, grouped by item group
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffItemGroupOrders22(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/PosStaffItemGroupOrders/StaffMember/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemGroupOrders22(_response);
        });
    }
    processPosStaffItemGroupOrders22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PosItemsOrdersSummary.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the top item group sold for each staff member
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffItemGroupSales(start, end) {
        let url_ = this.baseUrl + "/PosStaffItemGroupSales?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemGroupSales(_response);
        });
    }
    processPosStaffItemGroupSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTopStaffItemGroupsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the Sales for a specified staff member, grouped by item group.
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffItemGroupSales22(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/PosStaffItemGroupSales/StaffMember/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemGroupSales22(_response);
        });
    }
    processPosStaffItemGroupSales22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemGroupSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the top item Orders for each staff member, or all item orders for a single staff member
     * @param start (optional)
     * @param end (optional)
     * @param posIdentifier (optional)
     * @return OK
     */
    posStaffItemSales(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/PosStaffItemSales?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' cannot be null.");
        else if (posIdentifier !== undefined)
            url_ += "posIdentifier=" + encodeURIComponent("" + posIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffItemSales(_response);
        });
    }
    processPosStaffItemSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosStaffItemSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period, grouped by staff member.
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffOrders(start, end) {
        let url_ = this.baseUrl + "/pos/staff/orders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffOrders(_response);
        });
    }
    processPosStaffOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosStaffOrdersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders information for the report period and specified staff member, grouped by report interval.
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    posStaffOrders22(start, end, interval, posIdentifier) {
        let url_ = this.baseUrl + "/pos/staff/orders/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffOrders22(_response);
        });
    }
    processPosStaffOrders22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetOrdersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get table information for the report period, grouped by staff member.
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffTables(start, end) {
        let url_ = this.baseUrl + "/PosStaffTables?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffTables(_response);
        });
    }
    processPosStaffTables(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTablesByStaffResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get table information for the report period, grouped by staff member.
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    posStaffTables22(start, end, interval, posIdentifier) {
        let url_ = this.baseUrl + "/PosStaffTables/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffTables22(_response);
        });
    }
    processPosStaffTables22(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTableSummaryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the top void reason amounts for each staff member, or all voids for a staff member.
     * @param start (optional)
     * @param end (optional)
     * @param posIdentifier (optional)
     * @return OK
     */
    posStaffVoids(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/PosStaffVoids?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' cannot be null.");
        else if (posIdentifier !== undefined)
            url_ += "posIdentifier=" + encodeURIComponent("" + posIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffVoids(_response);
        });
    }
    processPosStaffVoids(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTopStaffVoidsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets Table and Tab summary information by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    posTables(start, end, interval) {
        let url_ = this.baseUrl + "/PosTables?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosTables(_response);
        });
    }
    processPosTables(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(IGetTableSummaryResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of tills from the company database
     * @return OK
     */
    posTills() {
        let url_ = this.baseUrl + "/PosTills";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosTills(_response);
        });
    }
    processPosTills(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTillsReponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update or create a multiple company Preferences
     * @param isArray (optional)
     * @param body (optional)
     * @return OK
     */
    preferences(isArray, body) {
        let url_ = this.baseUrl + "/preferences?";
        if (isArray === null)
            throw new Error("The parameter 'isArray' cannot be null.");
        else if (isArray !== undefined)
            url_ += "isArray=" + encodeURIComponent("" + isArray) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPreferences(_response);
        });
    }
    processPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    priceInformation() {
        let url_ = this.baseUrl + "/price-information";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPriceInformation(_response);
        });
    }
    processPriceInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PriceInformationResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    purchases(start, end, interval) {
        let url_ = this.baseUrl + "/gross-profit/purchases?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPurchases(_response);
        });
    }
    processPurchases(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets summarized POS sale refunds grouped by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @param posItemIdentifier (optional)
     * @return OK
     */
    posSaleRefunds(start, end, interval, posItemIdentifier) {
        let url_ = this.baseUrl + "/pos/sales/refunds?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        if (posItemIdentifier === null)
            throw new Error("The parameter 'posItemIdentifier' cannot be null.");
        else if (posItemIdentifier !== undefined)
            url_ += "posItemIdentifier=" + encodeURIComponent("" + posItemIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosSaleRefunds(_response);
        });
    }
    processPosSaleRefunds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetRefundsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Read Rostered Shift entries between a start and end date/time or by a roster id
     * @param rosterId (optional)
     * @param startTime (optional)
     * @param endTime (optional)
     * @param includeDeleted (optional)
     * @return OK
     */
    rosteredShiftsGETGET(rosterId, startTime, endTime, includeDeleted) {
        let url_ = this.baseUrl + "/time/rostered-shifts?";
        if (rosterId === null)
            throw new Error("The parameter 'rosterId' cannot be null.");
        else if (rosterId !== undefined)
            url_ += "rosterId=" + encodeURIComponent("" + rosterId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosteredShiftsGETGET(_response);
        });
    }
    processRosteredShiftsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a Rostered Shift entry
     * @param body (optional)
     * @return OK
     */
    rosteredShiftsPOSTPOST(body) {
        let url_ = this.baseUrl + "/time/rostered-shifts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosteredShiftsPOSTPOST(_response);
        });
    }
    processRosteredShiftsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a Rostered Shift Entry
     * @param body (optional)
     * @return OK
     */
    rosteredShiftsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/time/rostered-shifts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosteredShiftsPUTPUT(_response);
        });
    }
    processRosteredShiftsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param rosterStartTime (optional)
     * @param rosterEndTime (optional)
     * @param staffMemberIdFrom (optional)
     * @param staffMemberIdTo (optional)
     * @param rosterId (optional)
     * @return OK
     */
    reassignShifts(rosterStartTime, rosterEndTime, staffMemberIdFrom, staffMemberIdTo, rosterId) {
        let url_ = this.baseUrl + "/time/rostered-shifts/reassign-shifts?";
        if (rosterStartTime === null)
            throw new Error("The parameter 'rosterStartTime' cannot be null.");
        else if (rosterStartTime !== undefined)
            url_ += "rosterStartTime=" + encodeURIComponent(rosterStartTime ? "" + rosterStartTime.toISOString() : "") + "&";
        if (rosterEndTime === null)
            throw new Error("The parameter 'rosterEndTime' cannot be null.");
        else if (rosterEndTime !== undefined)
            url_ += "rosterEndTime=" + encodeURIComponent(rosterEndTime ? "" + rosterEndTime.toISOString() : "") + "&";
        if (staffMemberIdFrom === null)
            throw new Error("The parameter 'staffMemberIdFrom' cannot be null.");
        else if (staffMemberIdFrom !== undefined)
            url_ += "staffMemberIdFrom=" + encodeURIComponent("" + staffMemberIdFrom) + "&";
        if (staffMemberIdTo === null)
            throw new Error("The parameter 'staffMemberIdTo' cannot be null.");
        else if (staffMemberIdTo !== undefined)
            url_ += "staffMemberIdTo=" + encodeURIComponent("" + staffMemberIdTo) + "&";
        if (rosterId === null)
            throw new Error("The parameter 'rosterId' cannot be null.");
        else if (rosterId !== undefined)
            url_ += "rosterId=" + encodeURIComponent("" + rosterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processReassignShifts(_response);
        });
    }
    processReassignShifts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    rosteredShiftsSummary(startTime, endTime) {
        let url_ = this.baseUrl + "/time/rostered-shifts-summary?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosteredShiftsSummary(_response);
        });
    }
    processRosteredShiftsSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of Roster Templates
     * @param includeDeleted (optional)
     * @return OK
     */
    rostersGETGET(includeDeleted) {
        let url_ = this.baseUrl + "/time/rosters/templates?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersGETGET(_response);
        });
    }
    processRostersGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create Roster Template by Id
     * @return OK
     */
    rostersPOSTPOST() {
        let url_ = this.baseUrl + "/time/rosters/templates";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPOSTPOST(_response);
        });
    }
    processRostersPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Roster by Id
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    rostersGETGET2(startTime, endTime) {
        let url_ = this.baseUrl + "/time/rosters?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersGETGET2(_response);
        });
    }
    processRostersGETGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Roster by Id
     * @param includeDeletedRosteredShifts (optional)
     * @param inferRatesForRosteredShifts (optional)
     * @return OK
     */
    rostersGETGET3(id, includeDeletedRosteredShifts, inferRatesForRosteredShifts) {
        let url_ = this.baseUrl + "/time/rosters/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeDeletedRosteredShifts === null)
            throw new Error("The parameter 'includeDeletedRosteredShifts' cannot be null.");
        else if (includeDeletedRosteredShifts !== undefined)
            url_ += "includeDeletedRosteredShifts=" + encodeURIComponent("" + includeDeletedRosteredShifts) + "&";
        if (inferRatesForRosteredShifts === null)
            throw new Error("The parameter 'inferRatesForRosteredShifts' cannot be null.");
        else if (inferRatesForRosteredShifts !== undefined)
            url_ += "inferRatesForRosteredShifts=" + encodeURIComponent("" + inferRatesForRosteredShifts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersGETGET3(_response);
        });
    }
    processRostersGETGET3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update Roster by Id
     * @param body (optional)
     * @return OK
     */
    rostersPUTPUT(id, body) {
        let url_ = this.baseUrl + "/time/rosters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPUTPUT(_response);
        });
    }
    processRostersPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Copy a Roster or a Roster Template by Id or a datetime reference
     * @param body (optional)
     * @return OK
     */
    rostersPOSTPOST2(body) {
        let url_ = this.baseUrl + "/time/rosters/templates/copy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPOSTPOST2(_response);
        });
    }
    processRostersPOSTPOST2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Publish Roster by Id
     * @param body (optional)
     * @return OK
     */
    rostersPUTPUT2(id, body) {
        let url_ = this.baseUrl + "/time/rosters/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPUTPUT2(_response);
        });
    }
    processRostersPUTPUT2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Copy a Roster
     * @param body (optional)
     * @return OK
     */
    rostersPOSTPOST3(body) {
        let url_ = this.baseUrl + "/time/rosters/copy-new";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPOSTPOST3(_response);
        });
    }
    processRostersPOSTPOST3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a copy of a previous Roster using a date range
     * @param sourceWeek (optional)
     * @param destinationWeek (optional)
     * @return OK
     */
    rostersPOSTPOST4(sourceWeek, destinationWeek) {
        let url_ = this.baseUrl + "/time/rosters/copy?";
        if (sourceWeek === null)
            throw new Error("The parameter 'sourceWeek' cannot be null.");
        else if (sourceWeek !== undefined)
            url_ += "sourceWeek=" + encodeURIComponent(sourceWeek ? "" + sourceWeek.toISOString() : "") + "&";
        if (destinationWeek === null)
            throw new Error("The parameter 'destinationWeek' cannot be null.");
        else if (destinationWeek !== undefined)
            url_ += "destinationWeek=" + encodeURIComponent(destinationWeek ? "" + destinationWeek.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRostersPOSTPOST4(_response);
        });
    }
    processRostersPOSTPOST4(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the public Roster token to public or private
     * @param token (optional)
     * @return OK
     */
    rosters(token) {
        let url_ = this.baseUrl + "/time/rosters/token?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRosters(_response);
        });
    }
    processRosters(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all Rosters from the company database
     * @param companyId (optional)
     * @param token (optional)
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    timeRosterPublic(companyId, token, startTime, endTime) {
        let url_ = this.baseUrl + "/time-roster-public?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimeRosterPublic(_response);
        });
    }
    processTimeRosterPublic(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all roster preferences from the auth database
     * @param companyId (optional)
     * @param token (optional)
     * @return OK
     */
    timeRosterPublic2(companyId, token) {
        let url_ = this.baseUrl + "/time-roster-public/preferences?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimeRosterPublic2(_response);
        });
    }
    processTimeRosterPublic2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new rule
     * @param body (optional)
     * @return OK
     */
    rulesPOSTPOST(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/rules";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRulesPOSTPOST(_response);
        });
    }
    processRulesPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a rule
     * @param body (optional)
     * @return OK
     */
    rulesPUTPUT(body) {
        let url_ = this.baseUrl + "/pay-rules/packages/rules";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRulesPUTPUT(_response);
        });
    }
    processRulesPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a rule
     * @return OK
     */
    rulesDELETEDELETE(id) {
        let url_ = this.baseUrl + "/pay-rules/packages/rules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRulesDELETEDELETE(_response);
        });
    }
    processRulesDELETEDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get sales information for the report period, grouped by staff member.
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posStaffSales(start, end) {
        let url_ = this.baseUrl + "/pos/staff/sales?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffSales(_response);
        });
    }
    processPosStaffSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPosStaffSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get sales information for the report period and specified staff member, grouped by report interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    posStaffSales2(start, end, interval, posIdentifier) {
        let url_ = this.baseUrl + "/pos/staff/sales/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffSales2(_response);
        });
    }
    processPosStaffSales2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets summarized POS sales grouped by interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @param posItemIdentifier (optional)
     * @return OK
     */
    posSales(start, end, interval, posItemIdentifier) {
        let url_ = this.baseUrl + "/pos/sales?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        if (posItemIdentifier === null)
            throw new Error("The parameter 'posItemIdentifier' cannot be null.");
        else if (posItemIdentifier !== undefined)
            url_ += "posItemIdentifier=" + encodeURIComponent("" + posItemIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosSales(_response);
        });
    }
    processPosSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get sales information for the report period, grouped by item group
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posItemGroupSales(start, end) {
        let url_ = this.baseUrl + "/pos/sales/item-groups?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosItemGroupSales(_response);
        });
    }
    processPosItemGroupSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemGroupSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get sales information for the report period, grouped by item
     * @param startTime (optional)
     * @param endTime (optional)
     * @param categoryId (optional)
     * @return OK
     */
    posItemSales(startTime, endTime, categoryId) {
        let url_ = this.baseUrl + "/pos/items/sales?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosItemSales(_response);
        });
    }
    processPosItemSales(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemSalesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all locale tax rates
     * @param locale (optional)
     * @param province (optional)
     * @return OK
     */
    getLocaleSaleTaxRates(locale, province) {
        let url_ = this.baseUrl + "/sales-tax?";
        if (locale === null)
            throw new Error("The parameter 'locale' cannot be null.");
        else if (locale !== undefined)
            url_ += "locale=" + encodeURIComponent("" + locale) + "&";
        if (province === null)
            throw new Error("The parameter 'province' cannot be null.");
        else if (province !== undefined)
            url_ += "province=" + encodeURIComponent("" + province) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetLocaleSaleTaxRates(_response);
        });
    }
    processGetLocaleSaleTaxRates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update sale tax rates
     * @param body (optional)
     * @return OK
     */
    updateSaleTaxRates(body) {
        let url_ = this.baseUrl + "/sales-tax";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateSaleTaxRates(_response);
        });
    }
    processUpdateSaleTaxRates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    sendGridWebHook(body) {
        let url_ = this.baseUrl + "/SendGrid/SendGridWebHook";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendGridWebHook(_response);
        });
    }
    processSendGridWebHook(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    sendGridInbound(body) {
        let url_ = this.baseUrl + "/SendGrid/SendGridInbound";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendGridInbound(_response);
        });
    }
    processSendGridInbound(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a StaffMember from the company database
     * @return OK
     */
    staffMembersGETGET(employeeId) {
        let url_ = this.baseUrl + "/staff-members/personal-details/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersGETGET(_response);
        });
    }
    processStaffMembersGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a StaffMember's personal details in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT(employeeId, body) {
        let url_ = this.baseUrl + "/staff-members/personal-details/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT(_response);
        });
    }
    processStaffMembersPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a StaffMemberRemunerationHistory record in the database
     * @param body (optional)
     * @return OK
     */
    staffMemberRemunerationHistoryPUTPUT(id, body) {
        let url_ = this.baseUrl + "/StaffMemberRemunerationHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMemberRemunerationHistoryPUTPUT(_response);
        });
    }
    processStaffMemberRemunerationHistoryPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a StaffMemberRemunerationHistory record from the database
     * @return OK
     */
    staffMemberRemunerationHistoryDELETEDELETE(id) {
        let url_ = this.baseUrl + "/StaffMemberRemunerationHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMemberRemunerationHistoryDELETEDELETE(_response);
        });
    }
    processStaffMemberRemunerationHistoryDELETEDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a StaffMemberRemunerationHistory record in the database
     * @param body (optional)
     * @return OK
     */
    staffMemberRemunerationHistoryPUTPUT2(id, body) {
        let url_ = this.baseUrl + "/staff-member-remuneration-history/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMemberRemunerationHistoryPUTPUT2(_response);
        });
    }
    processStaffMemberRemunerationHistoryPUTPUT2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a StaffMemberRemunerationHistory record from the database
     * @return OK
     */
    staffMemberRemunerationHistoryDELETEDELETE2(id) {
        let url_ = this.baseUrl + "/staff-member-remuneration-history/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMemberRemunerationHistoryDELETEDELETE2(_response);
        });
    }
    processStaffMemberRemunerationHistoryDELETEDELETE2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all StaffMembers from the company database
     * @param time (optional)
     * @param includeDeleted (optional)
     * @return OK
     */
    staffMembersGETGET2(time, includeDeleted) {
        let url_ = this.baseUrl + "/StaffMembers?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent(time ? "" + time.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersGETGET2(_response);
        });
    }
    processStaffMembersGETGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a StaffMember in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPOSTPOST(body) {
        let url_ = this.baseUrl + "/StaffMembers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST(_response);
        });
    }
    processStaffMembersPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Patch a staff member in the company database
     * @param id (optional)
     * @param body (optional)
     * @return OK
     * @deprecated
     */
    staffMembersPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/StaffMembers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPATCHPATCH(_response);
        });
    }
    processStaffMembersPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all StaffMembers from the company database
     * @param time (optional)
     * @param includeDeleted (optional)
     * @return OK
     */
    staffMembersGETGET3(time, includeDeleted) {
        let url_ = this.baseUrl + "/staff-members?";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent(time ? "" + time.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersGETGET3(_response);
        });
    }
    processStaffMembersGETGET3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a StaffMember in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPOSTPOST2(body) {
        let url_ = this.baseUrl + "/staff-members";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST2(_response);
        });
    }
    processStaffMembersPOSTPOST2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Patch a staff member in the company database
     * @param id (optional)
     * @param body (optional)
     * @return OK
     * @deprecated
     */
    staffMembersPATCHPATCH2(id, body) {
        let url_ = this.baseUrl + "/staff-members?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPATCHPATCH2(_response);
        });
    }
    processStaffMembersPATCHPATCH2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a StaffMember from the company database
     * @return OK
     */
    staffMembersGETGET4(id) {
        let url_ = this.baseUrl + "/StaffMembers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersGETGET4(_response);
        });
    }
    processStaffMembersGETGET4(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a StaffMember in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT2(id, body) {
        let url_ = this.baseUrl + "/StaffMembers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT2(_response);
        });
    }
    processStaffMembersPUTPUT2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a StaffMember from the company database
     * @return OK
     */
    staffMembersGETGET5(id) {
        let url_ = this.baseUrl + "/staff-members/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersGETGET5(_response);
        });
    }
    processStaffMembersGETGET5(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a StaffMember in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT3(id, body) {
        let url_ = this.baseUrl + "/staff-members/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT3(_response);
        });
    }
    processStaffMembersPUTPUT3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Send a StaffMember onboarding request
     * @return OK
     */
    staffMembersPOSTPOST3(id) {
        let url_ = this.baseUrl + "/StaffMembers/{id}/onboarding-request";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST3(_response);
        });
    }
    processStaffMembersPOSTPOST3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Send a StaffMember onboarding request
     * @return OK
     */
    staffMembersPOSTPOST4(id) {
        let url_ = this.baseUrl + "/staff-members/{id}/onboarding-request";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST4(_response);
        });
    }
    processStaffMembersPOSTPOST4(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update StaffMembers emails in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT4(body) {
        let url_ = this.baseUrl + "/StaffMembers/update-emails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT4(_response);
        });
    }
    processStaffMembersPUTPUT4(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update StaffMembers emails in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT5(body) {
        let url_ = this.baseUrl + "/staff-members/update-emails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT5(_response);
        });
    }
    processStaffMembersPUTPUT5(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Export Staff Members to a defined format
     * @param format (optional)
     * @param body (optional)
     * @return OK
     * @deprecated
     */
    staffMembersPOSTPOST5(format, body) {
        let url_ = this.baseUrl + "/StaffMembers/export?";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST5(_response);
        });
    }
    processStaffMembersPOSTPOST5(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Export Staff Members to a defined format
     * @param format (optional)
     * @param body (optional)
     * @return OK
     * @deprecated
     */
    staffMembersPOSTPOST6(format, body) {
        let url_ = this.baseUrl + "/staff-members/export?";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST6(_response);
        });
    }
    processStaffMembersPOSTPOST6(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a Remuneration snapshot entry in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPOSTPOST7(body) {
        let url_ = this.baseUrl + "/staff-members/remuneration";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPOSTPOST7(_response);
        });
    }
    processStaffMembersPOSTPOST7(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a Remuneration snapshot entry in the company database
     * @param body (optional)
     * @return OK
     */
    staffMembersPUTPUT6(id, body) {
        let url_ = this.baseUrl + "/staff-members/remuneration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffMembersPUTPUT6(_response);
        });
    }
    processStaffMembersPUTPUT6(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getStaffRolesById(id) {
        let url_ = this.baseUrl + "/staff-roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetStaffRolesById(_response);
        });
    }
    processGetStaffRolesById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update an existing Staff Role in the company database
     * @param body (optional)
     * @return OK
     */
    staffRolesPUTPUT(id, body) {
        let url_ = this.baseUrl + "/staff-roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffRolesPUTPUT(_response);
        });
    }
    processStaffRolesPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all StaffRoles from the company database
     * @param includeDeleted (optional)
     * @return OK
     */
    staffRolesAllAll(includeDeleted) {
        let url_ = this.baseUrl + "/staff-roles?";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffRolesAllAll(_response);
        });
    }
    processStaffRolesAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(StaffRoleResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new staff role in the database
     * @param body (optional)
     * @return OK
     */
    staffRolesPOSTPOST(body) {
        let url_ = this.baseUrl + "/staff-roles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStaffRolesPOSTPOST(_response);
        });
    }
    processStaffRolesPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param active (optional)
     * @return OK
     */
    stockBrandsAllAll(active) {
        let url_ = this.baseUrl + "/StockBrands?";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockBrandsAllAll(_response);
        });
    }
    processStockBrandsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BrandModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockBrandsPOSTPOST(body) {
        let url_ = this.baseUrl + "/StockBrands";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockBrandsPOSTPOST(_response);
        });
    }
    processStockBrandsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param active (optional)
     * @return OK
     */
    brandsAllAll(active) {
        let url_ = this.baseUrl + "/stock/brands?";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBrandsAllAll(_response);
        });
    }
    processBrandsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BrandModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    brandsPOSTPOST(body) {
        let url_ = this.baseUrl + "/stock/brands";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBrandsPOSTPOST(_response);
        });
    }
    processBrandsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockBrandsGETGET(id) {
        let url_ = this.baseUrl + "/StockBrands/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockBrandsGETGET(_response);
        });
    }
    processStockBrandsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BrandModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    brandsGETGET(id) {
        let url_ = this.baseUrl + "/stock/brands/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBrandsGETGET(_response);
        });
    }
    processBrandsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BrandModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockDeliveryDetailsGETGET() {
        let url_ = this.baseUrl + "/StockDeliveryDetails";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockDeliveryDetailsGETGET(_response);
        });
    }
    processStockDeliveryDetailsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeliveryDetailsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    deliverydetailsGETGET() {
        let url_ = this.baseUrl + "/stock/deliverydetails";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeliverydetailsGETGET(_response);
        });
    }
    processDeliverydetailsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeliveryDetailsModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockDeliveryDetailsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/StockDeliveryDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockDeliveryDetailsPUTPUT(_response);
        });
    }
    processStockDeliveryDetailsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    deliverydetailsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/stock/deliverydetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeliverydetailsPUTPUT(_response);
        });
    }
    processDeliverydetailsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param dateFor (optional)
     * @return OK
     */
    stockItemCost(id, dateFor) {
        let url_ = this.baseUrl + "/StockItemCost/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dateFor === null)
            throw new Error("The parameter 'dateFor' cannot be null.");
        else if (dateFor !== undefined)
            url_ += "dateFor=" + encodeURIComponent(dateFor ? "" + dateFor.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemCost(_response);
        });
    }
    processStockItemCost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStockItemCostResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param dateFor (optional)
     * @return OK
     */
    cost(id, dateFor) {
        let url_ = this.baseUrl + "/stock/items/cost/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dateFor === null)
            throw new Error("The parameter 'dateFor' cannot be null.");
        else if (dateFor !== undefined)
            url_ += "dateFor=" + encodeURIComponent(dateFor ? "" + dateFor.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCost(_response);
        });
    }
    processCost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStockItemCostResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockItemGroups() {
        let url_ = this.baseUrl + "/StockItemGroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemGroups(_response);
        });
    }
    processStockItemGroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStockItemGroupsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemgroups() {
        let url_ = this.baseUrl + "/stock/itemgroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemgroups(_response);
        });
    }
    processItemgroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStockItemGroupsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockItemsAllAll() {
        let url_ = this.baseUrl + "/StockItems";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemsAllAll(_response);
        });
    }
    processStockItemsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStockItemSummariesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockItemsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/StockItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemsPUTPUT(_response);
        });
    }
    processStockItemsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockItemsPOSTPOST(body) {
        let url_ = this.baseUrl + "/StockItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemsPOSTPOST(_response);
        });
    }
    processStockItemsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockItemsPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/StockItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemsPATCHPATCH(_response);
        });
    }
    processStockItemsPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemsAllAll() {
        let url_ = this.baseUrl + "/stock/items";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsAllAll(_response);
        });
    }
    processItemsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetStockItemSummariesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    itemsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/stock/items?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsPUTPUT(_response);
        });
    }
    processItemsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    itemsPOSTPOST(body) {
        let url_ = this.baseUrl + "/stock/items";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsPOSTPOST(_response);
        });
    }
    processItemsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    itemsPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/stock/items?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsPATCHPATCH(_response);
        });
    }
    processItemsPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockItemsGETGET(id) {
        let url_ = this.baseUrl + "/StockItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemsGETGET(_response);
        });
    }
    processStockItemsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ItemModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemsGETGET(id) {
        let url_ = this.baseUrl + "/stock/items/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsGETGET(_response);
        });
    }
    processItemsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ItemModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param masterId (optional)
     * @return OK
     */
    createFromMaster(masterId) {
        let url_ = this.baseUrl + "/StockItems/CreateFromMaster?";
        if (masterId === null)
            throw new Error("The parameter 'masterId' cannot be null.");
        else if (masterId !== undefined)
            url_ += "masterId=" + encodeURIComponent("" + masterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateFromMaster(_response);
        });
    }
    processCreateFromMaster(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param masterId (optional)
     * @return OK
     */
    createFromMaster2(masterId) {
        let url_ = this.baseUrl + "/stock/items/CreateFromMaster?";
        if (masterId === null)
            throw new Error("The parameter 'masterId' cannot be null.");
        else if (masterId !== undefined)
            url_ += "masterId=" + encodeURIComponent("" + masterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateFromMaster2(_response);
        });
    }
    processCreateFromMaster2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param masterId (optional)
     * @return OK
     */
    createfrommaster(masterId) {
        let url_ = this.baseUrl + "/StockItems/createfrommaster?";
        if (masterId === null)
            throw new Error("The parameter 'masterId' cannot be null.");
        else if (masterId !== undefined)
            url_ += "masterId=" + encodeURIComponent("" + masterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreatefrommaster(_response);
        });
    }
    processCreatefrommaster(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param masterId (optional)
     * @return OK
     */
    createfrommaster2(masterId) {
        let url_ = this.baseUrl + "/stock/items/createfrommaster?";
        if (masterId === null)
            throw new Error("The parameter 'masterId' cannot be null.");
        else if (masterId !== undefined)
            url_ += "masterId=" + encodeURIComponent("" + masterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreatefrommaster2(_response);
        });
    }
    processCreatefrommaster2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockItemSuperGroupsAllAll() {
        let url_ = this.baseUrl + "/StockItemSuperGroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemSuperGroupsAllAll(_response);
        });
    }
    processStockItemSuperGroupsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemSuperGroupsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockItemSuperGroups(id, body) {
        let url_ = this.baseUrl + "/StockItemSuperGroups?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemSuperGroups(_response);
        });
    }
    processStockItemSuperGroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemsupergroupsAllAll() {
        let url_ = this.baseUrl + "/stock/itemsupergroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsupergroupsAllAll(_response);
        });
    }
    processItemsupergroupsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetItemSuperGroupsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    itemsupergroups(id, body) {
        let url_ = this.baseUrl + "/stock/itemsupergroups?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsupergroups(_response);
        });
    }
    processItemsupergroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockItemSuppliersAllAll() {
        let url_ = this.baseUrl + "/StockItemSuppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemSuppliersAllAll(_response);
        });
    }
    processStockItemSuppliersAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ItemSupplierModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockItemSuppliers(body) {
        let url_ = this.baseUrl + "/StockItemSuppliers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockItemSuppliers(_response);
        });
    }
    processStockItemSuppliers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemsuppliersAllAll() {
        let url_ = this.baseUrl + "/stock/itemsuppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsuppliersAllAll(_response);
        });
    }
    processItemsuppliersAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ItemSupplierModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    itemsuppliers(body) {
        let url_ = this.baseUrl + "/stock/itemsuppliers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsuppliers(_response);
        });
    }
    processItemsuppliers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockMasterItemGroups() {
        let url_ = this.baseUrl + "/StockMasterItemGroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockMasterItemGroups(_response);
        });
    }
    processStockMasterItemGroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ItemGroupModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemgroups2() {
        let url_ = this.baseUrl + "/stock/master/itemgroups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemgroups2(_response);
        });
    }
    processItemgroups2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ItemGroupModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockMasterItems() {
        let url_ = this.baseUrl + "/StockMasterItems";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockMasterItems(_response);
        });
    }
    processStockMasterItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetMasterItemsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    itemsAllAll2() {
        let url_ = this.baseUrl + "/stock/master/items";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processItemsAllAll2(_response);
        });
    }
    processItemsAllAll2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetMasterItemsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param searchStr (optional)
     * @param supplierId (optional)
     * @param limit (optional)
     * @return OK
     */
    stockMasterSupplierItems(searchStr, supplierId, limit) {
        let url_ = this.baseUrl + "/StockMasterSupplierItems?";
        if (searchStr === null)
            throw new Error("The parameter 'searchStr' cannot be null.");
        else if (searchStr !== undefined)
            url_ += "searchStr=" + encodeURIComponent("" + searchStr) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockMasterSupplierItems(_response);
        });
    }
    processStockMasterSupplierItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param searchStr (optional)
     * @param supplierId (optional)
     * @param limit (optional)
     * @return OK
     */
    supplieritems(searchStr, supplierId, limit) {
        let url_ = this.baseUrl + "/stock/master/supplieritems?";
        if (searchStr === null)
            throw new Error("The parameter 'searchStr' cannot be null.");
        else if (searchStr !== undefined)
            url_ += "searchStr=" + encodeURIComponent("" + searchStr) + "&";
        if (supplierId === null)
            throw new Error("The parameter 'supplierId' cannot be null.");
        else if (supplierId !== undefined)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSupplieritems(_response);
        });
    }
    processSupplieritems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockMasterSuppliers() {
        let url_ = this.baseUrl + "/StockMasterSuppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockMasterSuppliers(_response);
        });
    }
    processStockMasterSuppliers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSuppliersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    suppliersAllAll() {
        let url_ = this.baseUrl + "/stock/master/suppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersAllAll(_response);
        });
    }
    processSuppliersAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSuppliersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockSuppliersAllAll() {
        let url_ = this.baseUrl + "/StockSuppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockSuppliersAllAll(_response);
        });
    }
    processStockSuppliersAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSuppliersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockSuppliersPUTPUT(id, body) {
        let url_ = this.baseUrl + "/StockSuppliers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockSuppliersPUTPUT(_response);
        });
    }
    processStockSuppliersPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockSuppliersPOSTPOST(body) {
        let url_ = this.baseUrl + "/StockSuppliers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockSuppliersPOSTPOST(_response);
        });
    }
    processStockSuppliersPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockSuppliersPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/StockSuppliers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockSuppliersPATCHPATCH(_response);
        });
    }
    processStockSuppliersPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    suppliersAllAll2() {
        let url_ = this.baseUrl + "/stock/suppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersAllAll2(_response);
        });
    }
    processSuppliersAllAll2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSuppliersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    suppliersPUTPUT(id, body) {
        let url_ = this.baseUrl + "/stock/suppliers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersPUTPUT(_response);
        });
    }
    processSuppliersPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    suppliersPOSTPOST(body) {
        let url_ = this.baseUrl + "/stock/suppliers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersPOSTPOST(_response);
        });
    }
    processSuppliersPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    suppliersPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/stock/suppliers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersPATCHPATCH(_response);
        });
    }
    processSuppliersPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockSuppliersGETGET(id) {
        let url_ = this.baseUrl + "/StockSuppliers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockSuppliersGETGET(_response);
        });
    }
    processStockSuppliersGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    suppliersGETGET(id) {
        let url_ = this.baseUrl + "/stock/suppliers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuppliersGETGET(_response);
        });
    }
    processSuppliersGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param sourceId (optional)
     * @param destId (optional)
     * @return OK
     */
    merge(sourceId, destId) {
        let url_ = this.baseUrl + "/StockSuppliers/Merge?";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (destId === null)
            throw new Error("The parameter 'destId' cannot be null.");
        else if (destId !== undefined)
            url_ += "destId=" + encodeURIComponent("" + destId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processMerge(_response);
        });
    }
    processMerge(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param sourceId (optional)
     * @param destId (optional)
     * @return OK
     */
    merge2(sourceId, destId) {
        let url_ = this.baseUrl + "/stock/suppliers/Merge?";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (destId === null)
            throw new Error("The parameter 'destId' cannot be null.");
        else if (destId !== undefined)
            url_ += "destId=" + encodeURIComponent("" + destId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processMerge2(_response);
        });
    }
    processMerge2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param startStocktake (optional)
     * @param endStocktake (optional)
     * @return OK
     */
    generate(startStocktake, endStocktake) {
        let url_ = this.baseUrl + "/stock/stocktakereport/generate?";
        if (startStocktake === null)
            throw new Error("The parameter 'startStocktake' cannot be null.");
        else if (startStocktake !== undefined)
            url_ += "startStocktake=" + encodeURIComponent("" + startStocktake) + "&";
        if (endStocktake === null)
            throw new Error("The parameter 'endStocktake' cannot be null.");
        else if (endStocktake !== undefined)
            url_ += "endStocktake=" + encodeURIComponent("" + endStocktake) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGenerate(_response);
        });
    }
    processGenerate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param itemId (optional)
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    calculatedusage(itemId, startTime, endTime) {
        let url_ = this.baseUrl + "/stock/stocktakereport/calculatedusage?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCalculatedusage(_response);
        });
    }
    processCalculatedusage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    stockUnitsAllAll() {
        let url_ = this.baseUrl + "/StockUnits";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockUnitsAllAll(_response);
        });
    }
    processStockUnitsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UnitModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    stockUnitsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/StockUnits?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockUnitsPUTPUT(_response);
        });
    }
    processStockUnitsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    stockUnitsPOSTPOST(body) {
        let url_ = this.baseUrl + "/StockUnits";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processStockUnitsPOSTPOST(_response);
        });
    }
    processStockUnitsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    unitsAllAll() {
        let url_ = this.baseUrl + "/stock/units";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUnitsAllAll(_response);
        });
    }
    processUnitsAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UnitModel.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param body (optional)
     * @return OK
     */
    unitsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/stock/units?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUnitsPUTPUT(_response);
        });
    }
    processUnitsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    unitsPOSTPOST(body) {
        let url_ = this.baseUrl + "/stock/units";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUnitsPOSTPOST(_response);
        });
    }
    processUnitsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param startTime (optional)
     * @param endTime (optional)
     * @param interval (optional)
     * @return OK
     */
    summary(startTime, endTime, interval) {
        let url_ = this.baseUrl + "/time/clockins/summary?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSummary(_response);
        });
    }
    processSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param startTime (optional)
     * @param endTime (optional)
     * @param groupBy (optional)
     * @return OK
     */
    groupBy(startTime, endTime, groupBy) {
        let url_ = this.baseUrl + "/time/clockins/summary/group-by?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (groupBy === null)
            throw new Error("The parameter 'groupBy' cannot be null.");
        else if (groupBy !== undefined)
            url_ += "groupBy=" + encodeURIComponent("" + groupBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGroupBy(_response);
        });
    }
    processGroupBy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all payroll super funds stored in the Auth DB
     * @return OK
     */
    superFunds() {
        let url_ = this.baseUrl + "/payroll/super-funds";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuperFunds(_response);
        });
    }
    processSuperFunds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets Surcharges grouped by surcharge type
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posSurcharges(start, end) {
        let url_ = this.baseUrl + "/pos/surcharges?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosSurcharges(_response);
        });
    }
    processPosSurcharges(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSurchargesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get tender surcharge information for the report period, grouped by day and surcharge type
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posTenderSurcharges(start, end) {
        let url_ = this.baseUrl + "/pos/tenders/surcharges?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosTenderSurcharges(_response);
        });
    }
    processPosTenderSurcharges(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTenderSurchargesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get surcharge information for the report period and specified staff member, grouped by surcharge type
     * @param start (optional)
     * @param end (optional)
     * @param posIdentifier (optional)
     * @return OK
     */
    posStaffSurcharges(start, end, posIdentifier) {
        let url_ = this.baseUrl + "/pos/staff/surcharges?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' cannot be null.");
        else if (posIdentifier !== undefined)
            url_ += "posIdentifier=" + encodeURIComponent("" + posIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosStaffSurcharges(_response);
        });
    }
    processPosStaffSurcharges(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PosStaffSurchargesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get tender information for the report period, grouped by day and tender type
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posTenders(start, end) {
        let url_ = this.baseUrl + "/pos/tenders?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosTenders(_response);
        });
    }
    processPosTenders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTendersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    tenders(start, end, interval, posIdentifier) {
        let url_ = this.baseUrl + "/pos/tenders/{posIdentifier}?";
        if (posIdentifier === undefined || posIdentifier === null)
            throw new Error("The parameter 'posIdentifier' must be defined.");
        url_ = url_.replace("{posIdentifier}", encodeURIComponent("" + posIdentifier));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTenders(_response);
        });
    }
    processTenders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTendersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Test
     * @return OK
     */
    test() {
        let url_ = this.baseUrl + "/test";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTest(_response);
        });
    }
    processTest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    featureflags() {
        let url_ = this.baseUrl + "/test/featureflags";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processFeatureflags(_response);
        });
    }
    processFeatureflags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    beta() {
        let url_ = this.baseUrl + "/test/beta";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBeta(_response);
        });
    }
    processBeta(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    token() {
        let url_ = this.baseUrl + "/test/token";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processToken(_response);
        });
    }
    processToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    redeem() {
        let url_ = this.baseUrl + "/test/token/redeem";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRedeem(_response);
        });
    }
    processRedeem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    singleEmployeeToken() {
        let url_ = this.baseUrl + "/test/single-employee-token";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSingleEmployeeToken(_response);
        });
    }
    processSingleEmployeeToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    validate(employeeId) {
        let url_ = this.baseUrl + "/test/single-employee/validate/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processValidate(_response);
        });
    }
    processValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    validate2() {
        let url_ = this.baseUrl + "/test/single-company/validate";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processValidate2(_response);
        });
    }
    processValidate2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all payroll super funds from an external third party company
     * @return OK
     */
    superFunds2() {
        let url_ = this.baseUrl + "/payroll/third-party-super-funds";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSuperFunds2(_response);
        });
    }
    processSuperFunds2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all clockins for the period specified
     * @param startTime (optional)
     * @param endTime (optional)
     * @param includeInactive (optional)
     * @param includeLiveCalculation (optional)
     * @return OK
     */
    getClockins(startTime, endTime, includeInactive, includeLiveCalculation) {
        let url_ = this.baseUrl + "/time-clockins?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeLiveCalculation === null)
            throw new Error("The parameter 'includeLiveCalculation' cannot be null.");
        else if (includeLiveCalculation !== undefined)
            url_ += "includeLiveCalculation=" + encodeURIComponent("" + includeLiveCalculation) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockins(_response);
        });
    }
    processGetClockins(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add a new clockin
     * @param body (optional)
     * @return OK
     */
    addClockin(body) {
        let url_ = this.baseUrl + "/time-clockins";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddClockin(_response);
        });
    }
    processAddClockin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets all clockins for the period specified
     * @param startTime (optional)
     * @param endTime (optional)
     * @param includeInactive (optional)
     * @param includeLiveCalculation (optional)
     * @return OK
     */
    getClockins2(startTime, endTime, includeInactive, includeLiveCalculation) {
        let url_ = this.baseUrl + "/TimeClockins?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeLiveCalculation === null)
            throw new Error("The parameter 'includeLiveCalculation' cannot be null.");
        else if (includeLiveCalculation !== undefined)
            url_ += "includeLiveCalculation=" + encodeURIComponent("" + includeLiveCalculation) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockins2(_response);
        });
    }
    processGetClockins2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add a new clockin
     * @param body (optional)
     * @return OK
     */
    addClockin2(body) {
        let url_ = this.baseUrl + "/TimeClockins";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddClockin2(_response);
        });
    }
    processAddClockin2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a specific clockin by id
     * @return OK
     */
    getClockin(id) {
        let url_ = this.baseUrl + "/time-clockins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockin(_response);
        });
    }
    processGetClockin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a specific clockin by id
     * @param body (optional)
     * @return OK
     */
    updateClockin(id, body) {
        let url_ = this.baseUrl + "/time-clockins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateClockin(_response);
        });
    }
    processUpdateClockin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a specific clockin by id
     * @return OK
     */
    getClockin2(id) {
        let url_ = this.baseUrl + "/TimeClockins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockin2(_response);
        });
    }
    processGetClockin2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a specific clockin by id
     * @param body (optional)
     * @return OK
     */
    updateClockin2(id, body) {
        let url_ = this.baseUrl + "/TimeClockins/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateClockin2(_response);
        });
    }
    processUpdateClockin2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a list of clockins for a given staff member between two dates
     * @param staffMemberId (optional)
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    getStaffMemberClockins(staffMemberId, startTime, endTime) {
        let url_ = this.baseUrl + "/time-clockins/staffMemberClocks?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetStaffMemberClockins(_response);
        });
    }
    processGetStaffMemberClockins(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a list of clockins for a given staff member between two dates
     * @param staffMemberId (optional)
     * @param startTime (optional)
     * @param endTime (optional)
     * @return OK
     */
    getStaffMemberClockins2(staffMemberId, startTime, endTime) {
        let url_ = this.baseUrl + "/TimeClockins/staffMemberClocks?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetStaffMemberClockins2(_response);
        });
    }
    processGetStaffMemberClockins2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the last Loaded clockin for a staff member
     * @return OK
     */
    lastLoadedClockByStaffMemberId(staffMemberId) {
        let url_ = this.baseUrl + "/time-clockins/staff-members/{staffMemberId}/last-loaded-shift";
        if (staffMemberId === undefined || staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' must be defined.");
        url_ = url_.replace("{staffMemberId}", encodeURIComponent("" + staffMemberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLastLoadedClockByStaffMemberId(_response);
        });
    }
    processLastLoadedClockByStaffMemberId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the last Loaded clockin for a staff member
     * @return OK
     */
    lastLoadedClockByStaffMemberId2(staffMemberId) {
        let url_ = this.baseUrl + "/TimeClockins/staff-members/{staffMemberId}/last-loaded-shift";
        if (staffMemberId === undefined || staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' must be defined.");
        url_ = url_.replace("{staffMemberId}", encodeURIComponent("" + staffMemberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLastLoadedClockByStaffMemberId2(_response);
        });
    }
    processLastLoadedClockByStaffMemberId2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Generate an export file for a specified payroll system
     * @param startTime (optional)
     * @param endTime (optional)
     * @param format (optional)
     * @return OK
     */
    getClockinsExportFile(startTime, endTime, format) {
        let url_ = this.baseUrl + "/time-clockins/export?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockinsExportFile(_response);
        });
    }
    processGetClockinsExportFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Generate an export file for a specified payroll system
     * @param startTime (optional)
     * @param endTime (optional)
     * @param format (optional)
     * @return OK
     */
    getClockinsExportFile2(startTime, endTime, format) {
        let url_ = this.baseUrl + "/TimeClockins/export?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetClockinsExportFile2(_response);
        });
    }
    processGetClockinsExportFile2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    timePayrollAdjustmentsGETGET() {
        let url_ = this.baseUrl + "/time-payroll-adjustments";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollAdjustmentsGETGET(_response);
        });
    }
    processTimePayrollAdjustmentsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollAdjustmentsPOSTPOST(body) {
        let url_ = this.baseUrl + "/time-payroll-adjustments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollAdjustmentsPOSTPOST(_response);
        });
    }
    processTimePayrollAdjustmentsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollAdjustmentsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/time-payroll-adjustments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollAdjustmentsPUTPUT(_response);
        });
    }
    processTimePayrollAdjustmentsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param staffId (optional)
     * @param date (optional)
     * @return OK
     */
    timePayrollAverageDailyPay(staffId, date) {
        let url_ = this.baseUrl + "/TimePayrollAverageDailyPay?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollAverageDailyPay(_response);
        });
    }
    processTimePayrollAverageDailyPay(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param staffMemberId (optional)
     * @param datestampStart (optional)
     * @param datestampEnd (optional)
     * @return OK
     */
    timePayrollPayrunLines(staffMemberId, datestampStart, datestampEnd) {
        let url_ = this.baseUrl + "/TimePayrollPayrunLines?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        if (datestampStart === null)
            throw new Error("The parameter 'datestampStart' cannot be null.");
        else if (datestampStart !== undefined)
            url_ += "datestampStart=" + encodeURIComponent(datestampStart ? "" + datestampStart.toISOString() : "") + "&";
        if (datestampEnd === null)
            throw new Error("The parameter 'datestampEnd' cannot be null.");
        else if (datestampEnd !== undefined)
            url_ += "datestampEnd=" + encodeURIComponent(datestampEnd ? "" + datestampEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunLines(_response);
        });
    }
    processTimePayrollPayrunLines(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    timePayrollPayrunsGETGET() {
        let url_ = this.baseUrl + "/TimePayrollPayruns";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunsGETGET(_response);
        });
    }
    processTimePayrollPayrunsGETGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollPayrunsPOSTPOST(body) {
        let url_ = this.baseUrl + "/TimePayrollPayruns";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunsPOSTPOST(_response);
        });
    }
    processTimePayrollPayrunsPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    timePayrollPayrunsGETGET2(id) {
        let url_ = this.baseUrl + "/TimePayrollPayruns/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunsGETGET2(_response);
        });
    }
    processTimePayrollPayrunsGETGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollPayrunsPUTPUT(id, body) {
        let url_ = this.baseUrl + "/TimePayrollPayruns/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunsPUTPUT(_response);
        });
    }
    processTimePayrollPayrunsPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollPayrunsPATCHPATCH(id, body) {
        let url_ = this.baseUrl + "/TimePayrollPayruns/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPayrunsPATCHPATCH(_response);
        });
    }
    processTimePayrollPayrunsPATCHPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param id (optional)
     * @param includeStaff (optional)
     * @param format (optional)
     * @return OK
     */
    export(id, includeStaff, format) {
        let url_ = this.baseUrl + "/TimePayrollPayruns/export?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (includeStaff === null)
            throw new Error("The parameter 'includeStaff' cannot be null.");
        else if (includeStaff !== undefined)
            url_ += "includeStaff=" + encodeURIComponent("" + includeStaff) + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processExport(_response);
        });
    }
    processExport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param datestampStart (optional)
     * @param datestampEnd (optional)
     * @param datestampPayment (optional)
     * @param frequency (optional)
     * @return OK
     */
    new(datestampStart, datestampEnd, datestampPayment, frequency) {
        let url_ = this.baseUrl + "/TimePayrollPayruns/new?";
        if (datestampStart === null)
            throw new Error("The parameter 'datestampStart' cannot be null.");
        else if (datestampStart !== undefined)
            url_ += "datestampStart=" + encodeURIComponent(datestampStart ? "" + datestampStart.toISOString() : "") + "&";
        if (datestampEnd === null)
            throw new Error("The parameter 'datestampEnd' cannot be null.");
        else if (datestampEnd !== undefined)
            url_ += "datestampEnd=" + encodeURIComponent(datestampEnd ? "" + datestampEnd.toISOString() : "") + "&";
        if (datestampPayment === null)
            throw new Error("The parameter 'datestampPayment' cannot be null.");
        else if (datestampPayment !== undefined)
            url_ += "datestampPayment=" + encodeURIComponent(datestampPayment ? "" + datestampPayment.toISOString() : "") + "&";
        if (frequency === null)
            throw new Error("The parameter 'frequency' cannot be null.");
        else if (frequency !== undefined)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processNew(_response);
        });
    }
    processNew(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param module (optional)
     * @return OK
     */
    timePayrollPaytypesAllAll(module) {
        let url_ = this.baseUrl + "/TimePayrollPaytypes?";
        if (module === null)
            throw new Error("The parameter 'module' cannot be null.");
        else if (module !== undefined)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPaytypesAllAll(_response);
        });
    }
    processTimePayrollPaytypesAllAll(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PaytypeResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollPaytypesPOSTPOST(body) {
        let url_ = this.baseUrl + "/TimePayrollPaytypes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPaytypesPOSTPOST(_response);
        });
    }
    processTimePayrollPaytypesPOSTPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    timePayrollPaytypesPUTPUT(id, body) {
        let url_ = this.baseUrl + "/TimePayrollPaytypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTimePayrollPaytypesPUTPUT(_response);
        });
    }
    processTimePayrollPaytypesPUTPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets summarized POS tips grouped by interval
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posTips(start, end) {
        let url_ = this.baseUrl + "/pos/tips?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosTips(_response);
        });
    }
    processPosTips(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTipsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of sales headers for the report period
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posSalesTransactions(start, end) {
        let url_ = this.baseUrl + "/pos/sales/transactions?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosSalesTransactions(_response);
        });
    }
    processPosSalesTransactions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSalesTransactionHeadersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of sales headers for the report period
     * @return OK
     */
    posSalesTransactions_Lines(id) {
        let url_ = this.baseUrl + "/pos/sales/transactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosSalesTransactions_Lines(_response);
        });
    }
    processPosSalesTransactions_Lines(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSalesTransactionLinesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of order headers for the report periode
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    posOrderTransactions(start, end) {
        let url_ = this.baseUrl + "/pos/orders/transactions?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosOrderTransactions(_response);
        });
    }
    processPosOrderTransactions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTransactionHeadersResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of order lines for the specified order header
     * @return OK
     */
    posOrderTransactions_Lines(id) {
        let url_ = this.baseUrl + "/pos/orders/transactions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPosOrderTransactions_Lines(_response);
        });
    }
    processPosOrderTransactions_Lines(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTransactionLinesResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a full list of unavailability records from the company db filtered by optional params
     * @param staffMemberId (optional) The staff member id to filter by
     * @param type (optional) The type of unavailability record to filter by
     * @return OK
     */
    getUnavailability(staffMemberId, type) {
        let url_ = this.baseUrl + "/time/unavailability?";
        if (staffMemberId === null)
            throw new Error("The parameter 'staffMemberId' cannot be null.");
        else if (staffMemberId !== undefined)
            url_ += "staffMemberId=" + encodeURIComponent("" + staffMemberId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetUnavailability(_response);
        });
    }
    processGetUnavailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UnavailabilityRecord.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new unavailability record in the company db for a staff member
     * @param body (optional)
     * @return OK
     */
    addUnavailability(body) {
        let url_ = this.baseUrl + "/time/unavailability";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddUnavailability(_response);
        });
    }
    processAddUnavailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UnavailabilityRecord.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Send or resend an existing unavailability request
     * @param id Id of the unavailability request to send
     * @return OK
     */
    sendUnavailability(id) {
        let url_ = this.baseUrl + "/{id}/send";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSendUnavailability(_response);
        });
    }
    processSendUnavailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UnavailabilityRecord.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an existing unavailability record in the company db
     * @param body (optional)
     * @return OK
     */
    updateUnavailabilityStatus(id, body) {
        let url_ = this.baseUrl + "/time/unavailability/{id}status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateUnavailabilityStatus(_response);
        });
    }
    processUpdateUnavailabilityStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UnavailabilityRecord.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    loadedIdentityUser() {
        let url_ = this.baseUrl + "/LoadedIdentityUser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processLoadedIdentityUser(_response);
        });
    }
    processLoadedIdentityUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    userSession() {
        let url_ = this.baseUrl + "/user-session";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUserSession(_response);
        });
    }
    processUserSession(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    profile(body) {
        let url_ = this.baseUrl + "/LoadedIdentityUser/profile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProfile(_response);
        });
    }
    processProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    profile2(body) {
        let url_ = this.baseUrl + "/user-session/profile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProfile2(_response);
        });
    }
    processProfile2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    email(body) {
        let url_ = this.baseUrl + "/LoadedIdentityUser/email";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmail(_response);
        });
    }
    processEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    email2(body) {
        let url_ = this.baseUrl + "/user-session/email";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processEmail2(_response);
        });
    }
    processEmail2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    password(body) {
        let url_ = this.baseUrl + "/LoadedIdentityUser/password";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPassword(_response);
        });
    }
    processPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    password2(body) {
        let url_ = this.baseUrl + "/user-session/password";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPassword2(_response);
        });
    }
    processPassword2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get void information for the report period, grouped by report interval
     * @param start (optional)
     * @param end (optional)
     * @param interval (optional)
     * @return OK
     */
    pos_voids(start, end, interval) {
        let url_ = this.baseUrl + "/pos/voids?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (interval === null)
            throw new Error("The parameter 'interval' cannot be null.");
        else if (interval !== undefined)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPos_voids(_response);
        });
    }
    processPos_voids(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(IGetVoidsResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get void reason information for the report period
     * @param start (optional)
     * @param end (optional)
     * @return OK
     */
    pos_voidsByReason(start, end) {
        let url_ = this.baseUrl + "/pos/voids/by-reason?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPos_voidsByReason(_response);
        });
    }
    processPos_voidsByReason(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(IGetVoidsByReasonResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Xero connections
     * @return OK
     */
    xero_connections() {
        let url_ = this.baseUrl + "/connections/xero";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processXero_connections(_response);
        });
    }
    processXero_connections(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the current third party connection status
     * @param module (optional)
     * @return OK
     */
    connectionStatus(module) {
        let url_ = this.baseUrl + "/connections/xero/status?";
        if (module === null)
            throw new Error("The parameter 'module' cannot be null.");
        else if (module !== undefined)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processConnectionStatus(_response);
        });
    }
    processConnectionStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Authorises a third party connection with Loaded
     * @param body (optional)
     * @return OK
     */
    authorise(body) {
        let url_ = this.baseUrl + "/connections/xero/authorise";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAuthorise(_response);
        });
    }
    processAuthorise(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Attaches a third party company id to a current connection record
     * @param body (optional)
     * @return OK
     */
    attach(body) {
        let url_ = this.baseUrl + "/connections/xero/attach";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAttach(_response);
        });
    }
    processAttach(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Detaches a third party company id from a current connection record
     * @return OK
     */
    detach() {
        let url_ = this.baseUrl + "/connections/xero/detach";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDetach(_response);
        });
    }
    processDetach(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    zendesk(body) {
        let url_ = this.baseUrl + "/zendesk";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processZendesk(_response);
        });
    }
    processZendesk(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
exports.CoreApiClient = CoreApiClient;
class Action {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.loadedUserId = _data["loadedUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.at = _data["at"] ? dayjs(_data["at"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["loadedUserId"] = this.loadedUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["at"] = this.at ? this.at.toISOString() : undefined;
        return data;
    }
}
exports.Action = Action;
class ActivatedLeaveType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.activatedAt = _data["activatedAt"] ? dayjs(_data["activatedAt"].toString()) : undefined;
            this.conditions = _data["conditions"] ? LeaveTypeConditions.fromJS(_data["conditions"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivatedLeaveType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activatedAt"] = this.activatedAt ? this.activatedAt.toISOString() : undefined;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : undefined;
        return data;
    }
}
exports.ActivatedLeaveType = ActivatedLeaveType;
class ActivatedPackageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"] ? PackageRef.fromJS(_data["packageId"]) : undefined;
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : undefined;
            this.enabledAt = _data["enabledAt"] ? dayjs(_data["enabledAt"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivatedPackageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId ? this.packageId.toJSON() : undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["enabledAt"] = this.enabledAt ? this.enabledAt.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["type"] = this.type;
        return data;
    }
}
exports.ActivatedPackageDto = ActivatedPackageDto;
class AddCashupRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tillIdentifier = _data["tillIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddCashupRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tillIdentifier"] = this.tillIdentifier;
        return data;
    }
}
exports.AddCashupRequest = AddCashupRequest;
var AddressFamily;
(function (AddressFamily) {
    AddressFamily[AddressFamily["_0"] = 0] = "_0";
    AddressFamily[AddressFamily["_1"] = 1] = "_1";
    AddressFamily[AddressFamily["_2"] = 2] = "_2";
    AddressFamily[AddressFamily["_3"] = 3] = "_3";
    AddressFamily[AddressFamily["_4"] = 4] = "_4";
    AddressFamily[AddressFamily["_5"] = 5] = "_5";
    AddressFamily[AddressFamily["_6"] = 6] = "_6";
    AddressFamily[AddressFamily["_7"] = 7] = "_7";
    AddressFamily[AddressFamily["_8"] = 8] = "_8";
    AddressFamily[AddressFamily["_9"] = 9] = "_9";
    AddressFamily[AddressFamily["_10"] = 10] = "_10";
    AddressFamily[AddressFamily["_11"] = 11] = "_11";
    AddressFamily[AddressFamily["_12"] = 12] = "_12";
    AddressFamily[AddressFamily["_13"] = 13] = "_13";
    AddressFamily[AddressFamily["_14"] = 14] = "_14";
    AddressFamily[AddressFamily["_15"] = 15] = "_15";
    AddressFamily[AddressFamily["_16"] = 16] = "_16";
    AddressFamily[AddressFamily["_17"] = 17] = "_17";
    AddressFamily[AddressFamily["_18"] = 18] = "_18";
    AddressFamily[AddressFamily["_19"] = 19] = "_19";
    AddressFamily[AddressFamily["_21"] = 21] = "_21";
    AddressFamily[AddressFamily["_22"] = 22] = "_22";
    AddressFamily[AddressFamily["_23"] = 23] = "_23";
    AddressFamily[AddressFamily["_24"] = 24] = "_24";
    AddressFamily[AddressFamily["_25"] = 25] = "_25";
    AddressFamily[AddressFamily["_26"] = 26] = "_26";
    AddressFamily[AddressFamily["_28"] = 28] = "_28";
    AddressFamily[AddressFamily["_29"] = 29] = "_29";
    AddressFamily[AddressFamily["_65536"] = 65536] = "_65536";
    AddressFamily[AddressFamily["_65537"] = 65537] = "_65537";
    AddressFamily[AddressFamily["__1"] = -1] = "__1";
})(AddressFamily || (exports.AddressFamily = AddressFamily = {}));
class ApplyClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["transformations"])) {
                this.transformations = [];
                for (let item of _data["transformations"])
                    this.transformations.push(TransformationNode.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transformations)) {
            data["transformations"] = [];
            for (let item of this.transformations)
                data["transformations"].push(item.toJSON());
        }
        return data;
    }
}
exports.ApplyClause = ApplyClause;
class ApplyQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.resultClrType = _data["resultClrType"] ? Type.fromJS(_data["resultClrType"]) : undefined;
            this.applyClause = _data["applyClause"] ? ApplyClause.fromJS(_data["applyClause"]) : undefined;
            this.rawValue = _data["rawValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["resultClrType"] = this.resultClrType ? this.resultClrType.toJSON() : undefined;
        data["applyClause"] = this.applyClause ? this.applyClause.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }
}
exports.ApplyQueryOption = ApplyQueryOption;
class AsnEncodedData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.oid = _data["oid"] ? Oid.fromJS(_data["oid"]) : undefined;
            this.rawData = _data["rawData"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AsnEncodedData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid ? this.oid.toJSON() : undefined;
        data["rawData"] = this.rawData;
        return data;
    }
}
exports.AsnEncodedData = AsnEncodedData;
class Assembly {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                this.definedTypes = [];
                for (let item of _data["definedTypes"])
                    this.definedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                this.exportedTypes = [];
                for (let item of _data["exportedTypes"])
                    this.exportedTypes.push(Type.fromJS(item));
            }
            this.codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : undefined;
            this.fullName = _data["fullName"];
            this.imageRuntimeVersion = _data["imageRuntimeVersion"];
            this.isDynamic = _data["isDynamic"];
            this.location = _data["location"];
            this.reflectionOnly = _data["reflectionOnly"];
            this.isCollectible = _data["isCollectible"];
            this.isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : undefined;
            if (Array.isArray(_data["modules"])) {
                this.modules = [];
                for (let item of _data["modules"])
                    this.modules.push(Module.fromJS(item));
            }
            this.globalAssemblyCache = _data["globalAssemblyCache"];
            this.hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item.toJSON());
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}
exports.Assembly = Assembly;
class AsymmetricAlgorithm {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.keySize = _data["keySize"];
            if (Array.isArray(_data["legalKeySizes"])) {
                this.legalKeySizes = [];
                for (let item of _data["legalKeySizes"])
                    this.legalKeySizes.push(KeySizes.fromJS(item));
            }
            this.signatureAlgorithm = _data["signatureAlgorithm"];
            this.keyExchangeAlgorithm = _data["keyExchangeAlgorithm"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AsymmetricAlgorithm();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keySize"] = this.keySize;
        if (Array.isArray(this.legalKeySizes)) {
            data["legalKeySizes"] = [];
            for (let item of this.legalKeySizes)
                data["legalKeySizes"].push(item.toJSON());
        }
        data["signatureAlgorithm"] = this.signatureAlgorithm;
        data["keyExchangeAlgorithm"] = this.keyExchangeAlgorithm;
        return data;
    }
}
exports.AsymmetricAlgorithm = AsymmetricAlgorithm;
var AuIncomeType;
(function (AuIncomeType) {
    AuIncomeType[AuIncomeType["SalaryAndWages"] = "SalaryAndWages"] = "SalaryAndWages";
    AuIncomeType[AuIncomeType["WorkingHolidayMaker"] = "WorkingHolidayMaker"] = "WorkingHolidayMaker";
    AuIncomeType[AuIncomeType["NonEmployee"] = "NonEmployee"] = "NonEmployee";
    AuIncomeType[AuIncomeType["CloselyHeldPayees"] = "CloselyHeldPayees"] = "CloselyHeldPayees";
    AuIncomeType[AuIncomeType["LabourHire"] = "LabourHire"] = "LabourHire";
})(AuIncomeType || (exports.AuIncomeType = AuIncomeType = {}));
var AuPayeesWorkingCondition;
(function (AuPayeesWorkingCondition) {
    AuPayeesWorkingCondition[AuPayeesWorkingCondition["Promotional"] = "Promotional"] = "Promotional";
    AuPayeesWorkingCondition[AuPayeesWorkingCondition["ThreeOrLessPerformancesPerWeek"] = "ThreeOrLessPerformancesPerWeek"] = "ThreeOrLessPerformancesPerWeek";
    AuPayeesWorkingCondition[AuPayeesWorkingCondition["NoneOfThese"] = "NoneOfThese"] = "NoneOfThese";
})(AuPayeesWorkingCondition || (exports.AuPayeesWorkingCondition = AuPayeesWorkingCondition = {}));
var AuTaxFileNumberExemptionType;
(function (AuTaxFileNumberExemptionType) {
    AuTaxFileNumberExemptionType[AuTaxFileNumberExemptionType["Pensioner"] = "Pensioner"] = "Pensioner";
    AuTaxFileNumberExemptionType[AuTaxFileNumberExemptionType["UnderEighteen"] = "UnderEighteen"] = "UnderEighteen";
    AuTaxFileNumberExemptionType[AuTaxFileNumberExemptionType["TFNNotQuoted"] = "TFNNotQuoted"] = "TFNNotQuoted";
    AuTaxFileNumberExemptionType[AuTaxFileNumberExemptionType["AwaitingTFN"] = "AwaitingTFN"] = "AwaitingTFN";
})(AuTaxFileNumberExemptionType || (exports.AuTaxFileNumberExemptionType = AuTaxFileNumberExemptionType = {}));
var AuTaxScaleType;
(function (AuTaxScaleType) {
    AuTaxScaleType[AuTaxScaleType["Regular"] = "Regular"] = "Regular";
    AuTaxScaleType[AuTaxScaleType["HorticulturistsOrShearers"] = "HorticulturistsOrShearers"] = "HorticulturistsOrShearers";
    AuTaxScaleType[AuTaxScaleType["ActorsVarietyArtistsAndOtherEntertainers"] = "ActorsVarietyArtistsAndOtherEntertainers"] = "ActorsVarietyArtistsAndOtherEntertainers";
    AuTaxScaleType[AuTaxScaleType["SeniorOrPensioners"] = "SeniorOrPensioners"] = "SeniorOrPensioners";
    AuTaxScaleType[AuTaxScaleType["Foreign"] = "Foreign"] = "Foreign";
    AuTaxScaleType[AuTaxScaleType["WorkingHolidayMaker"] = "WorkingHolidayMaker"] = "WorkingHolidayMaker";
})(AuTaxScaleType || (exports.AuTaxScaleType = AuTaxScaleType = {}));
var AuthModule;
(function (AuthModule) {
    AuthModule[AuthModule["Time"] = "Time"] = "Time";
    AuthModule[AuthModule["Stock"] = "Stock"] = "Stock";
})(AuthModule || (exports.AuthModule = AuthModule = {}));
class AuthenticateResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}
exports.AuthenticateResponse = AuthenticateResponse;
class BaseConditionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.ruleId = _data["ruleId"];
            this.code = _data["code"];
            this.payload = _data["payload"] ? IBasePayloadModel.fromJS(_data["payload"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BaseConditionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["ruleId"] = this.ruleId;
        data["code"] = this.code;
        data["payload"] = this.payload ? this.payload.toJSON() : undefined;
        return data;
    }
}
exports.BaseConditionModel = BaseConditionModel;
class BrandModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BrandModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.BrandModel = BrandModel;
class BreakDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.shiftId = _data["shiftId"];
            this.breakStart = _data["breakStart"] ? dayjs(_data["breakStart"].toString()) : undefined;
            this.breakEnd = _data["breakEnd"] ? dayjs(_data["breakEnd"].toString()) : undefined;
            this.paid = _data["paid"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BreakDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["shiftId"] = this.shiftId;
        data["breakStart"] = this.breakStart ? this.breakStart.toISOString() : undefined;
        data["breakEnd"] = this.breakEnd ? this.breakEnd.toISOString() : undefined;
        data["paid"] = this.paid;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        return data;
    }
}
exports.BreakDto = BreakDto;
class Budget {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : undefined;
            this.amount = _data["amount"];
            this.salesTax = _data["salesTax"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Budget();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["amount"] = this.amount;
        data["salesTax"] = this.salesTax;
        return data;
    }
}
exports.Budget = Budget;
class BulkStaffMemberEmailUpdateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["updatedEmails"])) {
                this.updatedEmails = [];
                for (let item of _data["updatedEmails"])
                    this.updatedEmails.push(StaffMemberIdEmailPair.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkStaffMemberEmailUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updatedEmails)) {
            data["updatedEmails"] = [];
            for (let item of this.updatedEmails)
                data["updatedEmails"].push(item.toJSON());
        }
        return data;
    }
}
exports.BulkStaffMemberEmailUpdateRequest = BulkStaffMemberEmailUpdateRequest;
class ByteReadOnlyMemory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.length = _data["length"];
            this.isEmpty = _data["isEmpty"];
            this.span = _data["span"] ? ByteReadOnlySpan.fromJS(_data["span"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ByteReadOnlyMemory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["isEmpty"] = this.isEmpty;
        data["span"] = this.span ? this.span.toJSON() : undefined;
        return data;
    }
}
exports.ByteReadOnlyMemory = ByteReadOnlyMemory;
class ByteReadOnlySpan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.length = _data["length"];
            this.isEmpty = _data["isEmpty"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ByteReadOnlySpan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["isEmpty"] = this.isEmpty;
        return data;
    }
}
exports.ByteReadOnlySpan = ByteReadOnlySpan;
var CallingConventions;
(function (CallingConventions) {
    CallingConventions[CallingConventions["_1"] = 1] = "_1";
    CallingConventions[CallingConventions["_2"] = 2] = "_2";
    CallingConventions[CallingConventions["_3"] = 3] = "_3";
    CallingConventions[CallingConventions["_32"] = 32] = "_32";
    CallingConventions[CallingConventions["_64"] = 64] = "_64";
})(CallingConventions || (exports.CallingConventions = CallingConventions = {}));
class CancellationToken {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isCancellationRequested = _data["isCancellationRequested"];
            this.canBeCanceled = _data["canBeCanceled"];
            this.waitHandle = _data["waitHandle"] ? WaitHandle.fromJS(_data["waitHandle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationToken();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isCancellationRequested"] = this.isCancellationRequested;
        data["canBeCanceled"] = this.canBeCanceled;
        data["waitHandle"] = this.waitHandle ? this.waitHandle.toJSON() : undefined;
        return data;
    }
}
exports.CancellationToken = CancellationToken;
class CashupDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.cashupSetId = _data["cashupSetId"];
            this.tillName = _data["tillName"];
            this.tillIdentifier = _data["tillIdentifier"];
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.datestampCounted = _data["datestampCounted"] ? dayjs(_data["datestampCounted"].toString()) : undefined;
            this.countedUser = _data["countedUser"];
            this.countedUserName = _data["countedUserName"];
            this.commited = _data["commited"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [];
                for (let item of _data["lines"])
                    this.lines.push(CashupLineDto.fromJS(item));
            }
            this.cashAmountSystem = _data["cashAmountSystem"];
            this.otherAmountSystem = _data["otherAmountSystem"];
            this.cashAmountCounted = _data["cashAmountCounted"];
            this.otherAmountCounted = _data["otherAmountCounted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cashupSetId"] = this.cashupSetId;
        data["tillName"] = this.tillName;
        data["tillIdentifier"] = this.tillIdentifier;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["datestampCounted"] = this.datestampCounted ? this.datestampCounted.toISOString() : undefined;
        data["countedUser"] = this.countedUser;
        data["countedUserName"] = this.countedUserName;
        data["commited"] = this.commited;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["cashAmountSystem"] = this.cashAmountSystem;
        data["otherAmountSystem"] = this.otherAmountSystem;
        data["cashAmountCounted"] = this.cashAmountCounted;
        data["otherAmountCounted"] = this.otherAmountCounted;
        return data;
    }
}
exports.CashupDto = CashupDto;
class CashupLineDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.cashupId = _data["cashupId"];
            this.tenderTypeId = _data["tenderTypeId"];
            this.tenderTypeName = _data["tenderTypeName"];
            this.isCash = _data["isCash"];
            this.systemAmount = _data["systemAmount"];
            this.countedAmount = _data["countedAmount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashupLineDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cashupId"] = this.cashupId;
        data["tenderTypeId"] = this.tenderTypeId;
        data["tenderTypeName"] = this.tenderTypeName;
        data["isCash"] = this.isCash;
        data["systemAmount"] = this.systemAmount;
        data["countedAmount"] = this.countedAmount;
        return data;
    }
}
exports.CashupLineDto = CashupLineDto;
class CashupSetDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.committed = _data["committed"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["cashups"])) {
                this.cashups = [];
                for (let item of _data["cashups"])
                    this.cashups.push(CashupDto.fromJS(item));
            }
            this.cashVariance = _data["cashVariance"];
            this.otherVariance = _data["otherVariance"];
            this.firstCashupSet = _data["firstCashupSet"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashupSetDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["committed"] = this.committed;
        data["comment"] = this.comment;
        if (Array.isArray(this.cashups)) {
            data["cashups"] = [];
            for (let item of this.cashups)
                data["cashups"].push(item.toJSON());
        }
        data["cashVariance"] = this.cashVariance;
        data["otherVariance"] = this.otherVariance;
        data["firstCashupSet"] = this.firstCashupSet;
        return data;
    }
}
exports.CashupSetDto = CashupSetDto;
class CashupSummaryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.totalVariance = _data["totalVariance"];
            this.cashVariance = _data["cashVariance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CashupSummaryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["totalVariance"] = this.totalVariance;
        data["cashVariance"] = this.cashVariance;
        return data;
    }
}
exports.CashupSummaryDto = CashupSummaryDto;
class ChangeEmailBindingModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailBindingModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}
exports.ChangeEmailBindingModel = ChangeEmailBindingModel;
class ChangePasswordBindingModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordBindingModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}
exports.ChangePasswordBindingModel = ChangePasswordBindingModel;
class Claim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {};
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties[key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}
exports.Claim = Claim;
class ClaimsIdentity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : undefined;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            this.label = _data["label"];
            this.name = _data["name"];
            this.nameClaimType = _data["nameClaimType"];
            this.roleClaimType = _data["roleClaimType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["name"] = this.name;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data;
    }
}
exports.ClaimsIdentity = ClaimsIdentity;
class ClaimsPrincipal {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            if (Array.isArray(_data["identities"])) {
                this.identities = [];
                for (let item of _data["identities"])
                    this.identities.push(ClaimsIdentity.fromJS(item));
            }
            this.identity = _data["identity"] ? IIdentity.fromJS(_data["identity"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsPrincipal();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item.toJSON());
        }
        data["identity"] = this.identity ? this.identity.toJSON() : undefined;
        return data;
    }
}
exports.ClaimsPrincipal = ClaimsPrincipal;
var ClassifierType;
(function (ClassifierType) {
    ClassifierType[ClassifierType["Employment"] = "Employment"] = "Employment";
    ClassifierType[ClassifierType["Age"] = "Age"] = "Age";
    ClassifierType[ClassifierType["Remuneration"] = "Remuneration"] = "Remuneration";
    ClassifierType[ClassifierType["ContractedWeeklyHours"] = "ContractedWeeklyHours"] = "ContractedWeeklyHours";
    ClassifierType[ClassifierType["StartDate"] = "StartDate"] = "StartDate";
})(ClassifierType || (exports.ClassifierType = ClassifierType = {}));
class Clockin {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.posIdentifier = _data["posIdentifier"];
            this.staffMemberId = _data["staffMemberId"];
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? StaffRole.fromJS(_data["role"]) : undefined;
            this.hourlyRate = _data["hourlyRate"];
            this.clockinTime = _data["clockinTime"] ? dayjs(_data["clockinTime"].toString()) : undefined;
            this.clockoutTime = _data["clockoutTime"] ? dayjs(_data["clockoutTime"].toString()) : undefined;
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.datestampApproved = _data["datestampApproved"] ? dayjs(_data["datestampApproved"].toString()) : undefined;
            this.payrunLineId = _data["payrunLineId"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(ClockinRule.fromJS(item));
            }
            this.pgId = _data["pgId"];
            this.totalHours = _data["totalHours"];
            this.baseCost = _data["baseCost"];
            this.totalCost = _data["totalCost"];
            this.adjustedHourlyRate = _data["adjustedHourlyRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Clockin();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["posIdentifier"] = this.posIdentifier;
        data["staffMemberId"] = this.staffMemberId;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined;
        data["hourlyRate"] = this.hourlyRate;
        data["clockinTime"] = this.clockinTime ? this.clockinTime.toISOString() : undefined;
        data["clockoutTime"] = this.clockoutTime ? this.clockoutTime.toISOString() : undefined;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["datestampApproved"] = this.datestampApproved ? this.datestampApproved.toISOString() : undefined;
        data["payrunLineId"] = this.payrunLineId;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["pgId"] = this.pgId;
        data["totalHours"] = this.totalHours;
        data["baseCost"] = this.baseCost;
        data["totalCost"] = this.totalCost;
        data["adjustedHourlyRate"] = this.adjustedHourlyRate;
        return data;
    }
}
exports.Clockin = Clockin;
class ClockinHistoryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.clockinStaffMemberFirstName = _data["clockinStaffMemberFirstName"];
            this.clockinStaffMemberLastName = _data["clockinStaffMemberLastName"];
            this.datestampUpdated = _data["datestampUpdated"] ? dayjs(_data["datestampUpdated"].toString()) : undefined;
            this.clockinTime = _data["clockinTime"] ? dayjs(_data["clockinTime"].toString()) : undefined;
            this.clockoutTime = _data["clockoutTime"] ? dayjs(_data["clockoutTime"].toString()) : undefined;
            this.userFullName = _data["userFullName"];
            this.hourlyRate = _data["hourlyRate"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.clockinTimeUpdated = _data["clockinTimeUpdated"];
            this.clockoutTimeUpdated = _data["clockoutTimeUpdated"];
            this.hourlyRateUpdated = _data["hourlyRateUpdated"];
            this.roleUpdated = _data["roleUpdated"];
            this.operation = _data["operation"];
            this.system = _data["system"];
            this.ruleId = _data["ruleId"];
            this.ruleName = _data["ruleName"];
            this.ruleIdUpdated = _data["ruleIdUpdated"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClockinHistoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["clockinStaffMemberFirstName"] = this.clockinStaffMemberFirstName;
        data["clockinStaffMemberLastName"] = this.clockinStaffMemberLastName;
        data["datestampUpdated"] = this.datestampUpdated ? this.datestampUpdated.toISOString() : undefined;
        data["clockinTime"] = this.clockinTime ? this.clockinTime.toISOString() : undefined;
        data["clockoutTime"] = this.clockoutTime ? this.clockoutTime.toISOString() : undefined;
        data["userFullName"] = this.userFullName;
        data["hourlyRate"] = this.hourlyRate;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["clockinTimeUpdated"] = this.clockinTimeUpdated;
        data["clockoutTimeUpdated"] = this.clockoutTimeUpdated;
        data["hourlyRateUpdated"] = this.hourlyRateUpdated;
        data["roleUpdated"] = this.roleUpdated;
        data["operation"] = this.operation;
        data["system"] = this.system;
        data["ruleId"] = this.ruleId;
        data["ruleName"] = this.ruleName;
        data["ruleIdUpdated"] = this.ruleIdUpdated;
        return data;
    }
}
exports.ClockinHistoryResponse = ClockinHistoryResponse;
class ClockinRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(PostClockinRuleRequest.fromJS(item));
            }
            this.clockinTime = _data["clockinTime"] ? dayjs(_data["clockinTime"].toString()) : undefined;
            this.clockoutTime = _data["clockoutTime"] ? dayjs(_data["clockoutTime"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.datestampApproved = _data["datestampApproved"] ? dayjs(_data["datestampApproved"].toString()) : undefined;
            this.hourlyRate = _data["hourlyRate"];
            this.posIdentifier = _data["posIdentifier"];
            this.roleId = _data["roleId"];
            this.staffMemberId = _data["staffMemberId"];
            this.payrunLineId = _data["payrunLineId"];
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [];
                for (let item of _data["breaks"])
                    this.breaks.push(BreakDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClockinRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["clockinTime"] = this.clockinTime ? this.clockinTime.toISOString() : undefined;
        data["clockoutTime"] = this.clockoutTime ? this.clockoutTime.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["datestampApproved"] = this.datestampApproved ? this.datestampApproved.toISOString() : undefined;
        data["hourlyRate"] = this.hourlyRate;
        data["posIdentifier"] = this.posIdentifier;
        data["roleId"] = this.roleId;
        data["staffMemberId"] = this.staffMemberId;
        data["payrunLineId"] = this.payrunLineId;
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item.toJSON());
        }
        return data;
    }
}
exports.ClockinRequest = ClockinRequest;
class ClockinRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.clockin = _data["clockin"] ? Clockin.fromJS(_data["clockin"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.source = _data["source"];
            this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : undefined;
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : undefined;
            this.override = _data["override"] ? ClockinRuleOverride.fromJS(_data["override"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClockinRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["clockin"] = this.clockin ? this.clockin.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["source"] = this.source;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["override"] = this.override ? this.override.toJSON() : undefined;
        return data;
    }
}
exports.ClockinRule = ClockinRule;
class ClockinRuleOverride {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.ruleId = _data["ruleId"];
            this.type = _data["type"];
            this.addedAt = _data["addedAt"] ? dayjs(_data["addedAt"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.appliedFrom = _data["appliedFrom"] ? dayjs(_data["appliedFrom"].toString()) : undefined;
            this.appliedTo = _data["appliedTo"] ? dayjs(_data["appliedTo"].toString()) : undefined;
            this.totalHours = _data["totalHours"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClockinRuleOverride();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["ruleId"] = this.ruleId;
        data["type"] = this.type;
        data["addedAt"] = this.addedAt ? this.addedAt.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["appliedFrom"] = this.appliedFrom ? this.appliedFrom.toISOString() : undefined;
        data["appliedTo"] = this.appliedTo ? this.appliedTo.toISOString() : undefined;
        data["totalHours"] = this.totalHours;
        return data;
    }
}
exports.ClockinRuleOverride = ClockinRuleOverride;
class ClockinRuleOverrideModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.ruleId = _data["ruleId"];
            this.type = _data["type"];
            this.addedAt = _data["addedAt"] ? dayjs(_data["addedAt"].toString()) : undefined;
            this.appliedFrom = _data["appliedFrom"] ? dayjs(_data["appliedFrom"].toString()) : undefined;
            this.appliedTo = _data["appliedTo"] ? dayjs(_data["appliedTo"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.totalHours = _data["totalHours"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClockinRuleOverrideModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["ruleId"] = this.ruleId;
        data["type"] = this.type;
        data["addedAt"] = this.addedAt ? this.addedAt.toISOString() : undefined;
        data["appliedFrom"] = this.appliedFrom ? this.appliedFrom.toISOString() : undefined;
        data["appliedTo"] = this.appliedTo ? this.appliedTo.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["totalHours"] = this.totalHours;
        return data;
    }
}
exports.ClockinRuleOverrideModel = ClockinRuleOverrideModel;
class ComputeClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["computedItems"])) {
                this.computedItems = [];
                for (let item of _data["computedItems"])
                    this.computedItems.push(ComputeExpression.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.computedItems)) {
            data["computedItems"] = [];
            for (let item of this.computedItems)
                data["computedItems"].push(item.toJSON());
        }
        return data;
    }
}
exports.ComputeClause = ComputeClause;
class ComputeExpression {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : undefined;
            this.alias = _data["alias"];
            this.typeReference = _data["typeReference"] ? IEdmTypeReference.fromJS(_data["typeReference"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeExpression();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined;
        data["alias"] = this.alias;
        data["typeReference"] = this.typeReference ? this.typeReference.toJSON() : undefined;
        return data;
    }
}
exports.ComputeExpression = ComputeExpression;
class ComputeQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.resultClrType = _data["resultClrType"] ? Type.fromJS(_data["resultClrType"]) : undefined;
            this.computeClause = _data["computeClause"] ? ComputeClause.fromJS(_data["computeClause"]) : undefined;
            this.rawValue = _data["rawValue"];
            this.validator = _data["validator"] ? IComputeQueryValidator.fromJS(_data["validator"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["resultClrType"] = this.resultClrType ? this.resultClrType.toJSON() : undefined;
        data["computeClause"] = this.computeClause ? this.computeClause.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    }
}
exports.ComputeQueryOption = ComputeQueryOption;
class ConnectionInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.remoteIpAddress = _data["remoteIpAddress"] ? IPAddress.fromJS(_data["remoteIpAddress"]) : undefined;
            this.remotePort = _data["remotePort"];
            this.localIpAddress = _data["localIpAddress"] ? IPAddress.fromJS(_data["localIpAddress"]) : undefined;
            this.localPort = _data["localPort"];
            this.clientCertificate = _data["clientCertificate"] ? X509Certificate2.fromJS(_data["clientCertificate"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remoteIpAddress"] = this.remoteIpAddress ? this.remoteIpAddress.toJSON() : undefined;
        data["remotePort"] = this.remotePort;
        data["localIpAddress"] = this.localIpAddress ? this.localIpAddress.toJSON() : undefined;
        data["localPort"] = this.localPort;
        data["clientCertificate"] = this.clientCertificate ? this.clientCertificate.toJSON() : undefined;
        return data;
    }
}
exports.ConnectionInfo = ConnectionInfo;
class ConstructorInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined;
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}
exports.ConstructorInfo = ConstructorInfo;
class Contact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.contactType = _data["contactType"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneMobile = _data["phoneMobile"];
            this.relationship = _data["relationship"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactType"] = this.contactType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneMobile"] = this.phoneMobile;
        data["relationship"] = this.relationship;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.Contact = Contact;
var ContactType;
(function (ContactType) {
    ContactType[ContactType["Emergency"] = "Emergency"] = "Emergency";
})(ContactType || (exports.ContactType = ContactType = {}));
class CopyRosterRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rosterTemplateId = _data["rosterTemplateId"];
            this.sourceWeekStart = _data["sourceWeekStart"] ? dayjs(_data["sourceWeekStart"].toString()) : undefined;
            this.destinationWeekStart = _data["destinationWeekStart"] ? dayjs(_data["destinationWeekStart"].toString()) : undefined;
            if (Array.isArray(_data["days"])) {
                this.days = [];
                for (let item of _data["days"])
                    this.days.push(item);
            }
            if (Array.isArray(_data["staffMemberRosteredShiftsInfo"])) {
                this.staffMemberRosteredShiftsInfo = [];
                for (let item of _data["staffMemberRosteredShiftsInfo"])
                    this.staffMemberRosteredShiftsInfo.push(RosteredShifts.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CopyRosterRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rosterTemplateId"] = this.rosterTemplateId;
        data["sourceWeekStart"] = this.sourceWeekStart ? this.sourceWeekStart.toISOString() : undefined;
        data["destinationWeekStart"] = this.destinationWeekStart ? this.destinationWeekStart.toISOString() : undefined;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        if (Array.isArray(this.staffMemberRosteredShiftsInfo)) {
            data["staffMemberRosteredShiftsInfo"] = [];
            for (let item of this.staffMemberRosteredShiftsInfo)
                data["staffMemberRosteredShiftsInfo"].push(item.toJSON());
        }
        return data;
    }
}
exports.CopyRosterRequest = CopyRosterRequest;
class CountQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? ICountQueryValidator.fromJS(_data["validator"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CountQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    }
}
exports.CountQueryOption = CountQueryOption;
var Countries;
(function (Countries) {
    Countries[Countries["NewZealand"] = "NewZealand"] = "NewZealand";
    Countries[Countries["Australia"] = "Australia"] = "Australia";
})(Countries || (exports.Countries = Countries = {}));
class CreateCloudposDatabaseRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCloudposDatabaseRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}
exports.CreateCloudposDatabaseRequest = CreateCloudposDatabaseRequest;
class CreatePayRunModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.calendarId = _data["calendarId"];
            this.paymentDate = _data["paymentDate"] ? dayjs(_data["paymentDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayRunModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["calendarId"] = this.calendarId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        return data;
    }
}
exports.CreatePayRunModel = CreatePayRunModel;
class CustomAttributeData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                this.constructorArguments = [];
                for (let item of _data["constructorArguments"])
                    this.constructorArguments.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                this.namedArguments = [];
                for (let item of _data["namedArguments"])
                    this.namedArguments.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}
exports.CustomAttributeData = CustomAttributeData;
class CustomAttributeNamedArgument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : undefined;
            this.memberName = _data["memberName"];
            this.isField = _data["isField"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}
exports.CustomAttributeNamedArgument = CustomAttributeNamedArgument;
class CustomAttributeTypedArgument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : undefined;
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : undefined;
        data["value"] = this.value;
        return data;
    }
}
exports.CustomAttributeTypedArgument = CustomAttributeTypedArgument;
var DaysOfTheWeek;
(function (DaysOfTheWeek) {
    DaysOfTheWeek[DaysOfTheWeek["Sunday"] = "Sunday"] = "Sunday";
    DaysOfTheWeek[DaysOfTheWeek["Monday"] = "Monday"] = "Monday";
    DaysOfTheWeek[DaysOfTheWeek["Tuesday"] = "Tuesday"] = "Tuesday";
    DaysOfTheWeek[DaysOfTheWeek["Wednesday"] = "Wednesday"] = "Wednesday";
    DaysOfTheWeek[DaysOfTheWeek["Thursday"] = "Thursday"] = "Thursday";
    DaysOfTheWeek[DaysOfTheWeek["Friday"] = "Friday"] = "Friday";
    DaysOfTheWeek[DaysOfTheWeek["Saturday"] = "Saturday"] = "Saturday";
})(DaysOfTheWeek || (exports.DaysOfTheWeek = DaysOfTheWeek = {}));
class DefaultQueryConfigurations {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.enableExpand = _data["enableExpand"];
            this.enableSelect = _data["enableSelect"];
            this.enableCount = _data["enableCount"];
            this.enableOrderBy = _data["enableOrderBy"];
            this.enableFilter = _data["enableFilter"];
            this.maxTop = _data["maxTop"];
            this.enableSkipToken = _data["enableSkipToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultQueryConfigurations();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["enableExpand"] = this.enableExpand;
        data["enableSelect"] = this.enableSelect;
        data["enableCount"] = this.enableCount;
        data["enableOrderBy"] = this.enableOrderBy;
        data["enableFilter"] = this.enableFilter;
        data["maxTop"] = this.maxTop;
        data["enableSkipToken"] = this.enableSkipToken;
        return data;
    }
}
exports.DefaultQueryConfigurations = DefaultQueryConfigurations;
class DeleteActivatedPackageRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.packageRef = _data["packageRef"] ? PackageRef.fromJS(_data["packageRef"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteActivatedPackageRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageRef"] = this.packageRef ? this.packageRef.toJSON() : undefined;
        return data;
    }
}
exports.DeleteActivatedPackageRequest = DeleteActivatedPackageRequest;
class DeleteRuleOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.packageRef = _data["packageRef"] ? PackageRef.fromJS(_data["packageRef"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRuleOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageRef"] = this.packageRef ? this.packageRef.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.DeleteRuleOverrideRequest = DeleteRuleOverrideRequest;
class DeliveryDetailsModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.postal1 = _data["postal1"];
            this.postal2 = _data["postal2"];
            this.postal3 = _data["postal3"];
            this.postal4 = _data["postal4"];
            this.delivery1 = _data["delivery1"];
            this.delivery2 = _data["delivery2"];
            this.delivery3 = _data["delivery3"];
            this.delivery4 = _data["delivery4"];
            this.contact = _data["contact"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.phone3 = _data["phone3"];
            this.fax = _data["fax"];
            this.emailDelivery = _data["emailDelivery"];
            this.emailAccounts = _data["emailAccounts"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.isDefault = _data["isDefault"];
            this.separatePostalAddress = _data["separatePostalAddress"];
            this.logo = _data["logo"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailsModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postal1"] = this.postal1;
        data["postal2"] = this.postal2;
        data["postal3"] = this.postal3;
        data["postal4"] = this.postal4;
        data["delivery1"] = this.delivery1;
        data["delivery2"] = this.delivery2;
        data["delivery3"] = this.delivery3;
        data["delivery4"] = this.delivery4;
        data["contact"] = this.contact;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["phone3"] = this.phone3;
        data["fax"] = this.fax;
        data["emailDelivery"] = this.emailDelivery;
        data["emailAccounts"] = this.emailAccounts;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["isDefault"] = this.isDefault;
        data["separatePostalAddress"] = this.separatePostalAddress;
        data["logo"] = this.logo;
        return data;
    }
}
exports.DeliveryDetailsModel = DeliveryDetailsModel;
class ETag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isWellFormed = _data["isWellFormed"];
            this.entityType = _data["entityType"] ? Type.fromJS(_data["entityType"]) : undefined;
            this.isAny = _data["isAny"];
            this.isIfNoneMatch = _data["isIfNoneMatch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ETag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isWellFormed"] = this.isWellFormed;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined;
        data["isAny"] = this.isAny;
        data["isIfNoneMatch"] = this.isIfNoneMatch;
        return data;
    }
}
exports.ETag = ETag;
var EdmContainerElementKind;
(function (EdmContainerElementKind) {
    EdmContainerElementKind[EdmContainerElementKind["_0"] = 0] = "_0";
    EdmContainerElementKind[EdmContainerElementKind["_1"] = 1] = "_1";
    EdmContainerElementKind[EdmContainerElementKind["_2"] = 2] = "_2";
    EdmContainerElementKind[EdmContainerElementKind["_3"] = 3] = "_3";
    EdmContainerElementKind[EdmContainerElementKind["_4"] = 4] = "_4";
})(EdmContainerElementKind || (exports.EdmContainerElementKind = EdmContainerElementKind = {}));
var EdmExpressionKind;
(function (EdmExpressionKind) {
    EdmExpressionKind[EdmExpressionKind["_0"] = 0] = "_0";
    EdmExpressionKind[EdmExpressionKind["_1"] = 1] = "_1";
    EdmExpressionKind[EdmExpressionKind["_2"] = 2] = "_2";
    EdmExpressionKind[EdmExpressionKind["_3"] = 3] = "_3";
    EdmExpressionKind[EdmExpressionKind["_4"] = 4] = "_4";
    EdmExpressionKind[EdmExpressionKind["_5"] = 5] = "_5";
    EdmExpressionKind[EdmExpressionKind["_6"] = 6] = "_6";
    EdmExpressionKind[EdmExpressionKind["_7"] = 7] = "_7";
    EdmExpressionKind[EdmExpressionKind["_8"] = 8] = "_8";
    EdmExpressionKind[EdmExpressionKind["_9"] = 9] = "_9";
    EdmExpressionKind[EdmExpressionKind["_10"] = 10] = "_10";
    EdmExpressionKind[EdmExpressionKind["_11"] = 11] = "_11";
    EdmExpressionKind[EdmExpressionKind["_12"] = 12] = "_12";
    EdmExpressionKind[EdmExpressionKind["_13"] = 13] = "_13";
    EdmExpressionKind[EdmExpressionKind["_14"] = 14] = "_14";
    EdmExpressionKind[EdmExpressionKind["_15"] = 15] = "_15";
    EdmExpressionKind[EdmExpressionKind["_16"] = 16] = "_16";
    EdmExpressionKind[EdmExpressionKind["_17"] = 17] = "_17";
    EdmExpressionKind[EdmExpressionKind["_18"] = 18] = "_18";
    EdmExpressionKind[EdmExpressionKind["_19"] = 19] = "_19";
    EdmExpressionKind[EdmExpressionKind["_20"] = 20] = "_20";
    EdmExpressionKind[EdmExpressionKind["_21"] = 21] = "_21";
    EdmExpressionKind[EdmExpressionKind["_22"] = 22] = "_22";
    EdmExpressionKind[EdmExpressionKind["_23"] = 23] = "_23";
    EdmExpressionKind[EdmExpressionKind["_24"] = 24] = "_24";
    EdmExpressionKind[EdmExpressionKind["_25"] = 25] = "_25";
})(EdmExpressionKind || (exports.EdmExpressionKind = EdmExpressionKind = {}));
var EdmOnDeleteAction;
(function (EdmOnDeleteAction) {
    EdmOnDeleteAction[EdmOnDeleteAction["_0"] = 0] = "_0";
    EdmOnDeleteAction[EdmOnDeleteAction["_1"] = 1] = "_1";
})(EdmOnDeleteAction || (exports.EdmOnDeleteAction = EdmOnDeleteAction = {}));
var EdmPropertyKind;
(function (EdmPropertyKind) {
    EdmPropertyKind[EdmPropertyKind["_0"] = 0] = "_0";
    EdmPropertyKind[EdmPropertyKind["_1"] = 1] = "_1";
    EdmPropertyKind[EdmPropertyKind["_2"] = 2] = "_2";
})(EdmPropertyKind || (exports.EdmPropertyKind = EdmPropertyKind = {}));
class EdmReferentialConstraintPropertyPair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dependentProperty = _data["dependentProperty"] ? IEdmStructuralProperty.fromJS(_data["dependentProperty"]) : undefined;
            this.principalProperty = _data["principalProperty"] ? IEdmStructuralProperty.fromJS(_data["principalProperty"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EdmReferentialConstraintPropertyPair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dependentProperty"] = this.dependentProperty ? this.dependentProperty.toJSON() : undefined;
        data["principalProperty"] = this.principalProperty ? this.principalProperty.toJSON() : undefined;
        return data;
    }
}
exports.EdmReferentialConstraintPropertyPair = EdmReferentialConstraintPropertyPair;
var EdmSchemaElementKind;
(function (EdmSchemaElementKind) {
    EdmSchemaElementKind[EdmSchemaElementKind["_0"] = 0] = "_0";
    EdmSchemaElementKind[EdmSchemaElementKind["_1"] = 1] = "_1";
    EdmSchemaElementKind[EdmSchemaElementKind["_2"] = 2] = "_2";
    EdmSchemaElementKind[EdmSchemaElementKind["_3"] = 3] = "_3";
    EdmSchemaElementKind[EdmSchemaElementKind["_4"] = 4] = "_4";
    EdmSchemaElementKind[EdmSchemaElementKind["_5"] = 5] = "_5";
})(EdmSchemaElementKind || (exports.EdmSchemaElementKind = EdmSchemaElementKind = {}));
var EdmTypeKind;
(function (EdmTypeKind) {
    EdmTypeKind[EdmTypeKind["_0"] = 0] = "_0";
    EdmTypeKind[EdmTypeKind["_1"] = 1] = "_1";
    EdmTypeKind[EdmTypeKind["_2"] = 2] = "_2";
    EdmTypeKind[EdmTypeKind["_3"] = 3] = "_3";
    EdmTypeKind[EdmTypeKind["_4"] = 4] = "_4";
    EdmTypeKind[EdmTypeKind["_5"] = 5] = "_5";
    EdmTypeKind[EdmTypeKind["_6"] = 6] = "_6";
    EdmTypeKind[EdmTypeKind["_7"] = 7] = "_7";
    EdmTypeKind[EdmTypeKind["_8"] = 8] = "_8";
    EdmTypeKind[EdmTypeKind["_9"] = 9] = "_9";
})(EdmTypeKind || (exports.EdmTypeKind = EdmTypeKind = {}));
class EmployeeMatchCondition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.matchType = _data["matchType"];
            this.operator = _data["operator"];
            if (Array.isArray(_data["values"])) {
                this.values = [];
                for (let item of _data["values"])
                    this.values.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMatchCondition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["matchType"] = this.matchType;
        data["operator"] = this.operator;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}
exports.EmployeeMatchCondition = EmployeeMatchCondition;
class EmployeeMatchPayload {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.applyType = _data["applyType"];
            if (Array.isArray(_data["matchConditions"])) {
                this.matchConditions = [];
                for (let item of _data["matchConditions"])
                    this.matchConditions.push(EmployeeMatchCondition.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMatchPayload();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["applyType"] = this.applyType;
        if (Array.isArray(this.matchConditions)) {
            data["matchConditions"] = [];
            for (let item of this.matchConditions)
                data["matchConditions"].push(item.toJSON());
        }
        return data;
    }
}
exports.EmployeeMatchPayload = EmployeeMatchPayload;
var EmployeeMatchTypeModel;
(function (EmployeeMatchTypeModel) {
    EmployeeMatchTypeModel[EmployeeMatchTypeModel["StaffMember"] = "StaffMember"] = "StaffMember";
    EmployeeMatchTypeModel[EmployeeMatchTypeModel["StaffRole"] = "StaffRole"] = "StaffRole";
    EmployeeMatchTypeModel[EmployeeMatchTypeModel["EmploymentType"] = "EmploymentType"] = "EmploymentType";
    EmployeeMatchTypeModel[EmployeeMatchTypeModel["PayClassification"] = "PayClassification"] = "PayClassification";
})(EmployeeMatchTypeModel || (exports.EmployeeMatchTypeModel = EmployeeMatchTypeModel = {}));
var EmploymentType;
(function (EmploymentType) {
    EmploymentType[EmploymentType["FullTime"] = "FullTime"] = "FullTime";
    EmploymentType[EmploymentType["PartTime"] = "PartTime"] = "PartTime";
    EmploymentType[EmploymentType["Casual"] = "Casual"] = "Casual";
})(EmploymentType || (exports.EmploymentType = EmploymentType = {}));
var EvaluationType;
(function (EvaluationType) {
    EvaluationType[EvaluationType["_0"] = 0] = "_0";
    EvaluationType[EvaluationType["_1"] = 1] = "_1";
})(EvaluationType || (exports.EvaluationType = EvaluationType = {}));
var EvaluationTypeModel;
(function (EvaluationTypeModel) {
    EvaluationTypeModel[EvaluationTypeModel["All"] = "All"] = "All";
    EvaluationTypeModel[EvaluationTypeModel["Any"] = "Any"] = "Any";
})(EvaluationTypeModel || (exports.EvaluationTypeModel = EvaluationTypeModel = {}));
var EventAttributes;
(function (EventAttributes) {
    EventAttributes[EventAttributes["_0"] = 0] = "_0";
    EventAttributes[EventAttributes["_512"] = 512] = "_512";
    EventAttributes[EventAttributes["_1024"] = 1024] = "_1024";
})(EventAttributes || (exports.EventAttributes = EventAttributes = {}));
class EventInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : undefined;
            this.isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : undefined;
        return data;
    }
}
exports.EventInfo = EventInfo;
var FieldAttributes;
(function (FieldAttributes) {
    FieldAttributes[FieldAttributes["_0"] = 0] = "_0";
    FieldAttributes[FieldAttributes["_1"] = 1] = "_1";
    FieldAttributes[FieldAttributes["_2"] = 2] = "_2";
    FieldAttributes[FieldAttributes["_3"] = 3] = "_3";
    FieldAttributes[FieldAttributes["_4"] = 4] = "_4";
    FieldAttributes[FieldAttributes["_5"] = 5] = "_5";
    FieldAttributes[FieldAttributes["_6"] = 6] = "_6";
    FieldAttributes[FieldAttributes["_7"] = 7] = "_7";
    FieldAttributes[FieldAttributes["_16"] = 16] = "_16";
    FieldAttributes[FieldAttributes["_32"] = 32] = "_32";
    FieldAttributes[FieldAttributes["_64"] = 64] = "_64";
    FieldAttributes[FieldAttributes["_128"] = 128] = "_128";
    FieldAttributes[FieldAttributes["_256"] = 256] = "_256";
    FieldAttributes[FieldAttributes["_512"] = 512] = "_512";
    FieldAttributes[FieldAttributes["_1024"] = 1024] = "_1024";
    FieldAttributes[FieldAttributes["_4096"] = 4096] = "_4096";
    FieldAttributes[FieldAttributes["_8192"] = 8192] = "_8192";
    FieldAttributes[FieldAttributes["_32768"] = 32768] = "_32768";
    FieldAttributes[FieldAttributes["_38144"] = 38144] = "_38144";
})(FieldAttributes || (exports.FieldAttributes = FieldAttributes = {}));
class FieldInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : undefined;
            this.isInitOnly = _data["isInitOnly"];
            this.isLiteral = _data["isLiteral"];
            this.isNotSerialized = _data["isNotSerialized"];
            this.isPinvokeImpl = _data["isPinvokeImpl"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : undefined;
        return data;
    }
}
exports.FieldInfo = FieldInfo;
class FilterClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : undefined;
            this.rangeVariable = _data["rangeVariable"] ? RangeVariable.fromJS(_data["rangeVariable"]) : undefined;
            this.itemType = _data["itemType"] ? IEdmTypeReference.fromJS(_data["itemType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FilterClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined;
        data["rangeVariable"] = this.rangeVariable ? this.rangeVariable.toJSON() : undefined;
        data["itemType"] = this.itemType ? this.itemType.toJSON() : undefined;
        return data;
    }
}
exports.FilterClause = FilterClause;
class FilterQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.validator = _data["validator"] ? IFilterQueryValidator.fromJS(_data["validator"]) : undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : undefined;
            this.filterClause = _data["filterClause"] ? FilterClause.fromJS(_data["filterClause"]) : undefined;
            this.rawValue = _data["rawValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FilterQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : undefined;
        data["filterClause"] = this.filterClause ? this.filterClause.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }
}
exports.FilterQueryOption = FilterQueryOption;
var GenericParameterAttributes;
(function (GenericParameterAttributes) {
    GenericParameterAttributes[GenericParameterAttributes["_0"] = 0] = "_0";
    GenericParameterAttributes[GenericParameterAttributes["_1"] = 1] = "_1";
    GenericParameterAttributes[GenericParameterAttributes["_2"] = 2] = "_2";
    GenericParameterAttributes[GenericParameterAttributes["_3"] = 3] = "_3";
    GenericParameterAttributes[GenericParameterAttributes["_4"] = 4] = "_4";
    GenericParameterAttributes[GenericParameterAttributes["_8"] = 8] = "_8";
    GenericParameterAttributes[GenericParameterAttributes["_16"] = 16] = "_16";
    GenericParameterAttributes[GenericParameterAttributes["_28"] = 28] = "_28";
})(GenericParameterAttributes || (exports.GenericParameterAttributes = GenericParameterAttributes = {}));
class GetDiscountsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.discountTypeIdentifier = _data["discountTypeIdentifier"];
            this.discountType = _data["discountType"];
            this.discountsAmount = _data["discountsAmount"];
            this.discountsCount = _data["discountsCount"];
            this.discountInvoices = _data["discountInvoices"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiscountsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeIdentifier"] = this.discountTypeIdentifier;
        data["discountType"] = this.discountType;
        data["discountsAmount"] = this.discountsAmount;
        data["discountsCount"] = this.discountsCount;
        data["discountInvoices"] = this.discountInvoices;
        return data;
    }
}
exports.GetDiscountsResponse = GetDiscountsResponse;
class GetItemGroupOrdersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemGroupOrdersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetItemGroupOrdersResponse = GetItemGroupOrdersResponse;
class GetItemGroupSalesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.invoices = _data["invoices"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemGroupSalesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["invoices"] = this.invoices;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetItemGroupSalesResponse = GetItemGroupSalesResponse;
class GetItemSalesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.invoices = _data["invoices"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemSalesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["invoices"] = this.invoices;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetItemSalesResponse = GetItemSalesResponse;
class GetItemSuperGroupsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.masterId = _data["masterId"];
            this.xeroAccountCode = _data["xeroAccountCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemSuperGroupsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["masterId"] = this.masterId;
        data["xeroAccountCode"] = this.xeroAccountCode;
        return data;
    }
}
exports.GetItemSuperGroupsResponse = GetItemSuperGroupsResponse;
class GetMasterItemsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.countingUnitId = _data["countingUnitId"];
            this.countingUnitName = _data["countingUnitName"];
            this.orderingUnitId = _data["orderingUnitId"];
            this.orderingUnitName = _data["orderingUnitName"];
            this.orderingUnitRatio = _data["orderingUnitRatio"];
            this.globalPrice = _data["globalPrice"];
            this.currentPricePurchaseOrderId = _data["currentPricePurchaseOrderId"];
            this.sharedItemSyncGlobalPrice = _data["sharedItemSyncGlobalPrice"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.defaultSupplierId = _data["defaultSupplierId"];
            this.defaultSupplierName = _data["defaultSupplierName"];
            this.masterId = _data["masterId"];
            this.defaultBrandId = _data["defaultBrandId"];
            this.defaultBrandName = _data["defaultBrandName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["countingUnitId"] = this.countingUnitId;
        data["countingUnitName"] = this.countingUnitName;
        data["orderingUnitId"] = this.orderingUnitId;
        data["orderingUnitName"] = this.orderingUnitName;
        data["orderingUnitRatio"] = this.orderingUnitRatio;
        data["globalPrice"] = this.globalPrice;
        data["currentPricePurchaseOrderId"] = this.currentPricePurchaseOrderId;
        data["sharedItemSyncGlobalPrice"] = this.sharedItemSyncGlobalPrice;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["defaultSupplierId"] = this.defaultSupplierId;
        data["defaultSupplierName"] = this.defaultSupplierName;
        data["masterId"] = this.masterId;
        data["defaultBrandId"] = this.defaultBrandId;
        data["defaultBrandName"] = this.defaultBrandName;
        return data;
    }
}
exports.GetMasterItemsResponse = GetMasterItemsResponse;
class GetOrdersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.period = _data["period"];
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["period"] = this.period;
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }
}
exports.GetOrdersResponse = GetOrdersResponse;
class GetPosItemsOrdersSummaryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosItemsOrdersSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetPosItemsOrdersSummaryResponse = GetPosItemsOrdersSummaryResponse;
class GetPosItemsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.posIdentifier = _data["posIdentifier"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.priceEx = _data["priceEx"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.revenueGroup = _data["revenueGroup"];
            this.whenDeleted = _data["whenDeleted"] ? dayjs(_data["whenDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["posIdentifier"] = this.posIdentifier;
        data["name"] = this.name;
        data["price"] = this.price;
        data["priceEx"] = this.priceEx;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["revenueGroup"] = this.revenueGroup;
        data["whenDeleted"] = this.whenDeleted ? this.whenDeleted.toISOString() : undefined;
        return data;
    }
}
exports.GetPosItemsResponse = GetPosItemsResponse;
class GetPosStaffItemOrdersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosStaffItemOrdersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetPosStaffItemOrdersResponse = GetPosStaffItemOrdersResponse;
class GetPosStaffItemSalesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.invoices = _data["invoices"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosStaffItemSalesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["invoices"] = this.invoices;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetPosStaffItemSalesResponse = GetPosStaffItemSalesResponse;
class GetPosStaffOrdersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosStaffOrdersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["amount"] = this.amount;
        return data;
    }
}
exports.GetPosStaffOrdersResponse = GetPosStaffOrdersResponse;
class GetPosStaffSalesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.invoices = _data["invoices"];
            this.invoiceTax = _data["invoiceTax"];
            this.discounts = _data["discounts"];
            this.surcharges = _data["surcharges"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosStaffSalesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["invoices"] = this.invoices;
        data["invoiceTax"] = this.invoiceTax;
        data["discounts"] = this.discounts;
        data["surcharges"] = this.surcharges;
        return data;
    }
}
exports.GetPosStaffSalesResponse = GetPosStaffSalesResponse;
class GetRefundsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.period = _data["period"];
            this.refunds = _data["refunds"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRefundsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["period"] = this.period;
        data["refunds"] = this.refunds;
        return data;
    }
}
exports.GetRefundsResponse = GetRefundsResponse;
class GetSalesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.period = _data["period"];
            this.invoices = _data["invoices"];
            this.invoicesTax = _data["invoicesTax"];
            this.discounts = _data["discounts"];
            this.surcharges = _data["surcharges"];
            this.quantity = _data["quantity"];
            this.count = _data["count"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["period"] = this.period;
        data["invoices"] = this.invoices;
        data["invoicesTax"] = this.invoicesTax;
        data["discounts"] = this.discounts;
        data["surcharges"] = this.surcharges;
        data["quantity"] = this.quantity;
        data["count"] = this.count;
        return data;
    }
}
exports.GetSalesResponse = GetSalesResponse;
class GetSalesTransactionHeadersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.posIdentifier = _data["posIdentifier"];
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : undefined;
            this.staffName = _data["staffName"];
            this.invoices = _data["invoices"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTransactionHeadersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["posIdentifier"] = this.posIdentifier;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["staffName"] = this.staffName;
        data["invoices"] = this.invoices;
        return data;
    }
}
exports.GetSalesTransactionHeadersResponse = GetSalesTransactionHeadersResponse;
class GetSalesTransactionLinesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemName = _data["itemName"];
            this.quantity = _data["quantity"];
            this.invoices = _data["invoices"];
            this.discounts = _data["discounts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTransactionLinesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemName"] = this.itemName;
        data["quantity"] = this.quantity;
        data["invoices"] = this.invoices;
        data["discounts"] = this.discounts;
        return data;
    }
}
exports.GetSalesTransactionLinesResponse = GetSalesTransactionLinesResponse;
class GetStockItemCostResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.stockCostPurchaseOrderId = _data["stockCostPurchaseOrderId"];
            this.stockCost = _data["stockCost"];
            this.stockUnitId = _data["stockUnitId"];
            this.stockUnitName = _data["stockUnitName"];
            this.stockUnitRatio = _data["stockUnitRatio"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemCostResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockCostPurchaseOrderId"] = this.stockCostPurchaseOrderId;
        data["stockCost"] = this.stockCost;
        data["stockUnitId"] = this.stockUnitId;
        data["stockUnitName"] = this.stockUnitName;
        data["stockUnitRatio"] = this.stockUnitRatio;
        return data;
    }
}
exports.GetStockItemCostResponse = GetStockItemCostResponse;
class GetStockItemGroupsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.superGroupId = _data["superGroupId"];
            this.superGroupName = _data["superGroupName"];
            this.name = _data["name"];
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemGroupsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["superGroupId"] = this.superGroupId;
        data["superGroupName"] = this.superGroupName;
        data["name"] = this.name;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.GetStockItemGroupsResponse = GetStockItemGroupsResponse;
class GetStockItemSummariesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.countingUnitId = _data["countingUnitId"];
            this.countingUnitName = _data["countingUnitName"];
            this.countingUnitRatio = _data["countingUnitRatio"];
            this.orderingUnitId = _data["orderingUnitId"];
            this.orderingUnitName = _data["orderingUnitName"];
            this.orderingUnitRatio = _data["orderingUnitRatio"];
            this.currentPrice = _data["currentPrice"];
            this.globalPrice = _data["globalPrice"];
            this.globalSalesTaxRate = _data["globalSalesTaxRate"];
            this.currentPricePurchaseOrderOrderNumber = _data["currentPricePurchaseOrderOrderNumber"];
            this.currentPricePurchaseOrderId = _data["currentPricePurchaseOrderId"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.defaultSupplierId = _data["defaultSupplierId"];
            this.defaultSupplierName = _data["defaultSupplierName"];
            this.defaultSupplierValidateStockCode = _data["defaultSupplierValidateStockCode"];
            this.defaultBrandId = _data["defaultBrandId"];
            this.defaultBrandName = _data["defaultBrandName"];
            this.masterId = _data["masterId"];
            this.isShared = _data["isShared"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockItemSummariesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["countingUnitId"] = this.countingUnitId;
        data["countingUnitName"] = this.countingUnitName;
        data["countingUnitRatio"] = this.countingUnitRatio;
        data["orderingUnitId"] = this.orderingUnitId;
        data["orderingUnitName"] = this.orderingUnitName;
        data["orderingUnitRatio"] = this.orderingUnitRatio;
        data["currentPrice"] = this.currentPrice;
        data["globalPrice"] = this.globalPrice;
        data["globalSalesTaxRate"] = this.globalSalesTaxRate;
        data["currentPricePurchaseOrderOrderNumber"] = this.currentPricePurchaseOrderOrderNumber;
        data["currentPricePurchaseOrderId"] = this.currentPricePurchaseOrderId;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["defaultSupplierId"] = this.defaultSupplierId;
        data["defaultSupplierName"] = this.defaultSupplierName;
        data["defaultSupplierValidateStockCode"] = this.defaultSupplierValidateStockCode;
        data["defaultBrandId"] = this.defaultBrandId;
        data["defaultBrandName"] = this.defaultBrandName;
        data["masterId"] = this.masterId;
        data["isShared"] = this.isShared;
        return data;
    }
}
exports.GetStockItemSummariesResponse = GetStockItemSummariesResponse;
class GetSuppliersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.masterId = _data["masterId"];
            this.customerNumber = _data["customerNumber"];
            this.lastOrderAt = _data["lastOrderAt"] ? dayjs(_data["lastOrderAt"].toString()) : undefined;
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.contactName = _data["contactName"];
            this.xeroContactId = _data["xeroContactId"];
            this.validateStockCode = _data["validateStockCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuppliersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["masterId"] = this.masterId;
        data["customerNumber"] = this.customerNumber;
        data["lastOrderAt"] = this.lastOrderAt ? this.lastOrderAt.toISOString() : undefined;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["contactName"] = this.contactName;
        data["xeroContactId"] = this.xeroContactId;
        data["validateStockCode"] = this.validateStockCode;
        return data;
    }
}
exports.GetSuppliersResponse = GetSuppliersResponse;
class GetSurchargesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.surchargeTypeIdentifier = _data["surchargeTypeIdentifier"];
            this.surchargeType = _data["surchargeType"];
            this.surchargesAmount = _data["surchargesAmount"];
            this.surchargesCount = _data["surchargesCount"];
            this.surchargeInvoices = _data["surchargeInvoices"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurchargesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["surchargeTypeIdentifier"] = this.surchargeTypeIdentifier;
        data["surchargeType"] = this.surchargeType;
        data["surchargesAmount"] = this.surchargesAmount;
        data["surchargesCount"] = this.surchargesCount;
        data["surchargeInvoices"] = this.surchargeInvoices;
        return data;
    }
}
exports.GetSurchargesResponse = GetSurchargesResponse;
class GetTableSummaryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.period = _data["period"];
            this.count = _data["count"];
            this.heads = _data["heads"];
            this.orders = _data["orders"];
            this.discounts = _data["discounts"];
            this.voids = _data["voids"];
            this.invoices = _data["invoices"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["period"] = this.period;
        data["count"] = this.count;
        data["heads"] = this.heads;
        data["orders"] = this.orders;
        data["discounts"] = this.discounts;
        data["voids"] = this.voids;
        data["invoices"] = this.invoices;
        return data;
    }
}
exports.GetTableSummaryResponse = GetTableSummaryResponse;
class GetTablesByStaffResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
            this.count = _data["count"];
            this.heads = _data["heads"];
            this.orders = _data["orders"];
            this.discounts = _data["discounts"];
            this.voids = _data["voids"];
            this.invoices = _data["invoices"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTablesByStaffResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        data["count"] = this.count;
        data["heads"] = this.heads;
        data["orders"] = this.orders;
        data["discounts"] = this.discounts;
        data["voids"] = this.voids;
        data["invoices"] = this.invoices;
        return data;
    }
}
exports.GetTablesByStaffResponse = GetTablesByStaffResponse;
class GetTenderSurchargesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tenderSurchargeName = _data["tenderSurchargeName"];
            this.tenderSurchargePosIdentifier = _data["tenderSurchargePosIdentifier"];
            this.tenderSurchargeAmount = _data["tenderSurchargeAmount"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.periodTotal = _data["periodTotal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenderSurchargesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenderSurchargeName"] = this.tenderSurchargeName;
        data["tenderSurchargePosIdentifier"] = this.tenderSurchargePosIdentifier;
        data["tenderSurchargeAmount"] = this.tenderSurchargeAmount;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["periodTotal"] = this.periodTotal;
        return data;
    }
}
exports.GetTenderSurchargesResponse = GetTenderSurchargesResponse;
class GetTendersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tenderName = _data["tenderName"];
            this.tenderPosIdentifier = _data["tenderPosIdentifier"];
            this.tenderAmount = _data["tenderAmount"];
            this.tenderIsCash = _data["tenderIsCash"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.periodTotal = _data["periodTotal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTendersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tenderName"] = this.tenderName;
        data["tenderPosIdentifier"] = this.tenderPosIdentifier;
        data["tenderAmount"] = this.tenderAmount;
        data["tenderIsCash"] = this.tenderIsCash;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["periodTotal"] = this.periodTotal;
        return data;
    }
}
exports.GetTendersResponse = GetTendersResponse;
class GetTillsReponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTillsReponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}
exports.GetTillsReponse = GetTillsReponse;
class GetTipsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.period = _data["period"];
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTipsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["period"] = this.period;
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }
}
exports.GetTipsResponse = GetTipsResponse;
class GetTopStaffItemGroupsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.invoices = _data["invoices"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStaffItemGroupsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["invoices"] = this.invoices;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.GetTopStaffItemGroupsResponse = GetTopStaffItemGroupsResponse;
class GetTopStaffVoidsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
            this.voidReason = _data["voidReason"];
            this.voidQuantity = _data["voidQuantity"];
            this.voidAmount = _data["voidAmount"];
            this.wasteQuantity = _data["wasteQuantity"];
            this.wasteAmount = _data["wasteAmount"];
            this.transactions = _data["transactions"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStaffVoidsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        data["voidReason"] = this.voidReason;
        data["voidQuantity"] = this.voidQuantity;
        data["voidAmount"] = this.voidAmount;
        data["wasteQuantity"] = this.wasteQuantity;
        data["wasteAmount"] = this.wasteAmount;
        data["transactions"] = this.transactions;
        return data;
    }
}
exports.GetTopStaffVoidsResponse = GetTopStaffVoidsResponse;
class GetTransactionHeadersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.posIdentifier = _data["posIdentifier"];
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : undefined;
            this.staffName = _data["staffName"];
            this.orderAmount = _data["orderAmount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionHeadersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["posIdentifier"] = this.posIdentifier;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["staffName"] = this.staffName;
        data["orderAmount"] = this.orderAmount;
        return data;
    }
}
exports.GetTransactionHeadersResponse = GetTransactionHeadersResponse;
class GetTransactionLinesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemName = _data["itemName"];
            this.quantity = _data["quantity"];
            this.orderAmount = _data["orderAmount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionLinesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemName"] = this.itemName;
        data["quantity"] = this.quantity;
        data["orderAmount"] = this.orderAmount;
        return data;
    }
}
exports.GetTransactionLinesResponse = GetTransactionLinesResponse;
class HostString {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
            this.host = _data["host"];
            this.port = _data["port"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HostString();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        data["host"] = this.host;
        data["port"] = this.port;
        return data;
    }
}
exports.HostString = HostString;
class HttpContext {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["features"])) {
                this.features = [];
                for (let item of _data["features"])
                    this.features.push(TypeObjectKeyValuePair.fromJS(item));
            }
            this.request = _data["request"] ? HttpRequest.fromJS(_data["request"]) : undefined;
            this.response = _data["response"] ? HttpResponse.fromJS(_data["response"]) : undefined;
            this.connection = _data["connection"] ? ConnectionInfo.fromJS(_data["connection"]) : undefined;
            this.webSockets = _data["webSockets"] ? WebSocketManager.fromJS(_data["webSockets"]) : undefined;
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : undefined;
            if (_data["items"]) {
                this.items = {};
                for (let key in _data["items"]) {
                    if (_data["items"].hasOwnProperty(key))
                        this.items[key] = _data["items"][key];
                }
            }
            this.requestServices = _data["requestServices"] ? IServiceProvider.fromJS(_data["requestServices"]) : undefined;
            this.requestAborted = _data["requestAborted"] ? CancellationToken.fromJS(_data["requestAborted"]) : undefined;
            this.traceIdentifier = _data["traceIdentifier"];
            this.session = _data["session"] ? ISession.fromJS(_data["session"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContext();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : undefined;
        data["response"] = this.response ? this.response.toJSON() : undefined;
        data["connection"] = this.connection ? this.connection.toJSON() : undefined;
        data["webSockets"] = this.webSockets ? this.webSockets.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (this.items) {
            data["items"] = {};
            for (let key in this.items) {
                if (this.items.hasOwnProperty(key))
                    data["items"][key] = this.items[key];
            }
        }
        data["requestServices"] = this.requestServices ? this.requestServices.toJSON() : undefined;
        data["requestAborted"] = this.requestAborted ? this.requestAborted.toJSON() : undefined;
        data["traceIdentifier"] = this.traceIdentifier;
        data["session"] = this.session ? this.session.toJSON() : undefined;
        return data;
    }
}
exports.HttpContext = HttpContext;
class HttpRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.httpContext = _data["httpContext"] ? HttpContext.fromJS(_data["httpContext"]) : undefined;
            this.method = _data["method"];
            this.scheme = _data["scheme"];
            this.isHttps = _data["isHttps"];
            this.host = _data["host"] ? HostString.fromJS(_data["host"]) : undefined;
            this.pathBase = _data["pathBase"] ? PathString.fromJS(_data["pathBase"]) : undefined;
            this.path = _data["path"] ? PathString.fromJS(_data["path"]) : undefined;
            this.queryString = _data["queryString"] ? QueryString.fromJS(_data["queryString"]) : undefined;
            if (Array.isArray(_data["query"])) {
                this.query = [];
                for (let item of _data["query"])
                    this.query.push(StringStringValuesKeyValuePair.fromJS(item));
            }
            this.protocol = _data["protocol"];
            if (_data["headers"]) {
                this.headers = {};
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        this.headers[key] = _data["headers"][key] !== undefined ? _data["headers"][key] : [];
                }
            }
            if (Array.isArray(_data["cookies"])) {
                this.cookies = [];
                for (let item of _data["cookies"])
                    this.cookies.push(StringStringKeyValuePair.fromJS(item));
            }
            this.contentLength = _data["contentLength"];
            this.contentType = _data["contentType"];
            this.body = _data["body"];
            this.bodyReader = _data["bodyReader"];
            this.hasFormContentType = _data["hasFormContentType"];
            if (Array.isArray(_data["form"])) {
                this.form = [];
                for (let item of _data["form"])
                    this.form.push(StringStringValuesKeyValuePair.fromJS(item));
            }
            if (_data["routeValues"]) {
                this.routeValues = {};
                for (let key in _data["routeValues"]) {
                    if (_data["routeValues"].hasOwnProperty(key))
                        this.routeValues[key] = _data["routeValues"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["httpContext"] = this.httpContext ? this.httpContext.toJSON() : undefined;
        data["method"] = this.method;
        data["scheme"] = this.scheme;
        data["isHttps"] = this.isHttps;
        data["host"] = this.host ? this.host.toJSON() : undefined;
        data["pathBase"] = this.pathBase ? this.pathBase.toJSON() : undefined;
        data["path"] = this.path ? this.path.toJSON() : undefined;
        data["queryString"] = this.queryString ? this.queryString.toJSON() : undefined;
        if (Array.isArray(this.query)) {
            data["query"] = [];
            for (let item of this.query)
                data["query"].push(item.toJSON());
        }
        data["protocol"] = this.protocol;
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        if (Array.isArray(this.cookies)) {
            data["cookies"] = [];
            for (let item of this.cookies)
                data["cookies"].push(item.toJSON());
        }
        data["contentLength"] = this.contentLength;
        data["contentType"] = this.contentType;
        data["body"] = this.body;
        data["bodyReader"] = this.bodyReader;
        data["hasFormContentType"] = this.hasFormContentType;
        if (Array.isArray(this.form)) {
            data["form"] = [];
            for (let item of this.form)
                data["form"].push(item.toJSON());
        }
        if (this.routeValues) {
            data["routeValues"] = {};
            for (let key in this.routeValues) {
                if (this.routeValues.hasOwnProperty(key))
                    data["routeValues"][key] = this.routeValues[key];
            }
        }
        return data;
    }
}
exports.HttpRequest = HttpRequest;
class HttpResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.httpContext = _data["httpContext"] ? HttpContext.fromJS(_data["httpContext"]) : undefined;
            this.statusCode = _data["statusCode"];
            if (_data["headers"]) {
                this.headers = {};
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        this.headers[key] = _data["headers"][key] !== undefined ? _data["headers"][key] : [];
                }
            }
            this.body = _data["body"];
            this.bodyWriter = _data["bodyWriter"] ? PipeWriter.fromJS(_data["bodyWriter"]) : undefined;
            this.contentLength = _data["contentLength"];
            this.contentType = _data["contentType"];
            this.cookies = _data["cookies"] ? IResponseCookies.fromJS(_data["cookies"]) : undefined;
            this.hasStarted = _data["hasStarted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["httpContext"] = this.httpContext ? this.httpContext.toJSON() : undefined;
        data["statusCode"] = this.statusCode;
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["body"] = this.body;
        data["bodyWriter"] = this.bodyWriter ? this.bodyWriter.toJSON() : undefined;
        data["contentLength"] = this.contentLength;
        data["contentType"] = this.contentType;
        data["cookies"] = this.cookies ? this.cookies.toJSON() : undefined;
        data["hasStarted"] = this.hasStarted;
        return data;
    }
}
exports.HttpResponse = HttpResponse;
class IBasePayloadModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IBasePayloadModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IBasePayloadModel = IBasePayloadModel;
class IComputeQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IComputeQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IComputeQueryValidator = IComputeQueryValidator;
class IContractResolver {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IContractResolver();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IContractResolver = IContractResolver;
class ICountQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ICountQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ICountQueryValidator = ICountQueryValidator;
class ICustomAttributeProvider {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ICustomAttributeProvider = ICustomAttributeProvider;
class IEdmDirectValueAnnotationsManager {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmDirectValueAnnotationsManager();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IEdmDirectValueAnnotationsManager = IEdmDirectValueAnnotationsManager;
class IEdmEntityContainer {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.schemaElementKind = _data["schemaElementKind"];
            this.namespace = _data["namespace"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [];
                for (let item of _data["elements"])
                    this.elements.push(IEdmEntityContainerElement.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmEntityContainer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}
exports.IEdmEntityContainer = IEdmEntityContainer;
class IEdmEntityContainerElement {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.containerElementKind = _data["containerElementKind"];
            this.container = _data["container"] ? IEdmEntityContainer.fromJS(_data["container"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmEntityContainerElement();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["containerElementKind"] = this.containerElementKind;
        data["container"] = this.container ? this.container.toJSON() : undefined;
        return data;
    }
}
exports.IEdmEntityContainerElement = IEdmEntityContainerElement;
class IEdmExpression {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expressionKind = _data["expressionKind"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmExpression();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expressionKind"] = this.expressionKind;
        return data;
    }
}
exports.IEdmExpression = IEdmExpression;
class IEdmModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["schemaElements"])) {
                this.schemaElements = [];
                for (let item of _data["schemaElements"])
                    this.schemaElements.push(IEdmSchemaElement.fromJS(item));
            }
            if (Array.isArray(_data["vocabularyAnnotations"])) {
                this.vocabularyAnnotations = [];
                for (let item of _data["vocabularyAnnotations"])
                    this.vocabularyAnnotations.push(IEdmVocabularyAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["referencedModels"])) {
                this.referencedModels = [];
                for (let item of _data["referencedModels"])
                    this.referencedModels.push(IEdmModel.fromJS(item));
            }
            if (Array.isArray(_data["declaredNamespaces"])) {
                this.declaredNamespaces = [];
                for (let item of _data["declaredNamespaces"])
                    this.declaredNamespaces.push(item);
            }
            this.directValueAnnotationsManager = _data["directValueAnnotationsManager"] ? IEdmDirectValueAnnotationsManager.fromJS(_data["directValueAnnotationsManager"]) : undefined;
            this.entityContainer = _data["entityContainer"] ? IEdmEntityContainer.fromJS(_data["entityContainer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schemaElements)) {
            data["schemaElements"] = [];
            for (let item of this.schemaElements)
                data["schemaElements"].push(item.toJSON());
        }
        if (Array.isArray(this.vocabularyAnnotations)) {
            data["vocabularyAnnotations"] = [];
            for (let item of this.vocabularyAnnotations)
                data["vocabularyAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.referencedModels)) {
            data["referencedModels"] = [];
            for (let item of this.referencedModels)
                data["referencedModels"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNamespaces)) {
            data["declaredNamespaces"] = [];
            for (let item of this.declaredNamespaces)
                data["declaredNamespaces"].push(item);
        }
        data["directValueAnnotationsManager"] = this.directValueAnnotationsManager ? this.directValueAnnotationsManager.toJSON() : undefined;
        data["entityContainer"] = this.entityContainer ? this.entityContainer.toJSON() : undefined;
        return data;
    }
}
exports.IEdmModel = IEdmModel;
class IEdmNavigationProperty {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.propertyKind = _data["propertyKind"];
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : undefined;
            this.declaringType = _data["declaringType"] ? IEdmStructuredType.fromJS(_data["declaringType"]) : undefined;
            this.partner = _data["partner"] ? IEdmNavigationProperty.fromJS(_data["partner"]) : undefined;
            this.onDelete = _data["onDelete"];
            this.containsTarget = _data["containsTarget"];
            this.referentialConstraint = _data["referentialConstraint"] ? IEdmReferentialConstraint.fromJS(_data["referentialConstraint"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmNavigationProperty();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["propertyKind"] = this.propertyKind;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["onDelete"] = this.onDelete;
        data["containsTarget"] = this.containsTarget;
        data["referentialConstraint"] = this.referentialConstraint ? this.referentialConstraint.toJSON() : undefined;
        return data;
    }
}
exports.IEdmNavigationProperty = IEdmNavigationProperty;
class IEdmNavigationPropertyBinding {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.navigationProperty = _data["navigationProperty"] ? IEdmNavigationProperty.fromJS(_data["navigationProperty"]) : undefined;
            this.target = _data["target"] ? IEdmNavigationSource.fromJS(_data["target"]) : undefined;
            this.path = _data["path"] ? IEdmPathExpression.fromJS(_data["path"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmNavigationPropertyBinding();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["navigationProperty"] = this.navigationProperty ? this.navigationProperty.toJSON() : undefined;
        data["target"] = this.target ? this.target.toJSON() : undefined;
        data["path"] = this.path ? this.path.toJSON() : undefined;
        return data;
    }
}
exports.IEdmNavigationPropertyBinding = IEdmNavigationPropertyBinding;
class IEdmNavigationSource {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["navigationPropertyBindings"])) {
                this.navigationPropertyBindings = [];
                for (let item of _data["navigationPropertyBindings"])
                    this.navigationPropertyBindings.push(IEdmNavigationPropertyBinding.fromJS(item));
            }
            this.path = _data["path"] ? IEdmPathExpression.fromJS(_data["path"]) : undefined;
            this.type = _data["type"] ? IEdmType.fromJS(_data["type"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmNavigationSource();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.navigationPropertyBindings)) {
            data["navigationPropertyBindings"] = [];
            for (let item of this.navigationPropertyBindings)
                data["navigationPropertyBindings"].push(item.toJSON());
        }
        data["path"] = this.path ? this.path.toJSON() : undefined;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        return data;
    }
}
exports.IEdmNavigationSource = IEdmNavigationSource;
class IEdmPathExpression {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expressionKind = _data["expressionKind"];
            if (Array.isArray(_data["pathSegments"])) {
                this.pathSegments = [];
                for (let item of _data["pathSegments"])
                    this.pathSegments.push(item);
            }
            this.path = _data["path"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmPathExpression();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expressionKind"] = this.expressionKind;
        if (Array.isArray(this.pathSegments)) {
            data["pathSegments"] = [];
            for (let item of this.pathSegments)
                data["pathSegments"].push(item);
        }
        data["path"] = this.path;
        return data;
    }
}
exports.IEdmPathExpression = IEdmPathExpression;
class IEdmProperty {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.propertyKind = _data["propertyKind"];
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : undefined;
            this.declaringType = _data["declaringType"] ? IEdmStructuredType.fromJS(_data["declaringType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmProperty();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["propertyKind"] = this.propertyKind;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        return data;
    }
}
exports.IEdmProperty = IEdmProperty;
class IEdmReferentialConstraint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["propertyPairs"])) {
                this.propertyPairs = [];
                for (let item of _data["propertyPairs"])
                    this.propertyPairs.push(EdmReferentialConstraintPropertyPair.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmReferentialConstraint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propertyPairs)) {
            data["propertyPairs"] = [];
            for (let item of this.propertyPairs)
                data["propertyPairs"].push(item.toJSON());
        }
        return data;
    }
}
exports.IEdmReferentialConstraint = IEdmReferentialConstraint;
class IEdmSchemaElement {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.schemaElementKind = _data["schemaElementKind"];
            this.namespace = _data["namespace"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmSchemaElement();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        return data;
    }
}
exports.IEdmSchemaElement = IEdmSchemaElement;
class IEdmStructuralProperty {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.propertyKind = _data["propertyKind"];
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : undefined;
            this.declaringType = _data["declaringType"] ? IEdmStructuredType.fromJS(_data["declaringType"]) : undefined;
            this.defaultValueString = _data["defaultValueString"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmStructuralProperty();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["propertyKind"] = this.propertyKind;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["defaultValueString"] = this.defaultValueString;
        return data;
    }
}
exports.IEdmStructuralProperty = IEdmStructuralProperty;
class IEdmStructuredType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.typeKind = _data["typeKind"];
            this.isAbstract = _data["isAbstract"];
            this.isOpen = _data["isOpen"];
            this.baseType = _data["baseType"] ? IEdmStructuredType.fromJS(_data["baseType"]) : undefined;
            if (Array.isArray(_data["declaredProperties"])) {
                this.declaredProperties = [];
                for (let item of _data["declaredProperties"])
                    this.declaredProperties.push(IEdmProperty.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmStructuredType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["typeKind"] = this.typeKind;
        data["isAbstract"] = this.isAbstract;
        data["isOpen"] = this.isOpen;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined;
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        return data;
    }
}
exports.IEdmStructuredType = IEdmStructuredType;
class IEdmTerm {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.schemaElementKind = _data["schemaElementKind"];
            this.namespace = _data["namespace"];
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : undefined;
            this.appliesTo = _data["appliesTo"];
            this.defaultValue = _data["defaultValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmTerm();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["appliesTo"] = this.appliesTo;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}
exports.IEdmTerm = IEdmTerm;
class IEdmType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.typeKind = _data["typeKind"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["typeKind"] = this.typeKind;
        return data;
    }
}
exports.IEdmType = IEdmType;
class IEdmTypeReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isNullable = _data["isNullable"];
            this.definition = _data["definition"] ? IEdmType.fromJS(_data["definition"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmTypeReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isNullable"] = this.isNullable;
        data["definition"] = this.definition ? this.definition.toJSON() : undefined;
        return data;
    }
}
exports.IEdmTypeReference = IEdmTypeReference;
class IEdmVocabularyAnnotatable {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmVocabularyAnnotatable();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IEdmVocabularyAnnotatable = IEdmVocabularyAnnotatable;
class IEdmVocabularyAnnotation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.term = _data["term"] ? IEdmTerm.fromJS(_data["term"]) : undefined;
            this.target = _data["target"] ? IEdmVocabularyAnnotatable.fromJS(_data["target"]) : undefined;
            this.value = _data["value"] ? IEdmExpression.fromJS(_data["value"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IEdmVocabularyAnnotation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["term"] = this.term ? this.term.toJSON() : undefined;
        data["target"] = this.target ? this.target.toJSON() : undefined;
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    }
}
exports.IEdmVocabularyAnnotation = IEdmVocabularyAnnotation;
class IFilterQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IFilterQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IFilterQueryValidator = IFilterQueryValidator;
class IGetTableSummaryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.count = _data["count"];
            this.discounts = _data["discounts"];
            this.heads = _data["heads"];
            this.invoices = _data["invoices"];
            this.orders = _data["orders"];
            this.period = _data["period"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.voids = _data["voids"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IGetTableSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["discounts"] = this.discounts;
        data["heads"] = this.heads;
        data["invoices"] = this.invoices;
        data["orders"] = this.orders;
        data["period"] = this.period;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["voids"] = this.voids;
        return data;
    }
}
exports.IGetTableSummaryResponse = IGetTableSummaryResponse;
class IGetVoidsByReasonResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.voidReason = _data["voidReason"];
            this.voidQuantity = _data["voidQuantity"];
            this.voidAmount = _data["voidAmount"];
            this.wasteQuantity = _data["wasteQuantity"];
            this.wasteAmount = _data["wasteAmount"];
            this.transactions = _data["transactions"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IGetVoidsByReasonResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["voidReason"] = this.voidReason;
        data["voidQuantity"] = this.voidQuantity;
        data["voidAmount"] = this.voidAmount;
        data["wasteQuantity"] = this.wasteQuantity;
        data["wasteAmount"] = this.wasteAmount;
        data["transactions"] = this.transactions;
        return data;
    }
}
exports.IGetVoidsByReasonResponse = IGetVoidsByReasonResponse;
class IGetVoidsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.invoices = _data["invoices"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.transactions = _data["transactions"];
            this.voidAmount = _data["voidAmount"];
            this.voidQuantity = _data["voidQuantity"];
            this.voidReason = _data["voidReason"];
            this.wasteAmount = _data["wasteAmount"];
            this.wasteQuantity = _data["wasteQuantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IGetVoidsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["invoices"] = this.invoices;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["transactions"] = this.transactions;
        data["voidAmount"] = this.voidAmount;
        data["voidQuantity"] = this.voidQuantity;
        data["voidReason"] = this.voidReason;
        data["wasteAmount"] = this.wasteAmount;
        data["wasteQuantity"] = this.wasteQuantity;
        return data;
    }
}
exports.IGetVoidsResponse = IGetVoidsResponse;
class IIdentity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IIdentity();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        return data;
    }
}
exports.IIdentity = IIdentity;
class IODataQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IODataQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IODataQueryValidator = IODataQueryValidator;
class IOrderByQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderByQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IOrderByQueryValidator = IOrderByQueryValidator;
class IPAddress {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressFamily = _data["addressFamily"];
            this.scopeId = _data["scopeId"];
            this.isIPv6Multicast = _data["isIPv6Multicast"];
            this.isIPv6LinkLocal = _data["isIPv6LinkLocal"];
            this.isIPv6SiteLocal = _data["isIPv6SiteLocal"];
            this.isIPv6Teredo = _data["isIPv6Teredo"];
            this.isIPv6UniqueLocal = _data["isIPv6UniqueLocal"];
            this.isIPv4MappedToIPv6 = _data["isIPv4MappedToIPv6"];
            this.address = _data["address"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IPAddress();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressFamily"] = this.addressFamily;
        data["scopeId"] = this.scopeId;
        data["isIPv6Multicast"] = this.isIPv6Multicast;
        data["isIPv6LinkLocal"] = this.isIPv6LinkLocal;
        data["isIPv6SiteLocal"] = this.isIPv6SiteLocal;
        data["isIPv6Teredo"] = this.isIPv6Teredo;
        data["isIPv6UniqueLocal"] = this.isIPv6UniqueLocal;
        data["isIPv4MappedToIPv6"] = this.isIPv4MappedToIPv6;
        data["address"] = this.address;
        return data;
    }
}
exports.IPAddress = IPAddress;
class IResponseCookies {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IResponseCookies();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IResponseCookies = IResponseCookies;
class ISelectExpandQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ISelectExpandQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ISelectExpandQueryValidator = ISelectExpandQueryValidator;
class IServiceProvider {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IServiceProvider();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IServiceProvider = IServiceProvider;
class ISession {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
            this.id = _data["id"];
            if (Array.isArray(_data["keys"])) {
                this.keys = [];
                for (let item of _data["keys"])
                    this.keys.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ISession();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        data["id"] = this.id;
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item);
        }
        return data;
    }
}
exports.ISession = ISession;
class ISkipQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ISkipQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ISkipQueryValidator = ISkipQueryValidator;
class ISkipTokenQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ISkipTokenQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ISkipTokenQueryValidator = ISkipTokenQueryValidator;
class IStaffMemberRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.defaultRoleId = _data["defaultRoleId"];
            if (Array.isArray(_data["memberRoles"])) {
                this.memberRoles = [];
                for (let item of _data["memberRoles"])
                    this.memberRoles.push(StaffMemberRoleRequestModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IStaffMemberRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultRoleId"] = this.defaultRoleId;
        if (Array.isArray(this.memberRoles)) {
            data["memberRoles"] = [];
            for (let item of this.memberRoles)
                data["memberRoles"].push(item.toJSON());
        }
        return data;
    }
}
exports.IStaffMemberRequest = IStaffMemberRequest;
class ITopQueryValidator {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ITopQueryValidator();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.ITopQueryValidator = ITopQueryValidator;
class InboundEmailAttachment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.data = _data["data"];
            this.filename = _data["filename"];
            this.name = _data["name"];
            this.contentId = _data["content-id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InboundEmailAttachment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["data"] = this.data;
        data["filename"] = this.filename;
        data["name"] = this.name;
        data["content-id"] = this.contentId;
        return data;
    }
}
exports.InboundEmailAttachment = InboundEmailAttachment;
class IntPtr {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.IntPtr = IntPtr;
class ItemGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.superGroupId = _data["superGroupId"];
            this.superGroupName = _data["superGroupName"];
            this.name = _data["name"];
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["superGroupId"] = this.superGroupId;
        data["superGroupName"] = this.superGroupName;
        data["name"] = this.name;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.ItemGroupModel = ItemGroupModel;
class ItemJsonPatchDocument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [];
                for (let item of _data["operations"])
                    this.operations.push(ItemOperation.fromJS(item));
            }
            this.contractResolver = _data["contractResolver"] ? IContractResolver.fromJS(_data["contractResolver"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemJsonPatchDocument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        data["contractResolver"] = this.contractResolver ? this.contractResolver.toJSON() : undefined;
        return data;
    }
}
exports.ItemJsonPatchDocument = ItemJsonPatchDocument;
class ItemModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.countingUnitId = _data["countingUnitId"];
            this.countingUnitName = _data["countingUnitName"];
            this.orderingUnitId = _data["orderingUnitId"];
            this.orderingUnitName = _data["orderingUnitName"];
            this.orderingUnitRatio = _data["orderingUnitRatio"];
            this.globalPrice = _data["globalPrice"];
            this.currentPrice = _data["currentPrice"];
            this.globalSalesTaxRate = _data["globalSalesTaxRate"];
            this.currentPricePurchaseOrderId = _data["currentPricePurchaseOrderId"];
            this.sharedItemSyncGlobalPrice = _data["sharedItemSyncGlobalPrice"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.defaultSupplierId = _data["defaultSupplierId"];
            this.defaultSupplierName = _data["defaultSupplierName"];
            this.masterId = _data["masterId"];
            this.defaultBrandId = _data["defaultBrandId"];
            this.defaultBrandName = _data["defaultBrandName"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [];
                for (let item of _data["suppliers"])
                    this.suppliers.push(ItemSupplierModel.fromJS(item));
            }
            this.isShared = _data["isShared"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["countingUnitId"] = this.countingUnitId;
        data["countingUnitName"] = this.countingUnitName;
        data["orderingUnitId"] = this.orderingUnitId;
        data["orderingUnitName"] = this.orderingUnitName;
        data["orderingUnitRatio"] = this.orderingUnitRatio;
        data["globalPrice"] = this.globalPrice;
        data["currentPrice"] = this.currentPrice;
        data["globalSalesTaxRate"] = this.globalSalesTaxRate;
        data["currentPricePurchaseOrderId"] = this.currentPricePurchaseOrderId;
        data["sharedItemSyncGlobalPrice"] = this.sharedItemSyncGlobalPrice;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["defaultSupplierId"] = this.defaultSupplierId;
        data["defaultSupplierName"] = this.defaultSupplierName;
        data["masterId"] = this.masterId;
        data["defaultBrandId"] = this.defaultBrandId;
        data["defaultBrandName"] = this.defaultBrandName;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        data["isShared"] = this.isShared;
        return data;
    }
}
exports.ItemModel = ItemModel;
class ItemOperation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemOperation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        data["value"] = this.value;
        return data;
    }
}
exports.ItemOperation = ItemOperation;
class ItemRevenueGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.revenueGroupName = _data["revenueGroupName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRevenueGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["revenueGroupName"] = this.revenueGroupName;
        return data;
    }
}
exports.ItemRevenueGroupModel = ItemRevenueGroupModel;
class ItemSupplierModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.stockItemId = _data["stockItemId"];
            this.stockItemName = _data["stockItemName"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.brandId = _data["brandId"];
            this.brandName = _data["brandName"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.unitRatio = _data["unitRatio"];
            this.unitCost = _data["unitCost"];
            this.stockCode = _data["stockCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSupplierModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockItemId"] = this.stockItemId;
        data["stockItemName"] = this.stockItemName;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["brandId"] = this.brandId;
        data["brandName"] = this.brandName;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["unitRatio"] = this.unitRatio;
        data["unitCost"] = this.unitCost;
        data["stockCode"] = this.stockCode;
        return data;
    }
}
exports.ItemSupplierModel = ItemSupplierModel;
class ItemsRevenueGroupModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["posItemIds"])) {
                this.posItemIds = [];
                for (let item of _data["posItemIds"])
                    this.posItemIds.push(item);
            }
            this.revenueGroupName = _data["revenueGroupName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemsRevenueGroupModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.posItemIds)) {
            data["posItemIds"] = [];
            for (let item of this.posItemIds)
                data["posItemIds"].push(item);
        }
        data["revenueGroupName"] = this.revenueGroupName;
        return data;
    }
}
exports.ItemsRevenueGroupModel = ItemsRevenueGroupModel;
class KeySizes {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.minSize = _data["minSize"];
            this.maxSize = _data["maxSize"];
            this.skipSize = _data["skipSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new KeySizes();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["minSize"] = this.minSize;
        data["maxSize"] = this.maxSize;
        data["skipSize"] = this.skipSize;
        return data;
    }
}
exports.KeySizes = KeySizes;
var KiwisaverStatus;
(function (KiwisaverStatus) {
    KiwisaverStatus[KiwisaverStatus["ActiveMember"] = "ActiveMember"] = "ActiveMember";
    KiwisaverStatus[KiwisaverStatus["AutomaticallyEnrolled"] = "AutomaticallyEnrolled"] = "AutomaticallyEnrolled";
    KiwisaverStatus[KiwisaverStatus["OptedIn"] = "OptedIn"] = "OptedIn";
    KiwisaverStatus[KiwisaverStatus["EmployedForLessThan28Days"] = "EmployedForLessThan28Days"] = "EmployedForLessThan28Days";
    KiwisaverStatus[KiwisaverStatus["NotRequiredToBeAutomaticallyEnrolled"] = "NotRequiredToBeAutomaticallyEnrolled"] = "NotRequiredToBeAutomaticallyEnrolled";
    KiwisaverStatus[KiwisaverStatus["NotEligible"] = "NotEligible"] = "NotEligible";
})(KiwisaverStatus || (exports.KiwisaverStatus = KiwisaverStatus = {}));
var LayoutKind;
(function (LayoutKind) {
    LayoutKind[LayoutKind["_0"] = 0] = "_0";
    LayoutKind[LayoutKind["_2"] = 2] = "_2";
    LayoutKind[LayoutKind["_3"] = 3] = "_3";
})(LayoutKind || (exports.LayoutKind = LayoutKind = {}));
class LeaveRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.actions = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.startDateTime = _data["startDateTime"] ? dayjs(_data["startDateTime"].toString()) : undefined;
            this.endDateTime = _data["endDateTime"] ? dayjs(_data["endDateTime"].toString()) : undefined;
            this.reason = _data["reason"];
            this.automaticallyApprove = _data["automaticallyApprove"];
            this.status = _data["status"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(Action.fromJS(item));
            }
            this.isStartAllDay = _data["isStartAllDay"];
            this.isEndAllDay = _data["isEndAllDay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["leaveTypeId"] = this.leaveTypeId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined;
        data["reason"] = this.reason;
        data["automaticallyApprove"] = this.automaticallyApprove;
        data["status"] = this.status;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["isStartAllDay"] = this.isStartAllDay;
        data["isEndAllDay"] = this.isEndAllDay;
        return data;
    }
}
exports.LeaveRequest = LeaveRequest;
class LeaveRequestUpdateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRequestUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}
exports.LeaveRequestUpdateRequest = LeaveRequestUpdateRequest;
class LeaveType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isPaid = _data["isPaid"];
            this.salaryReduceNormalCost = _data["salaryReduceNormalCost"];
            this.automaticApproval = _data["automaticApproval"];
            this.showOnFinancialReports = _data["showOnFinancialReports"];
            this.type = _data["type"];
            this.percentage = _data["percentage"];
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.activation = _data["activation"] ? ActivatedLeaveType.fromJS(_data["activation"]) : undefined;
            this.conditions = _data["conditions"] ? LeaveTypeConditions.fromJS(_data["conditions"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isPaid"] = this.isPaid;
        data["salaryReduceNormalCost"] = this.salaryReduceNormalCost;
        data["automaticApproval"] = this.automaticApproval;
        data["showOnFinancialReports"] = this.showOnFinancialReports;
        data["type"] = this.type;
        data["percentage"] = this.percentage;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["activation"] = this.activation ? this.activation.toJSON() : undefined;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : undefined;
        return data;
    }
}
exports.LeaveType = LeaveType;
class LeaveTypeConditions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.employees = _data["employees"] ? EmployeeMatchPayload.fromJS(_data["employees"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypeConditions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["employees"] = this.employees ? this.employees.toJSON() : undefined;
        return data;
    }
}
exports.LeaveTypeConditions = LeaveTypeConditions;
class ListRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.pattern = _data["pattern"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined;
            this.parserType = _data["parserType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pattern"] = this.pattern;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined;
        data["parserType"] = this.parserType;
        return data;
    }
}
exports.ListRule = ListRule;
var LoadedActionType;
(function (LoadedActionType) {
    LoadedActionType[LoadedActionType["Requested"] = "Requested"] = "Requested";
    LoadedActionType[LoadedActionType["Approved"] = "Approved"] = "Approved";
    LoadedActionType[LoadedActionType["Declined"] = "Declined"] = "Declined";
    LoadedActionType[LoadedActionType["Cancelled"] = "Cancelled"] = "Cancelled";
    LoadedActionType[LoadedActionType["Updated"] = "Updated"] = "Updated";
})(LoadedActionType || (exports.LoadedActionType = LoadedActionType = {}));
var LoadedLeaveRequestStatus;
(function (LoadedLeaveRequestStatus) {
    LoadedLeaveRequestStatus[LoadedLeaveRequestStatus["Requested"] = "Requested"] = "Requested";
    LoadedLeaveRequestStatus[LoadedLeaveRequestStatus["Approved"] = "Approved"] = "Approved";
    LoadedLeaveRequestStatus[LoadedLeaveRequestStatus["Cancelled"] = "Cancelled"] = "Cancelled";
    LoadedLeaveRequestStatus[LoadedLeaveRequestStatus["Declined"] = "Declined"] = "Declined";
})(LoadedLeaveRequestStatus || (exports.LoadedLeaveRequestStatus = LoadedLeaveRequestStatus = {}));
var LoadedLeaveTypeType;
(function (LoadedLeaveTypeType) {
    LoadedLeaveTypeType[LoadedLeaveTypeType["Managed"] = "Managed"] = "Managed";
    LoadedLeaveTypeType[LoadedLeaveTypeType["Custom"] = "Custom"] = "Custom";
})(LoadedLeaveTypeType || (exports.LoadedLeaveTypeType = LoadedLeaveTypeType = {}));
class LoadedPayRun {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.payrollSystemCompanyId = _data["payrollSystemCompanyId"];
            this.periodStartDate = _data["periodStartDate"] ? dayjs(_data["periodStartDate"].toString()) : undefined;
            this.periodEndDate = _data["periodEndDate"] ? dayjs(_data["periodEndDate"].toString()) : undefined;
            this.paymentDate = _data["paymentDate"] ? dayjs(_data["paymentDate"].toString()) : undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [];
                for (let item of _data["employees"])
                    this.employees.push(LoadedPayRunEmployee.fromJS(item));
            }
            if (Array.isArray(_data["payslips"])) {
                this.payslips = [];
                for (let item of _data["payslips"])
                    this.payslips.push(LoadedPayRunPayslip.fromJS(item));
            }
            this.payslipMessage = _data["payslipMessage"];
            this.employeesWorked = _data["employeesWorked"];
            this.loadedPay = _data["loadedPay"];
            this.employeesPaid = _data["employeesPaid"];
            this.payrollPay = _data["payrollPay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoadedPayRun();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payrollSystemCompanyId"] = this.payrollSystemCompanyId;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toISOString() : undefined;
        data["periodEndDate"] = this.periodEndDate ? this.periodEndDate.toISOString() : undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined;
        data["status"] = this.status;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        if (Array.isArray(this.payslips)) {
            data["payslips"] = [];
            for (let item of this.payslips)
                data["payslips"].push(item.toJSON());
        }
        data["payslipMessage"] = this.payslipMessage;
        data["employeesWorked"] = this.employeesWorked;
        data["loadedPay"] = this.loadedPay;
        data["employeesPaid"] = this.employeesPaid;
        data["payrollPay"] = this.payrollPay;
        return data;
    }
}
exports.LoadedPayRun = LoadedPayRun;
class LoadedPayRunEmployee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.loadedWages = _data["loadedWages"];
            this.payrollSystemWages = _data["payrollSystemWages"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoadedPayRunEmployee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["loadedWages"] = this.loadedWages;
        data["payrollSystemWages"] = this.payrollSystemWages;
        data["status"] = this.status;
        return data;
    }
}
exports.LoadedPayRunEmployee = LoadedPayRunEmployee;
class LoadedPayRunPayslip {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.payslipId = _data["payslipId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.totalCost = _data["totalCost"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoadedPayRunPayslip();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["payslipId"] = this.payslipId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["totalCost"] = this.totalCost;
        return data;
    }
}
exports.LoadedPayRunPayslip = LoadedPayRunPayslip;
class LoadedPreferredHours {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoadedPreferredHours();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}
exports.LoadedPreferredHours = LoadedPreferredHours;
var LoadedRevenueGroup;
(function (LoadedRevenueGroup) {
    LoadedRevenueGroup[LoadedRevenueGroup["_0"] = 0] = "_0";
    LoadedRevenueGroup[LoadedRevenueGroup["_1"] = 1] = "_1";
    LoadedRevenueGroup[LoadedRevenueGroup["_2"] = 2] = "_2";
})(LoadedRevenueGroup || (exports.LoadedRevenueGroup = LoadedRevenueGroup = {}));
class LoadedSubscriptionModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.product = _data["product"] ? SubscriptionProductModel.fromJS(_data["product"]) : undefined;
            this.stateCode = _data["stateCode"];
            this.state = _data["state"];
            this.paymentCollectionMethodCode = _data["paymentCollectionMethodCode"];
            this.paymentCollectionMethod = _data["paymentCollectionMethod"];
            this.hasPaymentInfo = _data["hasPaymentInfo"];
            this.creditCardType = _data["creditCardType"];
            this.creditCardMaskedNumber = _data["creditCardMaskedNumber"];
            this.nextAssessmentAt = _data["nextAssessmentAt"] ? dayjs(_data["nextAssessmentAt"].toString()) : undefined;
            this.canceledAt = _data["canceledAt"] ? dayjs(_data["canceledAt"].toString()) : undefined;
            this.expiresAt = _data["expiresAt"] ? dayjs(_data["expiresAt"].toString()) : undefined;
            this.currentPeriodStartedAt = _data["currentPeriodStartedAt"] ? dayjs(_data["currentPeriodStartedAt"].toString()) : undefined;
            this.currentPeriodEndsAt = _data["currentPeriodEndsAt"] ? dayjs(_data["currentPeriodEndsAt"].toString()) : undefined;
            this.created = _data["created"] ? dayjs(_data["created"].toString()) : undefined;
            this.cancellationMessage = _data["cancellationMessage"];
            this.cancelAtEndOfPeriod = _data["cancelAtEndOfPeriod"];
            this.balance = _data["balance"];
            this.balanceInCents = _data["balanceInCents"];
            this.nextProductId = _data["nextProductId"];
            this.referralCode = _data["referralCode"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [];
                for (let item of _data["companies"])
                    this.companies.push(SubscriptionCompanyModel.fromJS(item));
            }
            if (Array.isArray(_data["unattachedComponents"])) {
                this.unattachedComponents = [];
                for (let item of _data["unattachedComponents"])
                    this.unattachedComponents.push(SubscriptionComponentModel.fromJS(item));
            }
            if (Array.isArray(_data["coupons"])) {
                this.coupons = [];
                for (let item of _data["coupons"])
                    this.coupons.push(SubscriptionCouponModel.fromJS(item));
            }
            this.customer = _data["customer"] ? SubscriptionCustomerModel.fromJS(_data["customer"]) : undefined;
            this.selfServiceUrl = _data["selfServiceUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoadedSubscriptionModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        data["stateCode"] = this.stateCode;
        data["state"] = this.state;
        data["paymentCollectionMethodCode"] = this.paymentCollectionMethodCode;
        data["paymentCollectionMethod"] = this.paymentCollectionMethod;
        data["hasPaymentInfo"] = this.hasPaymentInfo;
        data["creditCardType"] = this.creditCardType;
        data["creditCardMaskedNumber"] = this.creditCardMaskedNumber;
        data["nextAssessmentAt"] = this.nextAssessmentAt ? this.nextAssessmentAt.toISOString() : undefined;
        data["canceledAt"] = this.canceledAt ? this.canceledAt.toISOString() : undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined;
        data["currentPeriodStartedAt"] = this.currentPeriodStartedAt ? this.currentPeriodStartedAt.toISOString() : undefined;
        data["currentPeriodEndsAt"] = this.currentPeriodEndsAt ? this.currentPeriodEndsAt.toISOString() : undefined;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["cancellationMessage"] = this.cancellationMessage;
        data["cancelAtEndOfPeriod"] = this.cancelAtEndOfPeriod;
        data["balance"] = this.balance;
        data["balanceInCents"] = this.balanceInCents;
        data["nextProductId"] = this.nextProductId;
        data["referralCode"] = this.referralCode;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.unattachedComponents)) {
            data["unattachedComponents"] = [];
            for (let item of this.unattachedComponents)
                data["unattachedComponents"].push(item.toJSON());
        }
        if (Array.isArray(this.coupons)) {
            data["coupons"] = [];
            for (let item of this.coupons)
                data["coupons"].push(item.toJSON());
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["selfServiceUrl"] = this.selfServiceUrl;
        return data;
    }
}
exports.LoadedSubscriptionModel = LoadedSubscriptionModel;
var LoadedUnavailabilityRecordType;
(function (LoadedUnavailabilityRecordType) {
    LoadedUnavailabilityRecordType[LoadedUnavailabilityRecordType["Weekly"] = "Weekly"] = "Weekly";
    LoadedUnavailabilityRecordType[LoadedUnavailabilityRecordType["OneOff"] = "OneOff"] = "OneOff";
})(LoadedUnavailabilityRecordType || (exports.LoadedUnavailabilityRecordType = LoadedUnavailabilityRecordType = {}));
var LoadedUnavailabilityStatus;
(function (LoadedUnavailabilityStatus) {
    LoadedUnavailabilityStatus[LoadedUnavailabilityStatus["Requested"] = "Requested"] = "Requested";
    LoadedUnavailabilityStatus[LoadedUnavailabilityStatus["Approved"] = "Approved"] = "Approved";
    LoadedUnavailabilityStatus[LoadedUnavailabilityStatus["Declined"] = "Declined"] = "Declined";
    LoadedUnavailabilityStatus[LoadedUnavailabilityStatus["Cancelled"] = "Cancelled"] = "Cancelled";
})(LoadedUnavailabilityStatus || (exports.LoadedUnavailabilityStatus = LoadedUnavailabilityStatus = {}));
var LogicalOperatorType;
(function (LogicalOperatorType) {
    LogicalOperatorType[LogicalOperatorType["Equals"] = "Equals"] = "Equals";
    LogicalOperatorType[LogicalOperatorType["DoesNotEqual"] = "DoesNotEqual"] = "DoesNotEqual";
    LogicalOperatorType[LogicalOperatorType["IsGreaterThan"] = "IsGreaterThan"] = "IsGreaterThan";
    LogicalOperatorType[LogicalOperatorType["IsLessThan"] = "IsLessThan"] = "IsLessThan";
    LogicalOperatorType[LogicalOperatorType["IsOnOrAfter"] = "IsOnOrAfter"] = "IsOnOrAfter";
    LogicalOperatorType[LogicalOperatorType["IsOnOrBefore"] = "IsOnOrBefore"] = "IsOnOrBefore";
})(LogicalOperatorType || (exports.LogicalOperatorType = LogicalOperatorType = {}));
class LoginRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.grantType = _data["grantType"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.scope = _data["scope"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.refreshToken = _data["refreshToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["grantType"] = this.grantType;
        data["username"] = this.username;
        data["password"] = this.password;
        data["scope"] = this.scope;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}
exports.LoginRequest = LoginRequest;
class ManualPosSaleHeader {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.saleTime = _data["saleTime"] ? dayjs(_data["saleTime"].toString()) : undefined;
            this.foodAmount = _data["foodAmount"];
            this.beverageAmount = _data["beverageAmount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ManualPosSaleHeader();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["saleTime"] = this.saleTime ? this.saleTime.toISOString() : undefined;
        data["foodAmount"] = this.foodAmount;
        data["beverageAmount"] = this.beverageAmount;
        return data;
    }
}
exports.ManualPosSaleHeader = ManualPosSaleHeader;
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus[MaritalStatus["Couple"] = "Couple"] = "Couple";
    MaritalStatus[MaritalStatus["IllnessSeparatedCouple"] = "IllnessSeparatedCouple"] = "IllnessSeparatedCouple";
    MaritalStatus[MaritalStatus["Single"] = "Single"] = "Single";
})(MaritalStatus || (exports.MaritalStatus = MaritalStatus = {}));
class MemberInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}
exports.MemberInfo = MemberInfo;
var MemberTypes;
(function (MemberTypes) {
    MemberTypes[MemberTypes["_1"] = 1] = "_1";
    MemberTypes[MemberTypes["_2"] = 2] = "_2";
    MemberTypes[MemberTypes["_4"] = 4] = "_4";
    MemberTypes[MemberTypes["_8"] = 8] = "_8";
    MemberTypes[MemberTypes["_16"] = 16] = "_16";
    MemberTypes[MemberTypes["_32"] = 32] = "_32";
    MemberTypes[MemberTypes["_64"] = 64] = "_64";
    MemberTypes[MemberTypes["_128"] = 128] = "_128";
    MemberTypes[MemberTypes["_191"] = 191] = "_191";
})(MemberTypes || (exports.MemberTypes = MemberTypes = {}));
var MethodAttributes;
(function (MethodAttributes) {
    MethodAttributes[MethodAttributes["_0"] = 0] = "_0";
    MethodAttributes[MethodAttributes["_1"] = 1] = "_1";
    MethodAttributes[MethodAttributes["_2"] = 2] = "_2";
    MethodAttributes[MethodAttributes["_3"] = 3] = "_3";
    MethodAttributes[MethodAttributes["_4"] = 4] = "_4";
    MethodAttributes[MethodAttributes["_5"] = 5] = "_5";
    MethodAttributes[MethodAttributes["_6"] = 6] = "_6";
    MethodAttributes[MethodAttributes["_7"] = 7] = "_7";
    MethodAttributes[MethodAttributes["_8"] = 8] = "_8";
    MethodAttributes[MethodAttributes["_16"] = 16] = "_16";
    MethodAttributes[MethodAttributes["_32"] = 32] = "_32";
    MethodAttributes[MethodAttributes["_64"] = 64] = "_64";
    MethodAttributes[MethodAttributes["_128"] = 128] = "_128";
    MethodAttributes[MethodAttributes["_256"] = 256] = "_256";
    MethodAttributes[MethodAttributes["_512"] = 512] = "_512";
    MethodAttributes[MethodAttributes["_1024"] = 1024] = "_1024";
    MethodAttributes[MethodAttributes["_2048"] = 2048] = "_2048";
    MethodAttributes[MethodAttributes["_4096"] = 4096] = "_4096";
    MethodAttributes[MethodAttributes["_8192"] = 8192] = "_8192";
    MethodAttributes[MethodAttributes["_16384"] = 16384] = "_16384";
    MethodAttributes[MethodAttributes["_32768"] = 32768] = "_32768";
    MethodAttributes[MethodAttributes["_53248"] = 53248] = "_53248";
})(MethodAttributes || (exports.MethodAttributes = MethodAttributes = {}));
class MethodBase {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.memberType = _data["memberType"];
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined;
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}
exports.MethodBase = MethodBase;
var MethodImplAttributes;
(function (MethodImplAttributes) {
    MethodImplAttributes[MethodImplAttributes["_0"] = 0] = "_0";
    MethodImplAttributes[MethodImplAttributes["_1"] = 1] = "_1";
    MethodImplAttributes[MethodImplAttributes["_2"] = 2] = "_2";
    MethodImplAttributes[MethodImplAttributes["_3"] = 3] = "_3";
    MethodImplAttributes[MethodImplAttributes["_4"] = 4] = "_4";
    MethodImplAttributes[MethodImplAttributes["_8"] = 8] = "_8";
    MethodImplAttributes[MethodImplAttributes["_16"] = 16] = "_16";
    MethodImplAttributes[MethodImplAttributes["_32"] = 32] = "_32";
    MethodImplAttributes[MethodImplAttributes["_64"] = 64] = "_64";
    MethodImplAttributes[MethodImplAttributes["_128"] = 128] = "_128";
    MethodImplAttributes[MethodImplAttributes["_256"] = 256] = "_256";
    MethodImplAttributes[MethodImplAttributes["_512"] = 512] = "_512";
    MethodImplAttributes[MethodImplAttributes["_4096"] = 4096] = "_4096";
    MethodImplAttributes[MethodImplAttributes["_65535"] = 65535] = "_65535";
})(MethodImplAttributes || (exports.MethodImplAttributes = MethodImplAttributes = {}));
class MethodInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined;
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : undefined;
        return data;
    }
}
exports.MethodInfo = MethodInfo;
class Module {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined;
            this.fullyQualifiedName = _data["fullyQualifiedName"];
            this.name = _data["name"];
            this.mdStreamVersion = _data["mdStreamVersion"];
            this.moduleVersionId = _data["moduleVersionId"];
            this.scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}
exports.Module = Module;
class ModuleHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.mdStreamVersion = _data["mdStreamVersion"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}
exports.ModuleHandle = ModuleHandle;
class NewTicketRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.page = _data["page"];
            this.type = _data["type"];
            this.inviteSupport = _data["inviteSupport"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NewTicketRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["page"] = this.page;
        data["type"] = this.type;
        data["inviteSupport"] = this.inviteSupport;
        return data;
    }
}
exports.NewTicketRequestModel = NewTicketRequestModel;
var NzKiwisaverContributionOptions;
(function (NzKiwisaverContributionOptions) {
    NzKiwisaverContributionOptions[NzKiwisaverContributionOptions["MakeContributions"] = "MakeContributions"] = "MakeContributions";
    NzKiwisaverContributionOptions[NzKiwisaverContributionOptions["OnASavingsSuspension"] = "OnASavingsSuspension"] = "OnASavingsSuspension";
    NzKiwisaverContributionOptions[NzKiwisaverContributionOptions["OptOut"] = "OptOut"] = "OptOut";
    NzKiwisaverContributionOptions[NzKiwisaverContributionOptions["OnAContributionsHoliday"] = "OnAContributionsHoliday"] = "OnAContributionsHoliday";
    NzKiwisaverContributionOptions[NzKiwisaverContributionOptions["NotCurrentlyAKiwiSaverMember"] = "NotCurrentlyAKiwiSaverMember"] = "NotCurrentlyAKiwiSaverMember";
})(NzKiwisaverContributionOptions || (exports.NzKiwisaverContributionOptions = NzKiwisaverContributionOptions = {}));
var NzTaxCode;
(function (NzTaxCode) {
    NzTaxCode[NzTaxCode["ND"] = "ND"] = "ND";
    NzTaxCode[NzTaxCode["M"] = "M"] = "M";
    NzTaxCode[NzTaxCode["ME"] = "ME"] = "ME";
    NzTaxCode[NzTaxCode["MSL"] = "MSL"] = "MSL";
    NzTaxCode[NzTaxCode["MESL"] = "MESL"] = "MESL";
    NzTaxCode[NzTaxCode["SB"] = "SB"] = "SB";
    NzTaxCode[NzTaxCode["S"] = "S"] = "S";
    NzTaxCode[NzTaxCode["SH"] = "SH"] = "SH";
    NzTaxCode[NzTaxCode["ST"] = "ST"] = "ST";
    NzTaxCode[NzTaxCode["SBSL"] = "SBSL"] = "SBSL";
    NzTaxCode[NzTaxCode["SSL"] = "SSL"] = "SSL";
    NzTaxCode[NzTaxCode["SHSL"] = "SHSL"] = "SHSL";
    NzTaxCode[NzTaxCode["STSL"] = "STSL"] = "STSL";
    NzTaxCode[NzTaxCode["WT"] = "WT"] = "WT";
    NzTaxCode[NzTaxCode["CAE"] = "CAE"] = "CAE";
    NzTaxCode[NzTaxCode["EDW"] = "EDW"] = "EDW";
    NzTaxCode[NzTaxCode["NSW"] = "NSW"] = "NSW";
    NzTaxCode[NzTaxCode["STC"] = "STC"] = "STC";
    NzTaxCode[NzTaxCode["STCSL"] = "STCSL"] = "STCSL";
})(NzTaxCode || (exports.NzTaxCode = NzTaxCode = {}));
class ODataPathSegment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.edmType = _data["edmType"] ? IEdmType.fromJS(_data["edmType"]) : undefined;
            this.identifier = _data["identifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ODataPathSegment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["edmType"] = this.edmType ? this.edmType.toJSON() : undefined;
        data["identifier"] = this.identifier;
        return data;
    }
}
exports.ODataPathSegment = ODataPathSegment;
class ODataQueryContext {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.defaultQueryConfigurations = _data["defaultQueryConfigurations"] ? DefaultQueryConfigurations.fromJS(_data["defaultQueryConfigurations"]) : undefined;
            this.model = _data["model"] ? IEdmModel.fromJS(_data["model"]) : undefined;
            this.elementType = _data["elementType"] ? IEdmType.fromJS(_data["elementType"]) : undefined;
            this.navigationSource = _data["navigationSource"] ? IEdmNavigationSource.fromJS(_data["navigationSource"]) : undefined;
            this.elementClrType = _data["elementClrType"] ? Type.fromJS(_data["elementClrType"]) : undefined;
            if (Array.isArray(_data["path"])) {
                this.path = [];
                for (let item of _data["path"])
                    this.path.push(ODataPathSegment.fromJS(item));
            }
            this.requestContainer = _data["requestContainer"] ? IServiceProvider.fromJS(_data["requestContainer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryContext();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultQueryConfigurations"] = this.defaultQueryConfigurations ? this.defaultQueryConfigurations.toJSON() : undefined;
        data["model"] = this.model ? this.model.toJSON() : undefined;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined;
        data["navigationSource"] = this.navigationSource ? this.navigationSource.toJSON() : undefined;
        data["elementClrType"] = this.elementClrType ? this.elementClrType.toJSON() : undefined;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["requestContainer"] = this.requestContainer ? this.requestContainer.toJSON() : undefined;
        return data;
    }
}
exports.ODataQueryContext = ODataQueryContext;
class ODataRawQueryOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.filter = _data["filter"];
            this.apply = _data["apply"];
            this.compute = _data["compute"];
            this.search = _data["search"];
            this.orderBy = _data["orderBy"];
            this.top = _data["top"];
            this.skip = _data["skip"];
            this.select = _data["select"];
            this.expand = _data["expand"];
            this.count = _data["count"];
            this.format = _data["format"];
            this.skipToken = _data["skipToken"];
            this.deltaToken = _data["deltaToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ODataRawQueryOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["apply"] = this.apply;
        data["compute"] = this.compute;
        data["search"] = this.search;
        data["orderBy"] = this.orderBy;
        data["top"] = this.top;
        data["skip"] = this.skip;
        data["select"] = this.select;
        data["expand"] = this.expand;
        data["count"] = this.count;
        data["format"] = this.format;
        data["skipToken"] = this.skipToken;
        data["deltaToken"] = this.deltaToken;
        return data;
    }
}
exports.ODataRawQueryOptions = ODataRawQueryOptions;
class Oid {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
            this.friendlyName = _data["friendlyName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Oid();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["friendlyName"] = this.friendlyName;
        return data;
    }
}
exports.Oid = Oid;
var OperationType;
(function (OperationType) {
    OperationType[OperationType["_0"] = 0] = "_0";
    OperationType[OperationType["_1"] = 1] = "_1";
    OperationType[OperationType["_2"] = 2] = "_2";
    OperationType[OperationType["_3"] = 3] = "_3";
    OperationType[OperationType["_4"] = 4] = "_4";
    OperationType[OperationType["_5"] = 5] = "_5";
    OperationType[OperationType["_6"] = 6] = "_6";
})(OperationType || (exports.OperationType = OperationType = {}));
class OrderByClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.thenBy = _data["thenBy"] ? OrderByClause.fromJS(_data["thenBy"]) : undefined;
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : undefined;
            this.direction = _data["direction"];
            this.rangeVariable = _data["rangeVariable"] ? RangeVariable.fromJS(_data["rangeVariable"]) : undefined;
            this.itemType = _data["itemType"] ? IEdmTypeReference.fromJS(_data["itemType"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["thenBy"] = this.thenBy ? this.thenBy.toJSON() : undefined;
        data["expression"] = this.expression ? this.expression.toJSON() : undefined;
        data["direction"] = this.direction;
        data["rangeVariable"] = this.rangeVariable ? this.rangeVariable.toJSON() : undefined;
        data["itemType"] = this.itemType ? this.itemType.toJSON() : undefined;
        return data;
    }
}
exports.OrderByClause = OrderByClause;
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection[OrderByDirection["_0"] = 0] = "_0";
    OrderByDirection[OrderByDirection["_1"] = 1] = "_1";
})(OrderByDirection || (exports.OrderByDirection = OrderByDirection = {}));
class OrderByNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.direction = _data["direction"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        return data;
    }
}
exports.OrderByNode = OrderByNode;
class OrderByQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            if (Array.isArray(_data["orderByNodes"])) {
                this.orderByNodes = [];
                for (let item of _data["orderByNodes"])
                    this.orderByNodes.push(OrderByNode.fromJS(item));
            }
            this.rawValue = _data["rawValue"];
            this.validator = _data["validator"] ? IOrderByQueryValidator.fromJS(_data["validator"]) : undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : undefined;
            this.orderByClause = _data["orderByClause"] ? OrderByClause.fromJS(_data["orderByClause"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        if (Array.isArray(this.orderByNodes)) {
            data["orderByNodes"] = [];
            for (let item of this.orderByNodes)
                data["orderByNodes"].push(item.toJSON());
        }
        data["rawValue"] = this.rawValue;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : undefined;
        data["orderByClause"] = this.orderByClause ? this.orderByClause.toJSON() : undefined;
        return data;
    }
}
exports.OrderByQueryOption = OrderByQueryOption;
class PackageRef {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PackageRef();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["type"] = this.type;
        return data;
    }
}
exports.PackageRef = PackageRef;
var PackageType;
(function (PackageType) {
    PackageType[PackageType["Managed"] = "Managed"] = "Managed";
    PackageType[PackageType["Custom"] = "Custom"] = "Custom";
    PackageType[PackageType["UserDefined"] = "UserDefined"] = "UserDefined";
})(PackageType || (exports.PackageType = PackageType = {}));
var ParameterAttributes;
(function (ParameterAttributes) {
    ParameterAttributes[ParameterAttributes["_0"] = 0] = "_0";
    ParameterAttributes[ParameterAttributes["_1"] = 1] = "_1";
    ParameterAttributes[ParameterAttributes["_2"] = 2] = "_2";
    ParameterAttributes[ParameterAttributes["_4"] = 4] = "_4";
    ParameterAttributes[ParameterAttributes["_8"] = 8] = "_8";
    ParameterAttributes[ParameterAttributes["_16"] = 16] = "_16";
    ParameterAttributes[ParameterAttributes["_4096"] = 4096] = "_4096";
    ParameterAttributes[ParameterAttributes["_8192"] = 8192] = "_8192";
    ParameterAttributes[ParameterAttributes["_16384"] = 16384] = "_16384";
    ParameterAttributes[ParameterAttributes["_32768"] = 32768] = "_32768";
    ParameterAttributes[ParameterAttributes["_61440"] = 61440] = "_61440";
})(ParameterAttributes || (exports.ParameterAttributes = ParameterAttributes = {}));
class ParameterInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : undefined;
            this.name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : undefined;
            this.position = _data["position"];
            this.isIn = _data["isIn"];
            this.isLcid = _data["isLcid"];
            this.isOptional = _data["isOptional"];
            this.isOut = _data["isOut"];
            this.isRetval = _data["isRetval"];
            this.defaultValue = _data["defaultValue"];
            this.rawDefaultValue = _data["rawDefaultValue"];
            this.hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}
exports.ParameterInfo = ParameterInfo;
class PathString {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PathString();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        return data;
    }
}
exports.PathString = PathString;
class PayAdjustmentConditionType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            if (Array.isArray(_data["linkedConditions"])) {
                this.linkedConditions = [];
                for (let item of _data["linkedConditions"])
                    this.linkedConditions.push(PayAdjustmentLinkedCondition.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentConditionType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        if (Array.isArray(this.linkedConditions)) {
            data["linkedConditions"] = [];
            for (let item of this.linkedConditions)
                data["linkedConditions"].push(item.toJSON());
        }
        return data;
    }
}
exports.PayAdjustmentConditionType = PayAdjustmentConditionType;
var PayAdjustmentConditionTypeCode;
(function (PayAdjustmentConditionTypeCode) {
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["DaysOff"] = "DaysOff"] = "DaysOff";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["EmployeeMatch"] = "EmployeeMatch"] = "EmployeeMatch";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["ScheduleMatch"] = "ScheduleMatch"] = "ScheduleMatch";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["ShiftRest"] = "ShiftRest"] = "ShiftRest";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["HoursWorked"] = "HoursWorked"] = "HoursWorked";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["DaysWorked"] = "DaysWorked"] = "DaysWorked";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["EmployeeApplicable"] = "EmployeeApplicable"] = "EmployeeApplicable";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["PackageApplicable"] = "PackageApplicable"] = "PackageApplicable";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["MinLength"] = "MinLength"] = "MinLength";
    PayAdjustmentConditionTypeCode[PayAdjustmentConditionTypeCode["BreakMissed"] = "BreakMissed"] = "BreakMissed";
})(PayAdjustmentConditionTypeCode || (exports.PayAdjustmentConditionTypeCode = PayAdjustmentConditionTypeCode = {}));
class PayAdjustmentLinkedCondition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.ruleId = _data["ruleId"];
            this.conditionTypeId = _data["conditionTypeId"];
            this.conditionType = _data["conditionType"] ? PayAdjustmentConditionType.fromJS(_data["conditionType"]) : undefined;
            this.rule = _data["rule"] ? PayAdjustmentRule.fromJS(_data["rule"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentLinkedCondition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ruleId"] = this.ruleId;
        data["conditionTypeId"] = this.conditionTypeId;
        data["conditionType"] = this.conditionType ? this.conditionType.toJSON() : undefined;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        return data;
    }
}
exports.PayAdjustmentLinkedCondition = PayAdjustmentLinkedCondition;
class PayAdjustmentPackage {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(PayAdjustmentRule.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentPackage();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}
exports.PayAdjustmentPackage = PayAdjustmentPackage;
class PayAdjustmentRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.package = _data["package"] ? PayAdjustmentPackage.fromJS(_data["package"]) : undefined;
            this.packageId = _data["packageId"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.rate = _data["rate"];
            this.type = _data["type"];
            this.superRuleCode = _data["superRuleCode"];
            this.payCode = _data["payCode"];
            this.payrollPayTypeId = _data["payrollPayTypeId"];
            this.payrollPayTypeSource = _data["payrollPayTypeSource"];
            this.evaluationType = _data["evaluationType"];
            this.description = _data["description"];
            this.roundUpHours = _data["roundUpHours"];
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [];
                for (let item of _data["schedule"])
                    this.schedule.push(PayAdjustmentRuleSchedule.fromJS(item));
            }
            if (Array.isArray(_data["linkedConditions"])) {
                this.linkedConditions = [];
                for (let item of _data["linkedConditions"])
                    this.linkedConditions.push(PayAdjustmentLinkedCondition.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(PayAdjustmentRuleAction.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["packageId"] = this.packageId;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["rate"] = this.rate;
        data["type"] = this.type;
        data["superRuleCode"] = this.superRuleCode;
        data["payCode"] = this.payCode;
        data["payrollPayTypeId"] = this.payrollPayTypeId;
        data["payrollPayTypeSource"] = this.payrollPayTypeSource;
        data["evaluationType"] = this.evaluationType;
        data["description"] = this.description;
        data["roundUpHours"] = this.roundUpHours;
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedConditions)) {
            data["linkedConditions"] = [];
            for (let item of this.linkedConditions)
                data["linkedConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}
exports.PayAdjustmentRule = PayAdjustmentRule;
class PayAdjustmentRuleAction {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.rule = _data["rule"] ? PayAdjustmentRule.fromJS(_data["rule"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.type = _data["type"];
            if (Array.isArray(_data["references"])) {
                this.references = [];
                for (let item of _data["references"])
                    this.references.push(PayAdjustmentRuleActionReference.fromJS(item));
            }
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRuleAction();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["type"] = this.type;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        return data;
    }
}
exports.PayAdjustmentRuleAction = PayAdjustmentRuleAction;
class PayAdjustmentRuleActionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.ruleId = _data["ruleId"];
            this.type = _data["type"];
            if (Array.isArray(_data["references"])) {
                this.references = [];
                for (let item of _data["references"])
                    this.references.push(PayAdjustmentRuleActionReferenceDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRuleActionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ruleId"] = this.ruleId;
        data["type"] = this.type;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item.toJSON());
        }
        return data;
    }
}
exports.PayAdjustmentRuleActionDto = PayAdjustmentRuleActionDto;
class PayAdjustmentRuleActionReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"] ? PayAdjustmentRuleAction.fromJS(_data["action"]) : undefined;
            this.actionId = _data["actionId"];
            this.reference = _data["reference"];
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRuleActionReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action ? this.action.toJSON() : undefined;
        data["actionId"] = this.actionId;
        data["reference"] = this.reference;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        return data;
    }
}
exports.PayAdjustmentRuleActionReference = PayAdjustmentRuleActionReference;
class PayAdjustmentRuleActionReferenceDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.actionId = _data["actionId"];
            this.reference = _data["reference"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRuleActionReferenceDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionId"] = this.actionId;
        data["reference"] = this.reference;
        return data;
    }
}
exports.PayAdjustmentRuleActionReferenceDto = PayAdjustmentRuleActionReferenceDto;
class PayAdjustmentRuleSchedule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rule = _data["rule"] ? PayAdjustmentRule.fromJS(_data["rule"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.repeat = _data["repeat"];
            this.repeatEnd = _data["repeatEnd"] ? dayjs(_data["repeatEnd"].toString()) : undefined;
            this.days = _data["days"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayAdjustmentRuleSchedule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["repeat"] = this.repeat;
        data["repeatEnd"] = this.repeatEnd ? this.repeatEnd.toISOString() : undefined;
        data["days"] = this.days;
        return data;
    }
}
exports.PayAdjustmentRuleSchedule = PayAdjustmentRuleSchedule;
class PayClassification {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.baseHourlyRate = _data["baseHourlyRate"];
            this.isActive = _data["isActive"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayClassification();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["baseHourlyRate"] = this.baseHourlyRate;
        data["isActive"] = this.isActive;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.PayClassification = PayClassification;
class PayClassificationRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.baseHourlyRate = _data["baseHourlyRate"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [];
                for (let item of _data["variations"])
                    this.variations.push(PayClassificationVariationModel.fromJS(item));
            }
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayClassificationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["baseHourlyRate"] = this.baseHourlyRate;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item.toJSON());
        }
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.PayClassificationRequest = PayClassificationRequest;
var PayClassificationType;
(function (PayClassificationType) {
    PayClassificationType[PayClassificationType["Managed"] = "Managed"] = "Managed";
    PayClassificationType[PayClassificationType["Custom"] = "Custom"] = "Custom";
})(PayClassificationType || (exports.PayClassificationType = PayClassificationType = {}));
class PayClassificationVariationModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.payClassificationId = _data["payClassificationId"];
            this.classifier = _data["classifier"];
            this.logicalOperator = _data["logicalOperator"];
            this.age = _data["age"];
            this.contractedWeeklyHours = _data["contractedWeeklyHours"];
            this.employmentType = _data["employmentType"];
            this.remunerationType = _data["remunerationType"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : undefined;
            this.unitType = _data["unitType"];
            this.action = _data["action"];
            this.actionValue = _data["actionValue"];
            this.effectiveRate = _data["effectiveRate"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayClassificationVariationModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payClassificationId"] = this.payClassificationId;
        data["classifier"] = this.classifier;
        data["logicalOperator"] = this.logicalOperator;
        data["age"] = this.age;
        data["contractedWeeklyHours"] = this.contractedWeeklyHours;
        data["employmentType"] = this.employmentType;
        data["remunerationType"] = this.remunerationType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["unitType"] = this.unitType;
        data["action"] = this.action;
        data["actionValue"] = this.actionValue;
        data["effectiveRate"] = this.effectiveRate;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.PayClassificationVariationModel = PayClassificationVariationModel;
var PayRunEmployeeStatus;
(function (PayRunEmployeeStatus) {
    PayRunEmployeeStatus[PayRunEmployeeStatus["NotLinked"] = "NotLinked"] = "NotLinked";
    PayRunEmployeeStatus[PayRunEmployeeStatus["NotInLoaded"] = "NotInLoaded"] = "NotInLoaded";
    PayRunEmployeeStatus[PayRunEmployeeStatus["NotIncludedInPayrun"] = "NotIncludedInPayrun"] = "NotIncludedInPayrun";
    PayRunEmployeeStatus[PayRunEmployeeStatus["IncludedInPayrun"] = "IncludedInPayrun"] = "IncludedInPayrun";
})(PayRunEmployeeStatus || (exports.PayRunEmployeeStatus = PayRunEmployeeStatus = {}));
var PayRunStatus;
(function (PayRunStatus) {
    PayRunStatus[PayRunStatus["Draft"] = "Draft"] = "Draft";
    PayRunStatus[PayRunStatus["Completed"] = "Completed"] = "Completed";
})(PayRunStatus || (exports.PayRunStatus = PayRunStatus = {}));
class PayrollEmployee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.startDate = _data["startDate"];
            this.email = _data["email"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.bankAccountName = _data["bankAccountName"];
            this.bankAccountNumber = _data["bankAccountNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollEmployee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["startDate"] = this.startDate;
        data["email"] = this.email;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["bankAccountName"] = this.bankAccountName;
        data["bankAccountNumber"] = this.bankAccountNumber;
        return data;
    }
}
exports.PayrollEmployee = PayrollEmployee;
class PayrollPayTypeRef {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.payTypeId = _data["payTypeId"];
            this.payTypeSource = _data["payTypeSource"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollPayTypeRef();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["payTypeId"] = this.payTypeId;
        data["payTypeSource"] = this.payTypeSource;
        return data;
    }
}
exports.PayrollPayTypeRef = PayrollPayTypeRef;
var PayrollPayTypeSource;
(function (PayrollPayTypeSource) {
    PayrollPayTypeSource[PayrollPayTypeSource["Custom"] = "Custom"] = "Custom";
    PayrollPayTypeSource[PayrollPayTypeSource["Default"] = "Default"] = "Default";
})(PayrollPayTypeSource || (exports.PayrollPayTypeSource = PayrollPayTypeSource = {}));
var PayrollSystem;
(function (PayrollSystem) {
    PayrollSystem[PayrollSystem["Custom"] = "Custom"] = "Custom";
    PayrollSystem[PayrollSystem["AcePayroll"] = "AcePayroll"] = "AcePayroll";
    PayrollSystem[PayrollSystem["AffinityPayroll"] = "AffinityPayroll"] = "AffinityPayroll";
    PayrollSystem[PayrollSystem["CrystalPayroll"] = "CrystalPayroll"] = "CrystalPayroll";
    PayrollSystem[PayrollSystem["DataPay"] = "DataPay"] = "DataPay";
    PayrollSystem[PayrollSystem["EzyPay"] = "EzyPay"] = "EzyPay";
    PayrollSystem[PayrollSystem["Flexitime"] = "Flexitime"] = "Flexitime";
    PayrollSystem[PayrollSystem["IPayroll"] = "IPayroll"] = "IPayroll";
    PayrollSystem[PayrollSystem["MyobExo"] = "MyobExo"] = "MyobExo";
    PayrollSystem[PayrollSystem["MyobPayroll"] = "MyobPayroll"] = "MyobPayroll";
    PayrollSystem[PayrollSystem["PayHero"] = "PayHero"] = "PayHero";
    PayrollSystem[PayrollSystem["PaySauce"] = "PaySauce"] = "PaySauce";
    PayrollSystem[PayrollSystem["Smartly"] = "Smartly"] = "Smartly";
    PayrollSystem[PayrollSystem["XeroAu"] = "XeroAu"] = "XeroAu";
    PayrollSystem[PayrollSystem["XeroNz"] = "XeroNz"] = "XeroNz";
})(PayrollSystem || (exports.PayrollSystem = PayrollSystem = {}));
class Payrun {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [];
                for (let item of _data["lines"])
                    this.lines.push(PayrunLine.fromJS(item));
            }
            this.frequency = _data["frequency"];
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.datestampPayment = _data["datestampPayment"] ? dayjs(_data["datestampPayment"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.datestampApproved = _data["datestampApproved"] ? dayjs(_data["datestampApproved"].toString()) : undefined;
            this.pgId = _data["pgId"];
            this.totalPay = _data["totalPay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Payrun();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["frequency"] = this.frequency;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["datestampPayment"] = this.datestampPayment ? this.datestampPayment.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["datestampApproved"] = this.datestampApproved ? this.datestampApproved.toISOString() : undefined;
        data["pgId"] = this.pgId;
        data["totalPay"] = this.totalPay;
        return data;
    }
}
exports.Payrun = Payrun;
class PayrunETag {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isWellFormed = _data["isWellFormed"];
            this.entityType = _data["entityType"] ? Type.fromJS(_data["entityType"]) : undefined;
            this.isAny = _data["isAny"];
            this.isIfNoneMatch = _data["isIfNoneMatch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunETag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isWellFormed"] = this.isWellFormed;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : undefined;
        data["isAny"] = this.isAny;
        data["isIfNoneMatch"] = this.isIfNoneMatch;
        return data;
    }
}
exports.PayrunETag = PayrunETag;
var PayrunFrequency;
(function (PayrunFrequency) {
    PayrunFrequency[PayrunFrequency["_0"] = 0] = "_0";
    PayrunFrequency[PayrunFrequency["_1"] = 1] = "_1";
    PayrunFrequency[PayrunFrequency["_2"] = 2] = "_2";
})(PayrunFrequency || (exports.PayrunFrequency = PayrunFrequency = {}));
class PayrunJsonPatchDocument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [];
                for (let item of _data["operations"])
                    this.operations.push(PayrunOperation.fromJS(item));
            }
            this.contractResolver = _data["contractResolver"] ? IContractResolver.fromJS(_data["contractResolver"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunJsonPatchDocument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        data["contractResolver"] = this.contractResolver ? this.contractResolver.toJSON() : undefined;
        return data;
    }
}
exports.PayrunJsonPatchDocument = PayrunJsonPatchDocument;
class PayrunLine {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.payrun = _data["payrun"] ? Payrun.fromJS(_data["payrun"]) : undefined;
            this.payrunId = _data["payrunId"];
            this.staffMemberId = _data["staffMemberId"];
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            if (Array.isArray(_data["clockins"])) {
                this.clockins = [];
                for (let item of _data["clockins"])
                    this.clockins.push(Clockin.fromJS(item));
            }
            if (Array.isArray(_data["includedClockins"])) {
                this.includedClockins = [];
                for (let item of _data["includedClockins"])
                    this.includedClockins.push(PayrunLineClockin.fromJS(item));
            }
            if (Array.isArray(_data["paytypes"])) {
                this.paytypes = [];
                for (let item of _data["paytypes"])
                    this.paytypes.push(PayrunLinePaytype.fromJS(item));
            }
            this.pgId = _data["pgId"];
            this.totalWages = _data["totalWages"];
            this.totalAllowance = _data["totalAllowance"];
            this.totalGross = _data["totalGross"];
            this.totalPay = _data["totalPay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunLine();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payrun"] = this.payrun ? this.payrun.toJSON() : undefined;
        data["payrunId"] = this.payrunId;
        data["staffMemberId"] = this.staffMemberId;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        if (Array.isArray(this.clockins)) {
            data["clockins"] = [];
            for (let item of this.clockins)
                data["clockins"].push(item.toJSON());
        }
        if (Array.isArray(this.includedClockins)) {
            data["includedClockins"] = [];
            for (let item of this.includedClockins)
                data["includedClockins"].push(item.toJSON());
        }
        if (Array.isArray(this.paytypes)) {
            data["paytypes"] = [];
            for (let item of this.paytypes)
                data["paytypes"].push(item.toJSON());
        }
        data["pgId"] = this.pgId;
        data["totalWages"] = this.totalWages;
        data["totalAllowance"] = this.totalAllowance;
        data["totalGross"] = this.totalGross;
        data["totalPay"] = this.totalPay;
        return data;
    }
}
exports.PayrunLine = PayrunLine;
class PayrunLineClockin {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.clockin = _data["clockin"] ? Clockin.fromJS(_data["clockin"]) : undefined;
            this.payrunLineId = _data["payrunLineId"];
            this.payrunLine = _data["payrunLine"] ? PayrunLine.fromJS(_data["payrunLine"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunLineClockin();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["clockin"] = this.clockin ? this.clockin.toJSON() : undefined;
        data["payrunLineId"] = this.payrunLineId;
        data["payrunLine"] = this.payrunLine ? this.payrunLine.toJSON() : undefined;
        return data;
    }
}
exports.PayrunLineClockin = PayrunLineClockin;
class PayrunLinePaytype {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.paytypeId = _data["paytypeId"];
            this.paytype = _data["paytype"] ? Paytype.fromJS(_data["paytype"]) : undefined;
            this.payrunLineId = _data["payrunLineId"];
            this.payrunLine = _data["payrunLine"] ? PayrunLine.fromJS(_data["payrunLine"]) : undefined;
            this.rate = _data["rate"];
            this.quantity = _data["quantity"];
            this.label = _data["label"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunLinePaytype();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paytypeId"] = this.paytypeId;
        data["paytype"] = this.paytype ? this.paytype.toJSON() : undefined;
        data["payrunLineId"] = this.payrunLineId;
        data["payrunLine"] = this.payrunLine ? this.payrunLine.toJSON() : undefined;
        data["rate"] = this.rate;
        data["quantity"] = this.quantity;
        data["label"] = this.label;
        return data;
    }
}
exports.PayrunLinePaytype = PayrunLinePaytype;
class PayrunODataQueryOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.request = _data["request"] ? HttpRequest.fromJS(_data["request"]) : undefined;
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.rawValues = _data["rawValues"] ? ODataRawQueryOptions.fromJS(_data["rawValues"]) : undefined;
            this.selectExpand = _data["selectExpand"] ? SelectExpandQueryOption.fromJS(_data["selectExpand"]) : undefined;
            this.apply = _data["apply"] ? ApplyQueryOption.fromJS(_data["apply"]) : undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : undefined;
            this.filter = _data["filter"] ? FilterQueryOption.fromJS(_data["filter"]) : undefined;
            this.search = _data["search"] ? SearchQueryOption.fromJS(_data["search"]) : undefined;
            this.orderBy = _data["orderBy"] ? OrderByQueryOption.fromJS(_data["orderBy"]) : undefined;
            this.skip = _data["skip"] ? SkipQueryOption.fromJS(_data["skip"]) : undefined;
            this.skipToken = _data["skipToken"] ? SkipTokenQueryOption.fromJS(_data["skipToken"]) : undefined;
            this.top = _data["top"] ? TopQueryOption.fromJS(_data["top"]) : undefined;
            this.count = _data["count"] ? CountQueryOption.fromJS(_data["count"]) : undefined;
            this.validator = _data["validator"] ? IODataQueryValidator.fromJS(_data["validator"]) : undefined;
            this.ifMatch = _data["ifMatch"] ? PayrunETag.fromJS(_data["ifMatch"]) : undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? PayrunETag.fromJS(_data["ifNoneMatch"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunODataQueryOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : undefined;
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["rawValues"] = this.rawValues ? this.rawValues.toJSON() : undefined;
        data["selectExpand"] = this.selectExpand ? this.selectExpand.toJSON() : undefined;
        data["apply"] = this.apply ? this.apply.toJSON() : undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : undefined;
        data["search"] = this.search ? this.search.toJSON() : undefined;
        data["orderBy"] = this.orderBy ? this.orderBy.toJSON() : undefined;
        data["skip"] = this.skip ? this.skip.toJSON() : undefined;
        data["skipToken"] = this.skipToken ? this.skipToken.toJSON() : undefined;
        data["top"] = this.top ? this.top.toJSON() : undefined;
        data["count"] = this.count ? this.count.toJSON() : undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : undefined;
        return data;
    }
}
exports.PayrunODataQueryOptions = PayrunODataQueryOptions;
class PayrunOperation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PayrunOperation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        data["value"] = this.value;
        return data;
    }
}
exports.PayrunOperation = PayrunOperation;
class Paytype {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbrev = _data["abbrev"];
            this.module = _data["module"];
            this.isTaxable = _data["isTaxable"];
            this.defaultRate = _data["defaultRate"];
            this.defaultQuantity = _data["defaultQuantity"];
            this.autoAdd = _data["autoAdd"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            if (Array.isArray(_data["defaultStaff"])) {
                this.defaultStaff = [];
                for (let item of _data["defaultStaff"])
                    this.defaultStaff.push(StaffMemberPaytype.fromJS(item));
            }
            if (Array.isArray(_data["defaultRoles"])) {
                this.defaultRoles = [];
                for (let item of _data["defaultRoles"])
                    this.defaultRoles.push(StaffRolePaytype.fromJS(item));
            }
            this.pgId = _data["pgId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Paytype();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbrev"] = this.abbrev;
        data["module"] = this.module;
        data["isTaxable"] = this.isTaxable;
        data["defaultRate"] = this.defaultRate;
        data["defaultQuantity"] = this.defaultQuantity;
        data["autoAdd"] = this.autoAdd;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        if (Array.isArray(this.defaultStaff)) {
            data["defaultStaff"] = [];
            for (let item of this.defaultStaff)
                data["defaultStaff"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRoles)) {
            data["defaultRoles"] = [];
            for (let item of this.defaultRoles)
                data["defaultRoles"].push(item.toJSON());
        }
        data["pgId"] = this.pgId;
        return data;
    }
}
exports.Paytype = Paytype;
var PaytypeAutoAdd;
(function (PaytypeAutoAdd) {
    PaytypeAutoAdd[PaytypeAutoAdd["_1"] = 1] = "_1";
    PaytypeAutoAdd[PaytypeAutoAdd["_2"] = 2] = "_2";
    PaytypeAutoAdd[PaytypeAutoAdd["_3"] = 3] = "_3";
    PaytypeAutoAdd[PaytypeAutoAdd["_4"] = 4] = "_4";
})(PaytypeAutoAdd || (exports.PaytypeAutoAdd = PaytypeAutoAdd = {}));
var PaytypeDefaultQuantity;
(function (PaytypeDefaultQuantity) {
    PaytypeDefaultQuantity[PaytypeDefaultQuantity["_0"] = 0] = "_0";
    PaytypeDefaultQuantity[PaytypeDefaultQuantity["_1"] = 1] = "_1";
    PaytypeDefaultQuantity[PaytypeDefaultQuantity["_2"] = 2] = "_2";
    PaytypeDefaultQuantity[PaytypeDefaultQuantity["_3"] = 3] = "_3";
    PaytypeDefaultQuantity[PaytypeDefaultQuantity["_4"] = 4] = "_4";
})(PaytypeDefaultQuantity || (exports.PaytypeDefaultQuantity = PaytypeDefaultQuantity = {}));
class PaytypeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isTaxable = _data["isTaxable"];
            this.defaultQuantity = _data["defaultQuantity"];
            this.defaultRate = _data["defaultRate"];
            this.autoAdd = _data["autoAdd"];
            this.module = _data["module"];
            if (Array.isArray(_data["defaultStaff"])) {
                this.defaultStaff = [];
                for (let item of _data["defaultStaff"])
                    this.defaultStaff.push(StaffMemberPaytypeModel.fromJS(item));
            }
            if (Array.isArray(_data["defaultRoles"])) {
                this.defaultRoles = [];
                for (let item of _data["defaultRoles"])
                    this.defaultRoles.push(StaffRolePaytypeResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaytypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isTaxable"] = this.isTaxable;
        data["defaultQuantity"] = this.defaultQuantity;
        data["defaultRate"] = this.defaultRate;
        data["autoAdd"] = this.autoAdd;
        data["module"] = this.module;
        if (Array.isArray(this.defaultStaff)) {
            data["defaultStaff"] = [];
            for (let item of this.defaultStaff)
                data["defaultStaff"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRoles)) {
            data["defaultRoles"] = [];
            for (let item of this.defaultRoles)
                data["defaultRoles"].push(item.toJSON());
        }
        return data;
    }
}
exports.PaytypeResponse = PaytypeResponse;
class PipeWriter {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.canGetUnflushedBytes = _data["canGetUnflushedBytes"];
            this.unflushedBytes = _data["unflushedBytes"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PipeWriter();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["canGetUnflushedBytes"] = this.canGetUnflushedBytes;
        data["unflushedBytes"] = this.unflushedBytes;
        return data;
    }
}
exports.PipeWriter = PipeWriter;
class PosItemsOrdersSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PosItemsOrdersSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        return data;
    }
}
exports.PosItemsOrdersSummary = PosItemsOrdersSummary;
class PosItemsStaffOrdersSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.itemPosIdentifier = _data["itemPosIdentifier"];
            this.itemGroupName = _data["itemGroupName"];
            this.itemGroupIdentifier = _data["itemGroupIdentifier"];
            this.itemCategoryName = _data["itemCategoryName"];
            this.itemCategoryIdentifier = _data["itemCategoryIdentifier"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PosItemsStaffOrdersSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["itemPosIdentifier"] = this.itemPosIdentifier;
        data["itemGroupName"] = this.itemGroupName;
        data["itemGroupIdentifier"] = this.itemGroupIdentifier;
        data["itemCategoryName"] = this.itemCategoryName;
        data["itemCategoryIdentifier"] = this.itemCategoryIdentifier;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        return data;
    }
}
exports.PosItemsStaffOrdersSummary = PosItemsStaffOrdersSummary;
class PosStaffDiscountsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.discountTypeIdentifier = _data["discountTypeIdentifier"];
            this.discountType = _data["discountType"];
            this.discountsAmount = _data["discountsAmount"];
            this.discountsCount = _data["discountsCount"];
            this.discountInvoices = _data["discountInvoices"];
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PosStaffDiscountsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeIdentifier"] = this.discountTypeIdentifier;
        data["discountType"] = this.discountType;
        data["discountsAmount"] = this.discountsAmount;
        data["discountsCount"] = this.discountsCount;
        data["discountInvoices"] = this.discountInvoices;
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        return data;
    }
}
exports.PosStaffDiscountsResponse = PosStaffDiscountsResponse;
class PosStaffSurchargesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.surchargeTypeIdentifier = _data["surchargeTypeIdentifier"];
            this.surchargeType = _data["surchargeType"];
            this.surchargesAmount = _data["surchargesAmount"];
            this.surchargesCount = _data["surchargesCount"];
            this.surchargeInvoices = _data["surchargeInvoices"];
            this.staffName = _data["staffName"];
            this.staffPosIdentifier = _data["staffPosIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PosStaffSurchargesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["surchargeTypeIdentifier"] = this.surchargeTypeIdentifier;
        data["surchargeType"] = this.surchargeType;
        data["surchargesAmount"] = this.surchargesAmount;
        data["surchargesCount"] = this.surchargesCount;
        data["surchargeInvoices"] = this.surchargeInvoices;
        data["staffName"] = this.staffName;
        data["staffPosIdentifier"] = this.staffPosIdentifier;
        return data;
    }
}
exports.PosStaffSurchargesResponse = PosStaffSurchargesResponse;
class PostActivatedPackageRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"] ? PackageRef.fromJS(_data["packageId"]) : undefined;
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [];
                for (let item of _data["conditions"])
                    this.conditions.push(BaseConditionModel.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostActivatedPackageRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId ? this.packageId.toJSON() : undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}
exports.PostActivatedPackageRequest = PostActivatedPackageRequest;
class PostClockinRuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinId = _data["clockinId"];
            this.ruleId = _data["ruleId"];
            this.source = _data["source"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : undefined;
            this.override = _data["override"] ? ClockinRuleOverrideModel.fromJS(_data["override"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostClockinRuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinId"] = this.clockinId;
        data["ruleId"] = this.ruleId;
        data["source"] = this.source;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["override"] = this.override ? this.override.toJSON() : undefined;
        return data;
    }
}
exports.PostClockinRuleRequest = PostClockinRuleRequest;
class PostPackageRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostPackageRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        return data;
    }
}
exports.PostPackageRequest = PostPackageRequest;
class PostPayTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.payType = _data["payType"];
            this.payCode = _data["payCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostPayTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["payType"] = this.payType;
        data["payCode"] = this.payCode;
        return data;
    }
}
exports.PostPayTypeRequest = PostPayTypeRequest;
class PostPaytypeEnabledRolesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffRoleId = _data["staffRoleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostPaytypeEnabledRolesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffRoleId"] = this.staffRoleId;
        return data;
    }
}
exports.PostPaytypeEnabledRolesRequest = PostPaytypeEnabledRolesRequest;
class PostPaytypeEnabledStaffRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffMemberId = _data["staffMemberId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostPaytypeEnabledStaffRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffMemberId"] = this.staffMemberId;
        return data;
    }
}
exports.PostPaytypeEnabledStaffRequest = PostPaytypeEnabledStaffRequest;
class PostPaytypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbrev = _data["abbrev"];
            this.module = _data["module"];
            this.isTaxable = _data["isTaxable"];
            this.defaultRate = _data["defaultRate"];
            this.defaultQuantity = _data["defaultQuantity"];
            this.autoAdd = _data["autoAdd"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            if (Array.isArray(_data["defaultStaff"])) {
                this.defaultStaff = [];
                for (let item of _data["defaultStaff"])
                    this.defaultStaff.push(PostPaytypeEnabledStaffRequest.fromJS(item));
            }
            if (Array.isArray(_data["defaultRoles"])) {
                this.defaultRoles = [];
                for (let item of _data["defaultRoles"])
                    this.defaultRoles.push(PostPaytypeEnabledRolesRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostPaytypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbrev"] = this.abbrev;
        data["module"] = this.module;
        data["isTaxable"] = this.isTaxable;
        data["defaultRate"] = this.defaultRate;
        data["defaultQuantity"] = this.defaultQuantity;
        data["autoAdd"] = this.autoAdd;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        if (Array.isArray(this.defaultStaff)) {
            data["defaultStaff"] = [];
            for (let item of this.defaultStaff)
                data["defaultStaff"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRoles)) {
            data["defaultRoles"] = [];
            for (let item of this.defaultRoles)
                data["defaultRoles"].push(item.toJSON());
        }
        return data;
    }
}
exports.PostPaytypeRequest = PostPaytypeRequest;
class PostRuleOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.packageRef = _data["packageRef"] ? PackageRef.fromJS(_data["packageRef"]) : undefined;
            this.ruleId = _data["ruleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostRuleOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["packageRef"] = this.packageRef ? this.packageRef.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        return data;
    }
}
exports.PostRuleOverrideRequest = PostRuleOverrideRequest;
class PostRuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.packageId = _data["packageId"] ? PackageRef.fromJS(_data["packageId"]) : undefined;
            this.payCode = _data["payCode"];
            this.type = _data["type"];
            this.evaluationType = _data["evaluationType"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [];
                for (let item of _data["conditions"])
                    this.conditions.push(BaseConditionModel.fromJS(item));
            }
            this.payTypeRef = _data["payTypeRef"] ? PayrollPayTypeRef.fromJS(_data["payTypeRef"]) : undefined;
            this.roundUpHours = _data["roundUpHours"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(PayAdjustmentRuleActionDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostRuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["packageId"] = this.packageId ? this.packageId.toJSON() : undefined;
        data["payCode"] = this.payCode;
        data["type"] = this.type;
        data["evaluationType"] = this.evaluationType;
        data["rate"] = this.rate;
        data["description"] = this.description;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["payTypeRef"] = this.payTypeRef ? this.payTypeRef.toJSON() : undefined;
        data["roundUpHours"] = this.roundUpHours;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}
exports.PostRuleRequest = PostRuleRequest;
class PostSyncPayRunModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.payRunId = _data["payRunId"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [];
                for (let item of _data["employeeIds"])
                    this.employeeIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostSyncPayRunModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["payRunId"] = this.payRunId;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }
}
exports.PostSyncPayRunModel = PostSyncPayRunModel;
class PriceInformationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.plan = _data["plan"];
            this.frequency = _data["frequency"];
            this.pricePerMonth = _data["pricePerMonth"];
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.taxName = _data["taxName"];
            this.planName = _data["planName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInformationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["frequency"] = this.frequency;
        data["pricePerMonth"] = this.pricePerMonth;
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["taxName"] = this.taxName;
        data["planName"] = this.planName;
        return data;
    }
}
exports.PriceInformationResponse = PriceInformationResponse;
var PropertyAttributes;
(function (PropertyAttributes) {
    PropertyAttributes[PropertyAttributes["_0"] = 0] = "_0";
    PropertyAttributes[PropertyAttributes["_512"] = 512] = "_512";
    PropertyAttributes[PropertyAttributes["_1024"] = 1024] = "_1024";
    PropertyAttributes[PropertyAttributes["_4096"] = 4096] = "_4096";
    PropertyAttributes[PropertyAttributes["_8192"] = 8192] = "_8192";
    PropertyAttributes[PropertyAttributes["_16384"] = 16384] = "_16384";
    PropertyAttributes[PropertyAttributes["_32768"] = 32768] = "_32768";
    PropertyAttributes[PropertyAttributes["_62464"] = 62464] = "_62464";
})(PropertyAttributes || (exports.PropertyAttributes = PropertyAttributes = {}));
class PropertyInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : undefined;
            this.attributes = _data["attributes"];
            this.isSpecialName = _data["isSpecialName"];
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : undefined;
        return data;
    }
}
exports.PropertyInfo = PropertyInfo;
class PublicKey {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.encodedKeyValue = _data["encodedKeyValue"] ? AsnEncodedData.fromJS(_data["encodedKeyValue"]) : undefined;
            this.encodedParameters = _data["encodedParameters"] ? AsnEncodedData.fromJS(_data["encodedParameters"]) : undefined;
            this.key = _data["key"] ? AsymmetricAlgorithm.fromJS(_data["key"]) : undefined;
            this.oid = _data["oid"] ? Oid.fromJS(_data["oid"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublicKey();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["encodedKeyValue"] = this.encodedKeyValue ? this.encodedKeyValue.toJSON() : undefined;
        data["encodedParameters"] = this.encodedParameters ? this.encodedParameters.toJSON() : undefined;
        data["key"] = this.key ? this.key.toJSON() : undefined;
        data["oid"] = this.oid ? this.oid.toJSON() : undefined;
        return data;
    }
}
exports.PublicKey = PublicKey;
class PublishRosterRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.lockRoster = _data["lockRoster"];
            this.publishRosterToWeb = _data["publishRosterToWeb"];
            this.additionalNote = _data["additionalNote"];
            if (Array.isArray(_data["staffMemberRosteredShiftsInfo"])) {
                this.staffMemberRosteredShiftsInfo = [];
                for (let item of _data["staffMemberRosteredShiftsInfo"])
                    this.staffMemberRosteredShiftsInfo.push(RosteredShifts.fromJS(item));
            }
            this.selectedShifts = _data["selectedShifts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PublishRosterRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["lockRoster"] = this.lockRoster;
        data["publishRosterToWeb"] = this.publishRosterToWeb;
        data["additionalNote"] = this.additionalNote;
        if (Array.isArray(this.staffMemberRosteredShiftsInfo)) {
            data["staffMemberRosteredShiftsInfo"] = [];
            for (let item of this.staffMemberRosteredShiftsInfo)
                data["staffMemberRosteredShiftsInfo"].push(item.toJSON());
        }
        data["selectedShifts"] = this.selectedShifts;
        return data;
    }
}
exports.PublishRosterRequest = PublishRosterRequest;
class PutActivatedPackageRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"] ? PackageRef.fromJS(_data["packageId"]) : undefined;
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : undefined;
            this.enabledAt = _data["enabledAt"] ? dayjs(_data["enabledAt"].toString()) : undefined;
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutActivatedPackageRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId ? this.packageId.toJSON() : undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["enabledAt"] = this.enabledAt ? this.enabledAt.toISOString() : undefined;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["type"] = this.type;
        return data;
    }
}
exports.PutActivatedPackageRequest = PutActivatedPackageRequest;
class PutItemRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderingUnitId = _data["orderingUnitId"];
            this.countingUnitId = _data["countingUnitId"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.defaultBrandId = _data["defaultBrandId"];
            this.defaultSupplierId = _data["defaultSupplierId"];
            this.globalPrice = _data["globalPrice"];
            this.globalSalesTaxRate = _data["globalSalesTaxRate"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [];
                for (let item of _data["suppliers"])
                    this.suppliers.push(PutItemSuppliersRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutItemRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderingUnitId"] = this.orderingUnitId;
        data["countingUnitId"] = this.countingUnitId;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["defaultBrandId"] = this.defaultBrandId;
        data["defaultSupplierId"] = this.defaultSupplierId;
        data["globalPrice"] = this.globalPrice;
        data["globalSalesTaxRate"] = this.globalSalesTaxRate;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        return data;
    }
}
exports.PutItemRequest = PutItemRequest;
class PutItemSuppliersRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.brandId = _data["brandId"];
            this.unitId = _data["unitId"];
            this.unitCost = _data["unitCost"];
            this.stockCode = _data["stockCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutItemSuppliersRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["brandId"] = this.brandId;
        data["unitId"] = this.unitId;
        data["unitCost"] = this.unitCost;
        data["stockCode"] = this.stockCode;
        return data;
    }
}
exports.PutItemSuppliersRequest = PutItemSuppliersRequest;
class PutPackageRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.packageRef = _data["packageRef"] ? PackageRef.fromJS(_data["packageRef"]) : undefined;
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutPackageRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["packageRef"] = this.packageRef ? this.packageRef.toJSON() : undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}
exports.PutPackageRequest = PutPackageRequest;
class PutPayTypeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.payTypeRef = _data["payTypeRef"] ? PayrollPayTypeRef.fromJS(_data["payTypeRef"]) : undefined;
            this.payType = _data["payType"];
            this.payCode = _data["payCode"];
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutPayTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["payTypeRef"] = this.payTypeRef ? this.payTypeRef.toJSON() : undefined;
        data["payType"] = this.payType;
        data["payCode"] = this.payCode;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        return data;
    }
}
exports.PutPayTypeRequest = PutPayTypeRequest;
class PutRuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.packageId = _data["packageId"] ? PackageRef.fromJS(_data["packageId"]) : undefined;
            this.payCode = _data["payCode"];
            this.evaluationType = _data["evaluationType"];
            this.type = _data["type"];
            this.rate = _data["rate"];
            this.description = _data["description"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [];
                for (let item of _data["conditions"])
                    this.conditions.push(BaseConditionModel.fromJS(item));
            }
            this.payTypeRef = _data["payTypeRef"] ? PayrollPayTypeRef.fromJS(_data["payTypeRef"]) : undefined;
            this.roundUpHours = _data["roundUpHours"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(PayAdjustmentRuleActionDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PutRuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["packageId"] = this.packageId ? this.packageId.toJSON() : undefined;
        data["payCode"] = this.payCode;
        data["evaluationType"] = this.evaluationType;
        data["type"] = this.type;
        data["rate"] = this.rate;
        data["description"] = this.description;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["payTypeRef"] = this.payTypeRef ? this.payTypeRef.toJSON() : undefined;
        data["roundUpHours"] = this.roundUpHours;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}
exports.PutRuleRequest = PutRuleRequest;
var QueryNodeKind;
(function (QueryNodeKind) {
    QueryNodeKind[QueryNodeKind["_0"] = 0] = "_0";
    QueryNodeKind[QueryNodeKind["_1"] = 1] = "_1";
    QueryNodeKind[QueryNodeKind["_2"] = 2] = "_2";
    QueryNodeKind[QueryNodeKind["_3"] = 3] = "_3";
    QueryNodeKind[QueryNodeKind["_4"] = 4] = "_4";
    QueryNodeKind[QueryNodeKind["_5"] = 5] = "_5";
    QueryNodeKind[QueryNodeKind["_6"] = 6] = "_6";
    QueryNodeKind[QueryNodeKind["_7"] = 7] = "_7";
    QueryNodeKind[QueryNodeKind["_8"] = 8] = "_8";
    QueryNodeKind[QueryNodeKind["_9"] = 9] = "_9";
    QueryNodeKind[QueryNodeKind["_10"] = 10] = "_10";
    QueryNodeKind[QueryNodeKind["_11"] = 11] = "_11";
    QueryNodeKind[QueryNodeKind["_12"] = 12] = "_12";
    QueryNodeKind[QueryNodeKind["_13"] = 13] = "_13";
    QueryNodeKind[QueryNodeKind["_14"] = 14] = "_14";
    QueryNodeKind[QueryNodeKind["_15"] = 15] = "_15";
    QueryNodeKind[QueryNodeKind["_16"] = 16] = "_16";
    QueryNodeKind[QueryNodeKind["_17"] = 17] = "_17";
    QueryNodeKind[QueryNodeKind["_18"] = 18] = "_18";
    QueryNodeKind[QueryNodeKind["_19"] = 19] = "_19";
    QueryNodeKind[QueryNodeKind["_20"] = 20] = "_20";
    QueryNodeKind[QueryNodeKind["_21"] = 21] = "_21";
    QueryNodeKind[QueryNodeKind["_22"] = 22] = "_22";
    QueryNodeKind[QueryNodeKind["_23"] = 23] = "_23";
    QueryNodeKind[QueryNodeKind["_24"] = 24] = "_24";
    QueryNodeKind[QueryNodeKind["_25"] = 25] = "_25";
    QueryNodeKind[QueryNodeKind["_26"] = 26] = "_26";
    QueryNodeKind[QueryNodeKind["_27"] = 27] = "_27";
    QueryNodeKind[QueryNodeKind["_28"] = 28] = "_28";
    QueryNodeKind[QueryNodeKind["_29"] = 29] = "_29";
    QueryNodeKind[QueryNodeKind["_30"] = 30] = "_30";
    QueryNodeKind[QueryNodeKind["_31"] = 31] = "_31";
    QueryNodeKind[QueryNodeKind["_32"] = 32] = "_32";
    QueryNodeKind[QueryNodeKind["_33"] = 33] = "_33";
})(QueryNodeKind || (exports.QueryNodeKind = QueryNodeKind = {}));
class QueryString {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueryString();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        return data;
    }
}
exports.QueryString = QueryString;
class RangeVariable {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.typeReference = _data["typeReference"] ? IEdmTypeReference.fromJS(_data["typeReference"]) : undefined;
            this.kind = _data["kind"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RangeVariable();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeReference"] = this.typeReference ? this.typeReference.toJSON() : undefined;
        data["kind"] = this.kind;
        return data;
    }
}
exports.RangeVariable = RangeVariable;
var RelationshipTypes;
(function (RelationshipTypes) {
    RelationshipTypes[RelationshipTypes["Brother"] = "Brother"] = "Brother";
    RelationshipTypes[RelationshipTypes["Daughter"] = "Daughter"] = "Daughter";
    RelationshipTypes[RelationshipTypes["Father"] = "Father"] = "Father";
    RelationshipTypes[RelationshipTypes["Fiance"] = "Fiance"] = "Fiance";
    RelationshipTypes[RelationshipTypes["Friend"] = "Friend"] = "Friend";
    RelationshipTypes[RelationshipTypes["Husband"] = "Husband"] = "Husband";
    RelationshipTypes[RelationshipTypes["Mother"] = "Mother"] = "Mother";
    RelationshipTypes[RelationshipTypes["Partner"] = "Partner"] = "Partner";
    RelationshipTypes[RelationshipTypes["Sister"] = "Sister"] = "Sister";
    RelationshipTypes[RelationshipTypes["Son"] = "Son"] = "Son";
    RelationshipTypes[RelationshipTypes["Wife"] = "Wife"] = "Wife";
    RelationshipTypes[RelationshipTypes["Other"] = "Other"] = "Other";
})(RelationshipTypes || (exports.RelationshipTypes = RelationshipTypes = {}));
var RemunerationType;
(function (RemunerationType) {
    RemunerationType[RemunerationType["_0"] = 0] = "_0";
    RemunerationType[RemunerationType["_1"] = 1] = "_1";
})(RemunerationType || (exports.RemunerationType = RemunerationType = {}));
var ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus[ResidencyStatus["Australian"] = "Australian"] = "Australian";
    ResidencyStatus[ResidencyStatus["Foreigner"] = "Foreigner"] = "Foreigner";
    ResidencyStatus[ResidencyStatus["WorkingHolidayMaker"] = "WorkingHolidayMaker"] = "WorkingHolidayMaker";
})(ResidencyStatus || (exports.ResidencyStatus = ResidencyStatus = {}));
class RosterRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? dayjs(_data["startDateTime"].toString()) : undefined;
            this.endDateTime = _data["endDateTime"] ? dayjs(_data["endDateTime"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.datestampPublished = _data["datestampPublished"] ? dayjs(_data["datestampPublished"].toString()) : undefined;
            this.datestampLocked = _data["datestampLocked"] ? dayjs(_data["datestampLocked"].toString()) : undefined;
            this.templateName = _data["templateName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RosterRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["datestampPublished"] = this.datestampPublished ? this.datestampPublished.toISOString() : undefined;
        data["datestampLocked"] = this.datestampLocked ? this.datestampLocked.toISOString() : undefined;
        data["templateName"] = this.templateName;
        return data;
    }
}
exports.RosterRequest = RosterRequest;
class RosteredShiftRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clockinTime = _data["clockinTime"] ? dayjs(_data["clockinTime"].toString()) : undefined;
            this.clockoutTime = _data["clockoutTime"] ? dayjs(_data["clockoutTime"].toString()) : undefined;
            this.roleId = _data["roleId"];
            this.jobs = _data["jobs"];
            this.staffMemberId = _data["staffMemberId"];
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [];
                for (let item of _data["breaks"])
                    this.breaks.push(BreakDto.fromJS(item));
            }
            this.rosterId = _data["rosterId"];
            this.templateName = _data["templateName"];
            this.datestampDeleted = _data["datestampDeleted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RosteredShiftRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clockinTime"] = this.clockinTime ? this.clockinTime.toISOString() : undefined;
        data["clockoutTime"] = this.clockoutTime ? this.clockoutTime.toISOString() : undefined;
        data["roleId"] = this.roleId;
        data["jobs"] = this.jobs;
        data["staffMemberId"] = this.staffMemberId;
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item.toJSON());
        }
        data["rosterId"] = this.rosterId;
        data["templateName"] = this.templateName;
        data["datestampDeleted"] = this.datestampDeleted;
        return data;
    }
}
exports.RosteredShiftRequest = RosteredShiftRequest;
class RosteredShifts {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffMemberId = _data["staffMemberId"];
            this.email = _data["email"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [];
                for (let item of _data["roleIds"])
                    this.roleIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RosteredShifts();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffMemberId"] = this.staffMemberId;
        data["email"] = this.email;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}
exports.RosteredShifts = RosteredShifts;
class Rule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.rate = _data["rate"];
            this.type = _data["type"];
            this.payCodeType = _data["payCodeType"];
            this.roundUpHours = _data["roundUpHours"];
            this.shortName = _data["shortName"];
            this.pgId = _data["pgId"];
            this.autoAdd = _data["autoAdd"];
            if (Array.isArray(_data["defaultStaff"])) {
                this.defaultStaff = [];
                for (let item of _data["defaultStaff"])
                    this.defaultStaff.push(StaffMemberPayRule.fromJS(item));
            }
            if (Array.isArray(_data["defaultRoles"])) {
                this.defaultRoles = [];
                for (let item of _data["defaultRoles"])
                    this.defaultRoles.push(StaffRolePayRule.fromJS(item));
            }
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [];
                for (let item of _data["schedule"])
                    this.schedule.push(RuleSchedule.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(PayAdjustmentRuleAction.fromJS(item));
            }
            this.packageRef = _data["packageRef"] ? PackageRef.fromJS(_data["packageRef"]) : undefined;
            this.payTypeRef = _data["payTypeRef"] ? PayrollPayTypeRef.fromJS(_data["payTypeRef"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Rule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["rate"] = this.rate;
        data["type"] = this.type;
        data["payCodeType"] = this.payCodeType;
        data["roundUpHours"] = this.roundUpHours;
        data["shortName"] = this.shortName;
        data["pgId"] = this.pgId;
        data["autoAdd"] = this.autoAdd;
        if (Array.isArray(this.defaultStaff)) {
            data["defaultStaff"] = [];
            for (let item of this.defaultStaff)
                data["defaultStaff"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRoles)) {
            data["defaultRoles"] = [];
            for (let item of this.defaultRoles)
                data["defaultRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["packageRef"] = this.packageRef ? this.packageRef.toJSON() : undefined;
        data["payTypeRef"] = this.payTypeRef ? this.payTypeRef.toJSON() : undefined;
        return data;
    }
}
exports.Rule = Rule;
var RuleActionType;
(function (RuleActionType) {
    RuleActionType[RuleActionType["RemoveAdjustment"] = "RemoveAdjustment"] = "RemoveAdjustment";
    RuleActionType[RuleActionType["RemovePackage"] = "RemovePackage"] = "RemovePackage";
    RuleActionType[RuleActionType["RemoveAllAdjustments"] = "RemoveAllAdjustments"] = "RemoveAllAdjustments";
    RuleActionType[RuleActionType["TotalMultiplier"] = "TotalMultiplier"] = "TotalMultiplier";
})(RuleActionType || (exports.RuleActionType = RuleActionType = {}));
var RuleOverrideType;
(function (RuleOverrideType) {
    RuleOverrideType[RuleOverrideType["Deactivate"] = "Deactivate"] = "Deactivate";
    RuleOverrideType[RuleOverrideType["Add"] = "Add"] = "Add";
})(RuleOverrideType || (exports.RuleOverrideType = RuleOverrideType = {}));
var RuleOverrideTypeModel;
(function (RuleOverrideTypeModel) {
    RuleOverrideTypeModel[RuleOverrideTypeModel["Deactivate"] = "Deactivate"] = "Deactivate";
    RuleOverrideTypeModel[RuleOverrideTypeModel["Add"] = "Add"] = "Add";
    RuleOverrideTypeModel[RuleOverrideTypeModel["TimeAdjustment"] = "TimeAdjustment"] = "TimeAdjustment";
})(RuleOverrideTypeModel || (exports.RuleOverrideTypeModel = RuleOverrideTypeModel = {}));
var RulePayCodeType;
(function (RulePayCodeType) {
    RulePayCodeType[RulePayCodeType["_0"] = 0] = "_0";
    RulePayCodeType[RulePayCodeType["_1"] = 1] = "_1";
    RulePayCodeType[RulePayCodeType["_2"] = 2] = "_2";
    RulePayCodeType[RulePayCodeType["_3"] = 3] = "_3";
    RulePayCodeType[RulePayCodeType["_4"] = 4] = "_4";
})(RulePayCodeType || (exports.RulePayCodeType = RulePayCodeType = {}));
var RulePayCodeTypeModel;
(function (RulePayCodeTypeModel) {
    RulePayCodeTypeModel[RulePayCodeTypeModel["Award"] = "Award"] = "Award";
    RulePayCodeTypeModel[RulePayCodeTypeModel["Allowance"] = "Allowance"] = "Allowance";
    RulePayCodeTypeModel[RulePayCodeTypeModel["PublicHoliday"] = "PublicHoliday"] = "PublicHoliday";
    RulePayCodeTypeModel[RulePayCodeTypeModel["Other"] = "Other"] = "Other";
})(RulePayCodeTypeModel || (exports.RulePayCodeTypeModel = RulePayCodeTypeModel = {}));
class RuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.rate = _data["rate"];
            this.type = _data["type"];
            this.autoAdd = _data["autoAdd"];
            if (Array.isArray(_data["defaultStaff"])) {
                this.defaultStaff = [];
                for (let item of _data["defaultStaff"])
                    this.defaultStaff.push(StaffMemberPayAdjustmentModel.fromJS(item));
            }
            if (Array.isArray(_data["defaultRoles"])) {
                this.defaultRoles = [];
                for (let item of _data["defaultRoles"])
                    this.defaultRoles.push(StaffRolePayAdjustmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [];
                for (let item of _data["schedule"])
                    this.schedule.push(RuleScheduleRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["rate"] = this.rate;
        data["type"] = this.type;
        data["autoAdd"] = this.autoAdd;
        if (Array.isArray(this.defaultStaff)) {
            data["defaultStaff"] = [];
            for (let item of this.defaultStaff)
                data["defaultStaff"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRoles)) {
            data["defaultRoles"] = [];
            for (let item of this.defaultRoles)
                data["defaultRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        return data;
    }
}
exports.RuleRequest = RuleRequest;
class RuleSchedule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.repeat = _data["repeat"];
            this.repeatEnd = _data["repeatEnd"] ? dayjs(_data["repeatEnd"].toString()) : undefined;
            this.days = _data["days"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuleSchedule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["repeat"] = this.repeat;
        data["repeatEnd"] = this.repeatEnd ? this.repeatEnd.toISOString() : undefined;
        data["days"] = this.days;
        return data;
    }
}
exports.RuleSchedule = RuleSchedule;
var RuleScheduleRepeat;
(function (RuleScheduleRepeat) {
    RuleScheduleRepeat[RuleScheduleRepeat["_0"] = 0] = "_0";
    RuleScheduleRepeat[RuleScheduleRepeat["_1"] = 1] = "_1";
    RuleScheduleRepeat[RuleScheduleRepeat["_2"] = 2] = "_2";
    RuleScheduleRepeat[RuleScheduleRepeat["_3"] = 3] = "_3";
    RuleScheduleRepeat[RuleScheduleRepeat["_4"] = 4] = "_4";
})(RuleScheduleRepeat || (exports.RuleScheduleRepeat = RuleScheduleRepeat = {}));
class RuleScheduleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.datestampStart = _data["datestampStart"] ? dayjs(_data["datestampStart"].toString()) : undefined;
            this.datestampEnd = _data["datestampEnd"] ? dayjs(_data["datestampEnd"].toString()) : undefined;
            this.repeat = _data["repeat"];
            this.repeatEnd = _data["repeatEnd"] ? dayjs(_data["repeatEnd"].toString()) : undefined;
            this.days = _data["days"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuleScheduleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["datestampStart"] = this.datestampStart ? this.datestampStart.toISOString() : undefined;
        data["datestampEnd"] = this.datestampEnd ? this.datestampEnd.toISOString() : undefined;
        data["repeat"] = this.repeat;
        data["repeatEnd"] = this.repeatEnd ? this.repeatEnd.toISOString() : undefined;
        data["days"] = this.days;
        return data;
    }
}
exports.RuleScheduleRequest = RuleScheduleRequest;
var RuleType;
(function (RuleType) {
    RuleType[RuleType["_0"] = 0] = "_0";
    RuleType[RuleType["_1"] = 1] = "_1";
    RuleType[RuleType["_2"] = 2] = "_2";
    RuleType[RuleType["_3"] = 3] = "_3";
    RuleType[RuleType["_4"] = 4] = "_4";
})(RuleType || (exports.RuleType = RuleType = {}));
var RuleTypeModel;
(function (RuleTypeModel) {
    RuleTypeModel[RuleTypeModel["Add"] = "Add"] = "Add";
    RuleTypeModel[RuleTypeModel["Subtract"] = "Subtract"] = "Subtract";
    RuleTypeModel[RuleTypeModel["Equals"] = "Equals"] = "Equals";
    RuleTypeModel[RuleTypeModel["Multiple"] = "Multiple"] = "Multiple";
    RuleTypeModel[RuleTypeModel["PercentageTotal"] = "PercentageTotal"] = "PercentageTotal";
})(RuleTypeModel || (exports.RuleTypeModel = RuleTypeModel = {}));
class RuntimeFieldHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    }
}
exports.RuntimeFieldHandle = RuntimeFieldHandle;
class RuntimeMethodHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    }
}
exports.RuntimeMethodHandle = RuntimeMethodHandle;
class RuntimeTypeHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    }
}
exports.RuntimeTypeHandle = RuntimeTypeHandle;
class SafeWaitHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isClosed = _data["isClosed"];
            this.isInvalid = _data["isInvalid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SafeWaitHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isClosed"] = this.isClosed;
        data["isInvalid"] = this.isInvalid;
        return data;
    }
}
exports.SafeWaitHandle = SafeWaitHandle;
class SalesTaxDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.label = _data["label"];
            this.rate = _data["rate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTaxDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["label"] = this.label;
        data["rate"] = this.rate;
        return data;
    }
}
exports.SalesTaxDto = SalesTaxDto;
class SearchClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : undefined;
        return data;
    }
}
exports.SearchClause = SearchClause;
class SearchQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.resultClrType = _data["resultClrType"] ? Type.fromJS(_data["resultClrType"]) : undefined;
            this.searchClause = _data["searchClause"] ? SearchClause.fromJS(_data["searchClause"]) : undefined;
            this.rawValue = _data["rawValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["resultClrType"] = this.resultClrType ? this.resultClrType.toJSON() : undefined;
        data["searchClause"] = this.searchClause ? this.searchClause.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }
}
exports.SearchQueryOption = SearchQueryOption;
var SecurityRuleSet;
(function (SecurityRuleSet) {
    SecurityRuleSet[SecurityRuleSet["_0"] = 0] = "_0";
    SecurityRuleSet[SecurityRuleSet["_1"] = 1] = "_1";
    SecurityRuleSet[SecurityRuleSet["_2"] = 2] = "_2";
})(SecurityRuleSet || (exports.SecurityRuleSet = SecurityRuleSet = {}));
class SelectExpandClause {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["selectedItems"])) {
                this.selectedItems = [];
                for (let item of _data["selectedItems"])
                    this.selectedItems.push(SelectItem.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandClause();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedItems)) {
            data["selectedItems"] = [];
            for (let item of this.selectedItems)
                data["selectedItems"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }
}
exports.SelectExpandClause = SelectExpandClause;
class SelectExpandQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.rawSelect = _data["rawSelect"];
            this.rawExpand = _data["rawExpand"];
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : undefined;
            this.validator = _data["validator"] ? ISelectExpandQueryValidator.fromJS(_data["validator"]) : undefined;
            this.selectExpandClause = _data["selectExpandClause"] ? SelectExpandClause.fromJS(_data["selectExpandClause"]) : undefined;
            this.levelsMaxLiteralExpansionDepth = _data["levelsMaxLiteralExpansionDepth"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["rawSelect"] = this.rawSelect;
        data["rawExpand"] = this.rawExpand;
        data["compute"] = this.compute ? this.compute.toJSON() : undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["selectExpandClause"] = this.selectExpandClause ? this.selectExpandClause.toJSON() : undefined;
        data["levelsMaxLiteralExpansionDepth"] = this.levelsMaxLiteralExpansionDepth;
        return data;
    }
}
exports.SelectExpandQueryOption = SelectExpandQueryOption;
class SelectItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.SelectItem = SelectItem;
var SelectedShifts;
(function (SelectedShifts) {
    SelectedShifts[SelectedShifts["AllShifts"] = "AllShifts"] = "AllShifts";
    SelectedShifts[SelectedShifts["UpdatedShiftsOnly"] = "UpdatedShiftsOnly"] = "UpdatedShiftsOnly";
})(SelectedShifts || (exports.SelectedShifts = SelectedShifts = {}));
class SendgridWebHookResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.event = _data["event"];
            this.email = _data["email"];
            this.timestamp = _data["timestamp"];
            this.commId = _data["commId"];
            this.companyId = _data["companyId"];
            this.reason = _data["reason"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SendgridWebHookResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["email"] = this.email;
        data["timestamp"] = this.timestamp;
        data["commId"] = this.commId;
        data["companyId"] = this.companyId;
        data["reason"] = this.reason;
        return data;
    }
}
exports.SendgridWebHookResponse = SendgridWebHookResponse;
class SetPreferenceBindingModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetPreferenceBindingModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}
exports.SetPreferenceBindingModel = SetPreferenceBindingModel;
var ShiftType;
(function (ShiftType) {
    ShiftType[ShiftType["Clockin"] = "Clockin"] = "Clockin";
    ShiftType[ShiftType["Roster"] = "Roster"] = "Roster";
    ShiftType[ShiftType["RosterTemplate"] = "RosterTemplate"] = "RosterTemplate";
})(ShiftType || (exports.ShiftType = ShiftType = {}));
class SingleValueNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.typeReference = _data["typeReference"] ? IEdmTypeReference.fromJS(_data["typeReference"]) : undefined;
            this.kind = _data["kind"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SingleValueNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["typeReference"] = this.typeReference ? this.typeReference.toJSON() : undefined;
        data["kind"] = this.kind;
        return data;
    }
}
exports.SingleValueNode = SingleValueNode;
class SkipQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? ISkipQueryValidator.fromJS(_data["validator"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SkipQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    }
}
exports.SkipQueryOption = SkipQueryOption;
class SkipTokenHandler {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SkipTokenHandler();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
exports.SkipTokenHandler = SkipTokenHandler;
class SkipTokenQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rawValue = _data["rawValue"];
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.validator = _data["validator"] ? ISkipTokenQueryValidator.fromJS(_data["validator"]) : undefined;
            this.handler = _data["handler"] ? SkipTokenHandler.fromJS(_data["handler"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SkipTokenQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rawValue"] = this.rawValue;
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["handler"] = this.handler ? this.handler.toJSON() : undefined;
        return data;
    }
}
exports.SkipTokenQueryOption = SkipTokenQueryOption;
class StaffMember {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.posIdentifier = _data["posIdentifier"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampStarted = _data["datestampStarted"] ? dayjs(_data["datestampStarted"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.name = _data["name"];
            this.phoneHome = _data["phoneHome"];
            this.phoneMobile = _data["phoneMobile"];
            this.email = _data["email"];
            this.homeAddressUnit = _data["homeAddressUnit"];
            this.homeAddressStreet = _data["homeAddressStreet"];
            this.homeAddressSuburb = _data["homeAddressSuburb"];
            this.homeAddressCity = _data["homeAddressCity"];
            this.homeAddressState = _data["homeAddressState"];
            this.homeAddressZipCode = _data["homeAddressZipCode"];
            this.homeAddressCountry = _data["homeAddressCountry"];
            this.staffPayCode = _data["staffPayCode"];
            this.showInRoster = _data["showInRoster"];
            this.pgId = _data["pgId"];
            this.defaultRoleId = _data["defaultRoleId"];
            if (Array.isArray(_data["memberRoles"])) {
                this.memberRoles = [];
                for (let item of _data["memberRoles"])
                    this.memberRoles.push(StaffMemberRole.fromJS(item));
            }
            this.defaultRole = _data["defaultRole"] ? StaffRole.fromJS(_data["defaultRole"]) : undefined;
            this.defaultMemberRole = _data["defaultMemberRole"] ? StaffMemberRole.fromJS(_data["defaultMemberRole"]) : undefined;
            if (Array.isArray(_data["clockins"])) {
                this.clockins = [];
                for (let item of _data["clockins"])
                    this.clockins.push(Clockin.fromJS(item));
            }
            if (Array.isArray(_data["remunerationHistory"])) {
                this.remunerationHistory = [];
                for (let item of _data["remunerationHistory"])
                    this.remunerationHistory.push(StaffMemberRemunerationHistory.fromJS(item));
            }
            this.activeRemuneration = _data["activeRemuneration"] ? StaffMemberRemunerationHistory.fromJS(_data["activeRemuneration"]) : undefined;
            this.previousRemuneration = _data["previousRemuneration"] ? StaffMemberRemunerationHistory.fromJS(_data["previousRemuneration"]) : undefined;
            this.nextRemuneration = _data["nextRemuneration"] ? StaffMemberRemunerationHistory.fromJS(_data["nextRemuneration"]) : undefined;
            this.queryTime = _data["queryTime"] ? dayjs(_data["queryTime"].toString()) : undefined;
            this.lastClock = _data["lastClock"] ? Clockin.fromJS(_data["lastClock"]) : undefined;
            if (Array.isArray(_data["paytypes"])) {
                this.paytypes = [];
                for (let item of _data["paytypes"])
                    this.paytypes.push(StaffMemberPaytype.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(StaffMemberPayRule.fromJS(item));
            }
            this.isExported = _data["isExported"];
            this.thirdPartyEmployeeId = _data["thirdPartyEmployeeId"];
            this.lineManagerId = _data["lineManagerId"];
            this.preferredName = _data["preferredName"];
            this.middleName = _data["middleName"];
            this.gender = _data["gender"];
            this.dob = _data["dob"] ? dayjs(_data["dob"].toString()) : undefined;
            this.emergencyContactId = _data["emergencyContactId"];
            this.emergencyContact = _data["emergencyContact"] ? Contact.fromJS(_data["emergencyContact"]) : undefined;
            this.employmentType = _data["employmentType"];
            this.weeklyContractedHours = _data["weeklyContractedHours"];
            this.applyAdjustments = _data["applyAdjustments"];
            if (Array.isArray(_data["remunerationSnapshots"])) {
                this.remunerationSnapshots = [];
                for (let item of _data["remunerationSnapshots"])
                    this.remunerationSnapshots.push(StaffMemberRemunerationSnapshot.fromJS(item));
            }
            this.staffMemberAu = _data["staffMemberAu"] ? StaffMemberAu.fromJS(_data["staffMemberAu"]) : undefined;
            this.staffMemberNz = _data["staffMemberNz"] ? StaffMemberNz.fromJS(_data["staffMemberNz"]) : undefined;
            this.staffMemberAuPayrollDetail = _data["staffMemberAuPayrollDetail"] ? StaffMemberAuPayrollDetail.fromJS(_data["staffMemberAuPayrollDetail"]) : undefined;
            this.country = _data["country"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMember();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["posIdentifier"] = this.posIdentifier;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampStarted"] = this.datestampStarted ? this.datestampStarted.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["name"] = this.name;
        data["phoneHome"] = this.phoneHome;
        data["phoneMobile"] = this.phoneMobile;
        data["email"] = this.email;
        data["homeAddressUnit"] = this.homeAddressUnit;
        data["homeAddressStreet"] = this.homeAddressStreet;
        data["homeAddressSuburb"] = this.homeAddressSuburb;
        data["homeAddressCity"] = this.homeAddressCity;
        data["homeAddressState"] = this.homeAddressState;
        data["homeAddressZipCode"] = this.homeAddressZipCode;
        data["homeAddressCountry"] = this.homeAddressCountry;
        data["staffPayCode"] = this.staffPayCode;
        data["showInRoster"] = this.showInRoster;
        data["pgId"] = this.pgId;
        data["defaultRoleId"] = this.defaultRoleId;
        if (Array.isArray(this.memberRoles)) {
            data["memberRoles"] = [];
            for (let item of this.memberRoles)
                data["memberRoles"].push(item.toJSON());
        }
        data["defaultRole"] = this.defaultRole ? this.defaultRole.toJSON() : undefined;
        data["defaultMemberRole"] = this.defaultMemberRole ? this.defaultMemberRole.toJSON() : undefined;
        if (Array.isArray(this.clockins)) {
            data["clockins"] = [];
            for (let item of this.clockins)
                data["clockins"].push(item.toJSON());
        }
        if (Array.isArray(this.remunerationHistory)) {
            data["remunerationHistory"] = [];
            for (let item of this.remunerationHistory)
                data["remunerationHistory"].push(item.toJSON());
        }
        data["activeRemuneration"] = this.activeRemuneration ? this.activeRemuneration.toJSON() : undefined;
        data["previousRemuneration"] = this.previousRemuneration ? this.previousRemuneration.toJSON() : undefined;
        data["nextRemuneration"] = this.nextRemuneration ? this.nextRemuneration.toJSON() : undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toISOString() : undefined;
        data["lastClock"] = this.lastClock ? this.lastClock.toJSON() : undefined;
        if (Array.isArray(this.paytypes)) {
            data["paytypes"] = [];
            for (let item of this.paytypes)
                data["paytypes"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["isExported"] = this.isExported;
        data["thirdPartyEmployeeId"] = this.thirdPartyEmployeeId;
        data["lineManagerId"] = this.lineManagerId;
        data["preferredName"] = this.preferredName;
        data["middleName"] = this.middleName;
        data["gender"] = this.gender;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined;
        data["emergencyContactId"] = this.emergencyContactId;
        data["emergencyContact"] = this.emergencyContact ? this.emergencyContact.toJSON() : undefined;
        data["employmentType"] = this.employmentType;
        data["weeklyContractedHours"] = this.weeklyContractedHours;
        data["applyAdjustments"] = this.applyAdjustments;
        if (Array.isArray(this.remunerationSnapshots)) {
            data["remunerationSnapshots"] = [];
            for (let item of this.remunerationSnapshots)
                data["remunerationSnapshots"].push(item.toJSON());
        }
        data["staffMemberAu"] = this.staffMemberAu ? this.staffMemberAu.toJSON() : undefined;
        data["staffMemberNz"] = this.staffMemberNz ? this.staffMemberNz.toJSON() : undefined;
        data["staffMemberAuPayrollDetail"] = this.staffMemberAuPayrollDetail ? this.staffMemberAuPayrollDetail.toJSON() : undefined;
        data["country"] = this.country;
        return data;
    }
}
exports.StaffMember = StaffMember;
class StaffMemberAu {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.bankAccountName = _data["bankAccountName"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bsb = _data["bsb"];
            this.taxFileNumber = _data["taxFileNumber"];
            this.hasTaxFileNumberExemption = _data["hasTaxFileNumberExemption"];
            this.taxFileNumberExemptionType = _data["taxFileNumberExemptionType"];
            this.residencyStatus = _data["residencyStatus"];
            this.incomeType = _data["incomeType"];
            this.taxScaleType = _data["taxScaleType"];
            this.claimingTaxFreeThreshold = _data["claimingTaxFreeThreshold"];
            this.claimingZoneOverseasOrInvalid = _data["claimingZoneOverseasOrInvalid"];
            this.annualOffsetAmountClaimed = _data["annualOffsetAmountClaimed"];
            this.payeesWorkingCondition = _data["payeesWorkingCondition"];
            this.hasStudyLoanOrFinancialDebt = _data["hasStudyLoanOrFinancialDebt"];
            this.superFundId = _data["superFundId"];
            this.superFundNameOrUsi = _data["superFundNameOrUsi"];
            this.superFundSelfManaged = _data["superFundSelfManaged"];
            this.superFundMemberNumber = _data["superFundMemberNumber"];
            this.superFundABN = _data["superFundABN"];
            this.superFundESA = _data["superFundESA"];
            this.superFundAccountName = _data["superFundAccountName"];
            this.superFundAccountNumber = _data["superFundAccountNumber"];
            this.superFundBSB = _data["superFundBSB"];
            this.pensionersMaritalStatus = _data["pensionersMaritalStatus"];
            this.calendarId = _data["calendarId"];
            this.notEligibleForSuperFund = _data["notEligibleForSuperFund"];
            this.ordinaryEarningsRate = _data["ordinaryEarningsRate"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberAu();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["bankAccountName"] = this.bankAccountName;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bsb"] = this.bsb;
        data["taxFileNumber"] = this.taxFileNumber;
        data["hasTaxFileNumberExemption"] = this.hasTaxFileNumberExemption;
        data["taxFileNumberExemptionType"] = this.taxFileNumberExemptionType;
        data["residencyStatus"] = this.residencyStatus;
        data["incomeType"] = this.incomeType;
        data["taxScaleType"] = this.taxScaleType;
        data["claimingTaxFreeThreshold"] = this.claimingTaxFreeThreshold;
        data["claimingZoneOverseasOrInvalid"] = this.claimingZoneOverseasOrInvalid;
        data["annualOffsetAmountClaimed"] = this.annualOffsetAmountClaimed;
        data["payeesWorkingCondition"] = this.payeesWorkingCondition;
        data["hasStudyLoanOrFinancialDebt"] = this.hasStudyLoanOrFinancialDebt;
        data["superFundId"] = this.superFundId;
        data["superFundNameOrUsi"] = this.superFundNameOrUsi;
        data["superFundSelfManaged"] = this.superFundSelfManaged;
        data["superFundMemberNumber"] = this.superFundMemberNumber;
        data["superFundABN"] = this.superFundABN;
        data["superFundESA"] = this.superFundESA;
        data["superFundAccountName"] = this.superFundAccountName;
        data["superFundAccountNumber"] = this.superFundAccountNumber;
        data["superFundBSB"] = this.superFundBSB;
        data["pensionersMaritalStatus"] = this.pensionersMaritalStatus;
        data["calendarId"] = this.calendarId;
        data["notEligibleForSuperFund"] = this.notEligibleForSuperFund;
        data["ordinaryEarningsRate"] = this.ordinaryEarningsRate;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberAu = StaffMemberAu;
class StaffMemberAuPayrollDetail {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.calenderId = _data["calenderId"];
            this.ordinaryEarningsRate = _data["ordinaryEarningsRate"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberAuPayrollDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["calenderId"] = this.calenderId;
        data["ordinaryEarningsRate"] = this.ordinaryEarningsRate;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberAuPayrollDetail = StaffMemberAuPayrollDetail;
class StaffMemberIdEmailPair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberIdEmailPair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}
exports.StaffMemberIdEmailPair = StaffMemberIdEmailPair;
class StaffMemberJsonPatchDocument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [];
                for (let item of _data["operations"])
                    this.operations.push(StaffMemberOperation.fromJS(item));
            }
            this.contractResolver = _data["contractResolver"] ? IContractResolver.fromJS(_data["contractResolver"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberJsonPatchDocument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item.toJSON());
        }
        data["contractResolver"] = this.contractResolver ? this.contractResolver.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberJsonPatchDocument = StaffMemberJsonPatchDocument;
class StaffMemberNz {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.bankAccountName = _data["bankAccountName"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.irdNumber = _data["irdNumber"];
            this.taxCode = _data["taxCode"];
            this.employerKiwisaverContributionTaxRate = _data["employerKiwisaverContributionTaxRate"];
            this.kiwisaverStatus = _data["kiwisaverStatus"];
            this.contributionOption = _data["contributionOption"];
            this.employeeContribution = _data["employeeContribution"];
            this.employerContribution = _data["employerContribution"];
            this.employerContributionThroughSalarySacrifice = _data["employerContributionThroughSalarySacrifice"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberNz();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["bankAccountName"] = this.bankAccountName;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["irdNumber"] = this.irdNumber;
        data["taxCode"] = this.taxCode;
        data["employerKiwisaverContributionTaxRate"] = this.employerKiwisaverContributionTaxRate;
        data["kiwisaverStatus"] = this.kiwisaverStatus;
        data["contributionOption"] = this.contributionOption;
        data["employeeContribution"] = this.employeeContribution;
        data["employerContribution"] = this.employerContribution;
        data["employerContributionThroughSalarySacrifice"] = this.employerContributionThroughSalarySacrifice;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberNz = StaffMemberNz;
class StaffMemberOperation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.operationType = _data["operationType"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberOperation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        data["value"] = this.value;
        return data;
    }
}
exports.StaffMemberOperation = StaffMemberOperation;
class StaffMemberPayAdjustmentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffMemberId = _data["staffMemberId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberPayAdjustmentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffMemberId"] = this.staffMemberId;
        return data;
    }
}
exports.StaffMemberPayAdjustmentModel = StaffMemberPayAdjustmentModel;
class StaffMemberPayClassificationReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.payClassificationId = _data["payClassificationId"];
            this.staffMemberRoleId = _data["staffMemberRoleId"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.memberRole = _data["memberRole"] ? StaffMemberRole.fromJS(_data["memberRole"]) : undefined;
            this.payClassification = _data["payClassification"] ? PayClassification.fromJS(_data["payClassification"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberPayClassificationReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payClassificationId"] = this.payClassificationId;
        data["staffMemberRoleId"] = this.staffMemberRoleId;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["memberRole"] = this.memberRole ? this.memberRole.toJSON() : undefined;
        data["payClassification"] = this.payClassification ? this.payClassification.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberPayClassificationReference = StaffMemberPayClassificationReference;
class StaffMemberPayRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberPayRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberPayRule = StaffMemberPayRule;
class StaffMemberPaytype {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
            this.paytypeId = _data["paytypeId"];
            this.paytype = _data["paytype"] ? Paytype.fromJS(_data["paytype"]) : undefined;
            this.values = _data["values"];
            if (_data["valuesObject"]) {
                this.valuesObject = {};
                for (let key in _data["valuesObject"]) {
                    if (_data["valuesObject"].hasOwnProperty(key))
                        this.valuesObject[key] = _data["valuesObject"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberPaytype();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        data["paytypeId"] = this.paytypeId;
        data["paytype"] = this.paytype ? this.paytype.toJSON() : undefined;
        data["values"] = this.values;
        if (this.valuesObject) {
            data["valuesObject"] = {};
            for (let key in this.valuesObject) {
                if (this.valuesObject.hasOwnProperty(key))
                    data["valuesObject"][key] = this.valuesObject[key];
            }
        }
        return data;
    }
}
exports.StaffMemberPaytype = StaffMemberPaytype;
class StaffMemberPaytypeModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.paytypeId = _data["paytypeId"];
            this.paytypeName = _data["paytypeName"];
            this.paytypeDefaultRate = _data["paytypeDefaultRate"];
            this.paytypeDefaultQuantity = _data["paytypeDefaultQuantity"];
            this.values = _data["values"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberPaytypeModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["paytypeId"] = this.paytypeId;
        data["paytypeName"] = this.paytypeName;
        data["paytypeDefaultRate"] = this.paytypeDefaultRate;
        data["paytypeDefaultQuantity"] = this.paytypeDefaultQuantity;
        data["values"] = this.values;
        return data;
    }
}
exports.StaffMemberPaytypeModel = StaffMemberPaytypeModel;
class StaffMemberRemunerationHistory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.staffMember = _data["staffMember"] ? StaffMember.fromJS(_data["staffMember"]) : undefined;
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.type = _data["type"];
            this.rate = _data["rate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRemunerationHistory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["staffMember"] = this.staffMember ? this.staffMember.toJSON() : undefined;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["type"] = this.type;
        data["rate"] = this.rate;
        return data;
    }
}
exports.StaffMemberRemunerationHistory = StaffMemberRemunerationHistory;
class StaffMemberRemunerationHistoryRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.type = _data["type"];
            this.rate = _data["rate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRemunerationHistoryRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["type"] = this.type;
        data["rate"] = this.rate;
        return data;
    }
}
exports.StaffMemberRemunerationHistoryRequestModel = StaffMemberRemunerationHistoryRequestModel;
class StaffMemberRemunerationSnapshot {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.validFrom = _data["validFrom"] ? dayjs(_data["validFrom"].toString()) : undefined;
            this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : undefined;
            this.isActiveRemuneration = _data["isActiveRemuneration"];
            this.payload = _data["payload"];
            this.userId = _data["userId"];
            this.userFullName = _data["userFullName"];
            this.operation = _data["operation"];
            this.snapshotRelatedTo = _data["snapshotRelatedTo"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampModified = _data["datestampModified"] ? dayjs(_data["datestampModified"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRemunerationSnapshot();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined;
        data["isActiveRemuneration"] = this.isActiveRemuneration;
        data["payload"] = this.payload;
        data["userId"] = this.userId;
        data["userFullName"] = this.userFullName;
        data["operation"] = this.operation;
        data["snapshotRelatedTo"] = this.snapshotRelatedTo;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampModified"] = this.datestampModified ? this.datestampModified.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.StaffMemberRemunerationSnapshot = StaffMemberRemunerationSnapshot;
class StaffMemberRemunerationSnapshotRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.isActiveRemuneration = _data["isActiveRemuneration"];
            this.staffMemberId = _data["staffMemberId"];
            this.defaultRoleId = _data["defaultRoleId"];
            this.validFrom = _data["validFrom"];
            this.validTo = _data["validTo"];
            this.type = _data["type"];
            this.salaryRate = _data["salaryRate"];
            this.employmentType = _data["employmentType"];
            this.weeklyContractedHours = _data["weeklyContractedHours"];
            if (Array.isArray(_data["memberRoles"])) {
                this.memberRoles = [];
                for (let item of _data["memberRoles"])
                    this.memberRoles.push(StaffMemberRoleModel.fromJS(item));
            }
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRemunerationSnapshotRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActiveRemuneration"] = this.isActiveRemuneration;
        data["staffMemberId"] = this.staffMemberId;
        data["defaultRoleId"] = this.defaultRoleId;
        data["validFrom"] = this.validFrom;
        data["validTo"] = this.validTo;
        data["type"] = this.type;
        data["salaryRate"] = this.salaryRate;
        data["employmentType"] = this.employmentType;
        data["weeklyContractedHours"] = this.weeklyContractedHours;
        if (Array.isArray(this.memberRoles)) {
            data["memberRoles"] = [];
            for (let item of this.memberRoles)
                data["memberRoles"].push(item.toJSON());
        }
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.StaffMemberRemunerationSnapshotRequest = StaffMemberRemunerationSnapshotRequest;
class StaffMemberRole {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.member = _data["member"] ? StaffMember.fromJS(_data["member"]) : undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? StaffRole.fromJS(_data["role"]) : undefined;
            this.hourlyRate = _data["hourlyRate"];
            this.code = _data["code"];
            this.payClassificationId = _data["payClassificationId"];
            this.payClassificationVariationId = _data["payClassificationVariationId"];
            this.payClassificationReference = _data["payClassificationReference"] ? StaffMemberPayClassificationReference.fromJS(_data["payClassificationReference"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRole();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined;
        data["hourlyRate"] = this.hourlyRate;
        data["code"] = this.code;
        data["payClassificationId"] = this.payClassificationId;
        data["payClassificationVariationId"] = this.payClassificationVariationId;
        data["payClassificationReference"] = this.payClassificationReference ? this.payClassificationReference.toJSON() : undefined;
        return data;
    }
}
exports.StaffMemberRole = StaffMemberRole;
class StaffMemberRoleModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.hourlyRate = _data["hourlyRate"];
            this.code = _data["code"];
            this.payClassificationId = _data["payClassificationId"];
            this.payClassificationVariationId = _data["payClassificationVariationId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRoleModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["hourlyRate"] = this.hourlyRate;
        data["code"] = this.code;
        data["payClassificationId"] = this.payClassificationId;
        data["payClassificationVariationId"] = this.payClassificationVariationId;
        return data;
    }
}
exports.StaffMemberRoleModel = StaffMemberRoleModel;
class StaffMemberRoleRequestModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? UpdateStaffPosMemberRoleRequest.fromJS(_data["role"]) : undefined;
            this.hourlyRate = _data["hourlyRate"];
            this.code = _data["code"];
            this.payClassificationId = _data["payClassificationId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffMemberRoleRequestModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined;
        data["hourlyRate"] = this.hourlyRate;
        data["code"] = this.code;
        data["payClassificationId"] = this.payClassificationId;
        return data;
    }
}
exports.StaffMemberRoleRequestModel = StaffMemberRoleRequestModel;
class StaffRole {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.posIdentifier = _data["posIdentifier"];
            this.name = _data["name"];
            this.costGroup = _data["costGroup"];
            this.deptCode = _data["deptCode"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.pgId = _data["pgId"];
            if (Array.isArray(_data["paytypeValues"])) {
                this.paytypeValues = [];
                for (let item of _data["paytypeValues"])
                    this.paytypeValues.push(StaffRolePaytype.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(StaffRolePayRule.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRole();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["posIdentifier"] = this.posIdentifier;
        data["name"] = this.name;
        data["costGroup"] = this.costGroup;
        data["deptCode"] = this.deptCode;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["pgId"] = this.pgId;
        if (Array.isArray(this.paytypeValues)) {
            data["paytypeValues"] = [];
            for (let item of this.paytypeValues)
                data["paytypeValues"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}
exports.StaffRole = StaffRole;
class StaffRolePayAdjustmentRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.staffRoleId = _data["staffRoleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRolePayAdjustmentRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["staffRoleId"] = this.staffRoleId;
        return data;
    }
}
exports.StaffRolePayAdjustmentRequest = StaffRolePayAdjustmentRequest;
class StaffRolePayRule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffRoleId = _data["staffRoleId"];
            this.staffRole = _data["staffRole"] ? StaffRole.fromJS(_data["staffRole"]) : undefined;
            this.ruleId = _data["ruleId"];
            this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRolePayRule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffRoleId"] = this.staffRoleId;
        data["staffRole"] = this.staffRole ? this.staffRole.toJSON() : undefined;
        data["ruleId"] = this.ruleId;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined;
        return data;
    }
}
exports.StaffRolePayRule = StaffRolePayRule;
class StaffRolePaytype {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffRoleId = _data["staffRoleId"];
            this.staffRole = _data["staffRole"] ? StaffRole.fromJS(_data["staffRole"]) : undefined;
            this.paytypeId = _data["paytypeId"];
            this.paytype = _data["paytype"] ? Paytype.fromJS(_data["paytype"]) : undefined;
            this.values = _data["values"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRolePaytype();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffRoleId"] = this.staffRoleId;
        data["staffRole"] = this.staffRole ? this.staffRole.toJSON() : undefined;
        data["paytypeId"] = this.paytypeId;
        data["paytype"] = this.paytype ? this.paytype.toJSON() : undefined;
        data["values"] = this.values;
        return data;
    }
}
exports.StaffRolePaytype = StaffRolePaytype;
class StaffRolePaytypeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffRoleId = _data["staffRoleId"];
            this.paytypeId = _data["paytypeId"];
            this.values = _data["values"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRolePaytypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffRoleId"] = this.staffRoleId;
        data["paytypeId"] = this.paytypeId;
        data["values"] = this.values;
        return data;
    }
}
exports.StaffRolePaytypeResponse = StaffRolePaytypeResponse;
class StaffRoleResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.posIdentifier = _data["posIdentifier"];
            this.name = _data["name"];
            this.costGroup = _data["costGroup"];
            this.deptCode = _data["deptCode"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StaffRoleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["posIdentifier"] = this.posIdentifier;
        data["name"] = this.name;
        data["costGroup"] = this.costGroup;
        data["deptCode"] = this.deptCode;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        return data;
    }
}
exports.StaffRoleResponse = StaffRoleResponse;
class StringStringKeyValuePair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringKeyValuePair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}
exports.StringStringKeyValuePair = StringStringKeyValuePair;
class StringStringValuesKeyValuePair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [];
                for (let item of _data["value"])
                    this.value.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringValuesKeyValuePair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}
exports.StringStringValuesKeyValuePair = StringStringValuesKeyValuePair;
class StructLayoutAttribute {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}
exports.StructLayoutAttribute = StructLayoutAttribute;
class SubscriptionCompanyModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.shortName = _data["shortName"];
            this.ownerId = _data["ownerId"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerLastName = _data["ownerLastName"];
            this.billingIdent = _data["billingIdent"];
            this.subscriptionIdent = _data["subscriptionIdent"];
            this.chargifyComponentType = _data["chargifyComponentType"];
            this.componentId = _data["componentId"];
            this.componentHandle = _data["componentHandle"];
            this.componentName = _data["componentName"];
            this.componentPricePointId = _data["componentPricePointId"];
            this.componentPriceCurrencyCode = _data["componentPriceCurrencyCode"];
            this.componentCurrencySymbol = _data["componentCurrencySymbol"];
            this.componentPrice = _data["componentPrice"];
            this.componentDiscountedPrice = _data["componentDiscountedPrice"];
            this.componentTaxIncluded = _data["componentTaxIncluded"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCompanyModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["shortName"] = this.shortName;
        data["ownerId"] = this.ownerId;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerLastName"] = this.ownerLastName;
        data["billingIdent"] = this.billingIdent;
        data["subscriptionIdent"] = this.subscriptionIdent;
        data["chargifyComponentType"] = this.chargifyComponentType;
        data["componentId"] = this.componentId;
        data["componentHandle"] = this.componentHandle;
        data["componentName"] = this.componentName;
        data["componentPricePointId"] = this.componentPricePointId;
        data["componentPriceCurrencyCode"] = this.componentPriceCurrencyCode;
        data["componentCurrencySymbol"] = this.componentCurrencySymbol;
        data["componentPrice"] = this.componentPrice;
        data["componentDiscountedPrice"] = this.componentDiscountedPrice;
        data["componentTaxIncluded"] = this.componentTaxIncluded;
        return data;
    }
}
exports.SubscriptionCompanyModel = SubscriptionCompanyModel;
class SubscriptionComponentModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.handle = _data["handle"];
            this.name = _data["name"];
            this.pricePointId = _data["pricePointId"];
            this.priceCurrencyCode = _data["priceCurrencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.price = _data["price"];
            this.discountedPrice = _data["discountedPrice"];
            this.taxIncluded = _data["taxIncluded"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionComponentModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["handle"] = this.handle;
        data["name"] = this.name;
        data["pricePointId"] = this.pricePointId;
        data["priceCurrencyCode"] = this.priceCurrencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["price"] = this.price;
        data["discountedPrice"] = this.discountedPrice;
        data["taxIncluded"] = this.taxIncluded;
        return data;
    }
}
exports.SubscriptionComponentModel = SubscriptionComponentModel;
class SubscriptionCouponModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.couponCode = _data["couponCode"];
            this.couponName = _data["couponName"];
            this.discountPercent = _data["discountPercent"];
            this.discountDisplay = _data["discountDisplay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCouponModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["couponCode"] = this.couponCode;
        data["couponName"] = this.couponName;
        data["discountPercent"] = this.discountPercent;
        data["discountDisplay"] = this.discountDisplay;
        return data;
    }
}
exports.SubscriptionCouponModel = SubscriptionCouponModel;
class SubscriptionCustomerModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.chargifyID = _data["chargifyID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.organization = _data["organization"];
            this.vatNumber = _data["vatNumber"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingZip = _data["shippingZip"];
            this.shippingState = _data["shippingState"];
            this.shippingCountry = _data["shippingCountry"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCustomerModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["chargifyID"] = this.chargifyID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["organization"] = this.organization;
        data["vatNumber"] = this.vatNumber;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingZip"] = this.shippingZip;
        data["shippingState"] = this.shippingState;
        data["shippingCountry"] = this.shippingCountry;
        return data;
    }
}
exports.SubscriptionCustomerModel = SubscriptionCustomerModel;
class SubscriptionProductModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.handle = _data["handle"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionProductModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["handle"] = this.handle;
        data["name"] = this.name;
        return data;
    }
}
exports.SubscriptionProductModel = SubscriptionProductModel;
var SuperRuleCode;
(function (SuperRuleCode) {
    SuperRuleCode[SuperRuleCode["_0"] = 0] = "_0";
    SuperRuleCode[SuperRuleCode["_1"] = 1] = "_1";
})(SuperRuleCode || (exports.SuperRuleCode = SuperRuleCode = {}));
class Supplier {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.contactName = _data["contactName"];
            this.terms = _data["terms"];
            this.notes = _data["notes"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.masterId = _data["masterId"];
            this.orderDirect = _data["orderDirect"];
            this.pgId = _data["pgId"];
            this.orderDirectCredentials = _data["orderDirectCredentials"];
            this.orderDirectCredentialsStore = _data["orderDirectCredentialsStore"];
            this.orderDirectProvider = _data["orderDirectProvider"];
            this.customerNumber = _data["customerNumber"];
            this.xeroContactId = _data["xeroContactId"];
            this.emailEnabled = _data["emailEnabled"];
            this.faxEnabled = _data["faxEnabled"];
            this.validateStockCode = _data["validateStockCode"];
            this.lastOrderAt = _data["lastOrderAt"] ? dayjs(_data["lastOrderAt"].toString()) : undefined;
            if (Array.isArray(_data["stockListRules"])) {
                this.stockListRules = [];
                for (let item of _data["stockListRules"])
                    this.stockListRules.push(ListRule.fromJS(item));
            }
            this.unitCostIncludesTax = _data["unitCostIncludesTax"];
            if (Array.isArray(_data["aliases"])) {
                this.aliases = [];
                for (let item of _data["aliases"])
                    this.aliases.push(SupplierAlias.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["contactName"] = this.contactName;
        data["terms"] = this.terms;
        data["notes"] = this.notes;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["masterId"] = this.masterId;
        data["orderDirect"] = this.orderDirect;
        data["pgId"] = this.pgId;
        data["orderDirectCredentials"] = this.orderDirectCredentials;
        data["orderDirectCredentialsStore"] = this.orderDirectCredentialsStore;
        data["orderDirectProvider"] = this.orderDirectProvider;
        data["customerNumber"] = this.customerNumber;
        data["xeroContactId"] = this.xeroContactId;
        data["emailEnabled"] = this.emailEnabled;
        data["faxEnabled"] = this.faxEnabled;
        data["validateStockCode"] = this.validateStockCode;
        data["lastOrderAt"] = this.lastOrderAt ? this.lastOrderAt.toISOString() : undefined;
        if (Array.isArray(this.stockListRules)) {
            data["stockListRules"] = [];
            for (let item of this.stockListRules)
                data["stockListRules"].push(item.toJSON());
        }
        data["unitCostIncludesTax"] = this.unitCostIncludesTax;
        if (Array.isArray(this.aliases)) {
            data["aliases"] = [];
            for (let item of this.aliases)
                data["aliases"].push(item.toJSON());
        }
        return data;
    }
}
exports.Supplier = Supplier;
class SupplierAlias {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : undefined;
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierAlias();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : undefined;
        data["name"] = this.name;
        return data;
    }
}
exports.SupplierAlias = SupplierAlias;
class SupplierModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.contactName = _data["contactName"];
            this.terms = _data["terms"];
            this.notes = _data["notes"];
            this.datestampCreated = _data["datestampCreated"] ? dayjs(_data["datestampCreated"].toString()) : undefined;
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.masterId = _data["masterId"];
            this.orderDirect = _data["orderDirect"];
            this.orderDirectCredentials = _data["orderDirectCredentials"];
            this.orderDirectProvider = _data["orderDirectProvider"];
            this.customerNumber = _data["customerNumber"];
            this.xeroContactId = _data["xeroContactId"];
            this.emailEnabled = _data["emailEnabled"];
            this.faxEnabled = _data["faxEnabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["contactName"] = this.contactName;
        data["terms"] = this.terms;
        data["notes"] = this.notes;
        data["datestampCreated"] = this.datestampCreated ? this.datestampCreated.toISOString() : undefined;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["masterId"] = this.masterId;
        data["orderDirect"] = this.orderDirect;
        data["orderDirectCredentials"] = this.orderDirectCredentials;
        data["orderDirectProvider"] = this.orderDirectProvider;
        data["customerNumber"] = this.customerNumber;
        data["xeroContactId"] = this.xeroContactId;
        data["emailEnabled"] = this.emailEnabled;
        data["faxEnabled"] = this.faxEnabled;
        return data;
    }
}
exports.SupplierModel = SupplierModel;
class ThirdPartyConnectionAuthoriseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.scope = _data["scope"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyConnectionAuthoriseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["scope"] = this.scope;
        return data;
    }
}
exports.ThirdPartyConnectionAuthoriseModel = ThirdPartyConnectionAuthoriseModel;
class ThirdPartyConnectionCompanyAttachModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.thirdPartyCompanyId = _data["thirdPartyCompanyId"];
            if (_data["thirdPartyDisplayMetadata"]) {
                this.thirdPartyDisplayMetadata = {};
                for (let key in _data["thirdPartyDisplayMetadata"]) {
                    if (_data["thirdPartyDisplayMetadata"].hasOwnProperty(key))
                        this.thirdPartyDisplayMetadata[key] = _data["thirdPartyDisplayMetadata"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyConnectionCompanyAttachModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["thirdPartyCompanyId"] = this.thirdPartyCompanyId;
        if (this.thirdPartyDisplayMetadata) {
            data["thirdPartyDisplayMetadata"] = {};
            for (let key in this.thirdPartyDisplayMetadata) {
                if (this.thirdPartyDisplayMetadata.hasOwnProperty(key))
                    data["thirdPartyDisplayMetadata"][key] = this.thirdPartyDisplayMetadata[key];
            }
        }
        return data;
    }
}
exports.ThirdPartyConnectionCompanyAttachModel = ThirdPartyConnectionCompanyAttachModel;
class TokenResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.token_type = _data["token_type"];
            this.expires_in = _data["expires_in"];
            this.refresh_token = _data["refresh_token"];
            this.as_client_id = _data["as:client_id"];
            this.userName = _data["userName"];
            this.Issued = _data[".issued"];
            this.Expires = _data[".expires"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["token_type"] = this.token_type;
        data["expires_in"] = this.expires_in;
        data["refresh_token"] = this.refresh_token;
        data["as:client_id"] = this.as_client_id;
        data["userName"] = this.userName;
        data[".issued"] = this.Issued;
        data[".expires"] = this.Expires;
        return data;
    }
}
exports.TokenResponse = TokenResponse;
class TopQueryOption {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? ITopQueryValidator.fromJS(_data["validator"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TopQueryOption();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    }
}
exports.TopQueryOption = TopQueryOption;
class TransformationNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.kind = _data["kind"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TransformationNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        return data;
    }
}
exports.TransformationNode = TransformationNode;
var TransformationNodeKind;
(function (TransformationNodeKind) {
    TransformationNodeKind[TransformationNodeKind["_0"] = 0] = "_0";
    TransformationNodeKind[TransformationNodeKind["_1"] = 1] = "_1";
    TransformationNodeKind[TransformationNodeKind["_2"] = 2] = "_2";
    TransformationNodeKind[TransformationNodeKind["_3"] = 3] = "_3";
    TransformationNodeKind[TransformationNodeKind["_4"] = 4] = "_4";
})(TransformationNodeKind || (exports.TransformationNodeKind = TransformationNodeKind = {}));
class Type {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            this.namespace = _data["namespace"];
            this.assemblyQualifiedName = _data["assemblyQualifiedName"];
            this.fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            this.isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : undefined;
            this.isTypeDefinition = _data["isTypeDefinition"];
            this.isArray = _data["isArray"];
            this.isByRef = _data["isByRef"];
            this.isPointer = _data["isPointer"];
            this.isConstructedGenericType = _data["isConstructedGenericType"];
            this.isGenericParameter = _data["isGenericParameter"];
            this.isGenericTypeParameter = _data["isGenericTypeParameter"];
            this.isGenericMethodParameter = _data["isGenericMethodParameter"];
            this.isGenericType = _data["isGenericType"];
            this.isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            this.isSZArray = _data["isSZArray"];
            this.isVariableBoundArray = _data["isVariableBoundArray"];
            this.isByRefLike = _data["isByRefLike"];
            this.isFunctionPointer = _data["isFunctionPointer"];
            this.isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            this.hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                this.genericTypeArguments = [];
                for (let item of _data["genericTypeArguments"])
                    this.genericTypeArguments.push(Type.fromJS(item));
            }
            this.genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            this.isAbstract = _data["isAbstract"];
            this.isImport = _data["isImport"];
            this.isSealed = _data["isSealed"];
            this.isSpecialName = _data["isSpecialName"];
            this.isClass = _data["isClass"];
            this.isNestedAssembly = _data["isNestedAssembly"];
            this.isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            this.isNestedFamily = _data["isNestedFamily"];
            this.isNestedFamORAssem = _data["isNestedFamORAssem"];
            this.isNestedPrivate = _data["isNestedPrivate"];
            this.isNestedPublic = _data["isNestedPublic"];
            this.isNotPublic = _data["isNotPublic"];
            this.isPublic = _data["isPublic"];
            this.isAutoLayout = _data["isAutoLayout"];
            this.isExplicitLayout = _data["isExplicitLayout"];
            this.isLayoutSequential = _data["isLayoutSequential"];
            this.isAnsiClass = _data["isAnsiClass"];
            this.isAutoClass = _data["isAutoClass"];
            this.isUnicodeClass = _data["isUnicodeClass"];
            this.isCOMObject = _data["isCOMObject"];
            this.isContextful = _data["isContextful"];
            this.isEnum = _data["isEnum"];
            this.isMarshalByRef = _data["isMarshalByRef"];
            this.isPrimitive = _data["isPrimitive"];
            this.isValueType = _data["isValueType"];
            this.isSignatureType = _data["isSignatureType"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : undefined;
            this.guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : undefined;
            this.isSerializable = _data["isSerializable"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.isVisible = _data["isVisible"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}
exports.Type = Type;
var TypeAttributes;
(function (TypeAttributes) {
    TypeAttributes[TypeAttributes["_0"] = 0] = "_0";
    TypeAttributes[TypeAttributes["_1"] = 1] = "_1";
    TypeAttributes[TypeAttributes["_2"] = 2] = "_2";
    TypeAttributes[TypeAttributes["_3"] = 3] = "_3";
    TypeAttributes[TypeAttributes["_4"] = 4] = "_4";
    TypeAttributes[TypeAttributes["_5"] = 5] = "_5";
    TypeAttributes[TypeAttributes["_6"] = 6] = "_6";
    TypeAttributes[TypeAttributes["_7"] = 7] = "_7";
    TypeAttributes[TypeAttributes["_8"] = 8] = "_8";
    TypeAttributes[TypeAttributes["_16"] = 16] = "_16";
    TypeAttributes[TypeAttributes["_24"] = 24] = "_24";
    TypeAttributes[TypeAttributes["_32"] = 32] = "_32";
    TypeAttributes[TypeAttributes["_128"] = 128] = "_128";
    TypeAttributes[TypeAttributes["_256"] = 256] = "_256";
    TypeAttributes[TypeAttributes["_1024"] = 1024] = "_1024";
    TypeAttributes[TypeAttributes["_2048"] = 2048] = "_2048";
    TypeAttributes[TypeAttributes["_4096"] = 4096] = "_4096";
    TypeAttributes[TypeAttributes["_8192"] = 8192] = "_8192";
    TypeAttributes[TypeAttributes["_16384"] = 16384] = "_16384";
    TypeAttributes[TypeAttributes["_65536"] = 65536] = "_65536";
    TypeAttributes[TypeAttributes["_131072"] = 131072] = "_131072";
    TypeAttributes[TypeAttributes["_196608"] = 196608] = "_196608";
    TypeAttributes[TypeAttributes["_262144"] = 262144] = "_262144";
    TypeAttributes[TypeAttributes["_264192"] = 264192] = "_264192";
    TypeAttributes[TypeAttributes["_1048576"] = 1048576] = "_1048576";
    TypeAttributes[TypeAttributes["_12582912"] = 12582912] = "_12582912";
})(TypeAttributes || (exports.TypeAttributes = TypeAttributes = {}));
class TypeInfo {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [];
                for (let item of _data["customAttributes"])
                    this.customAttributes.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
            this.isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            this.namespace = _data["namespace"];
            this.assemblyQualifiedName = _data["assemblyQualifiedName"];
            this.fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined;
            this.isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : undefined;
            this.isTypeDefinition = _data["isTypeDefinition"];
            this.isArray = _data["isArray"];
            this.isByRef = _data["isByRef"];
            this.isPointer = _data["isPointer"];
            this.isConstructedGenericType = _data["isConstructedGenericType"];
            this.isGenericParameter = _data["isGenericParameter"];
            this.isGenericTypeParameter = _data["isGenericTypeParameter"];
            this.isGenericMethodParameter = _data["isGenericMethodParameter"];
            this.isGenericType = _data["isGenericType"];
            this.isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            this.isSZArray = _data["isSZArray"];
            this.isVariableBoundArray = _data["isVariableBoundArray"];
            this.isByRefLike = _data["isByRefLike"];
            this.isFunctionPointer = _data["isFunctionPointer"];
            this.isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            this.hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                this.genericTypeArguments = [];
                for (let item of _data["genericTypeArguments"])
                    this.genericTypeArguments.push(Type.fromJS(item));
            }
            this.genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            this.isAbstract = _data["isAbstract"];
            this.isImport = _data["isImport"];
            this.isSealed = _data["isSealed"];
            this.isSpecialName = _data["isSpecialName"];
            this.isClass = _data["isClass"];
            this.isNestedAssembly = _data["isNestedAssembly"];
            this.isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            this.isNestedFamily = _data["isNestedFamily"];
            this.isNestedFamORAssem = _data["isNestedFamORAssem"];
            this.isNestedPrivate = _data["isNestedPrivate"];
            this.isNestedPublic = _data["isNestedPublic"];
            this.isNotPublic = _data["isNotPublic"];
            this.isPublic = _data["isPublic"];
            this.isAutoLayout = _data["isAutoLayout"];
            this.isExplicitLayout = _data["isExplicitLayout"];
            this.isLayoutSequential = _data["isLayoutSequential"];
            this.isAnsiClass = _data["isAnsiClass"];
            this.isAutoClass = _data["isAutoClass"];
            this.isUnicodeClass = _data["isUnicodeClass"];
            this.isCOMObject = _data["isCOMObject"];
            this.isContextful = _data["isContextful"];
            this.isEnum = _data["isEnum"];
            this.isMarshalByRef = _data["isMarshalByRef"];
            this.isPrimitive = _data["isPrimitive"];
            this.isValueType = _data["isValueType"];
            this.isSignatureType = _data["isSignatureType"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : undefined;
            this.guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : undefined;
            this.isSerializable = _data["isSerializable"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                this.genericTypeParameters = [];
                for (let item of _data["genericTypeParameters"])
                    this.genericTypeParameters.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                this.declaredConstructors = [];
                for (let item of _data["declaredConstructors"])
                    this.declaredConstructors.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                this.declaredEvents = [];
                for (let item of _data["declaredEvents"])
                    this.declaredEvents.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                this.declaredFields = [];
                for (let item of _data["declaredFields"])
                    this.declaredFields.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                this.declaredMembers = [];
                for (let item of _data["declaredMembers"])
                    this.declaredMembers.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                this.declaredMethods = [];
                for (let item of _data["declaredMethods"])
                    this.declaredMethods.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                this.declaredNestedTypes = [];
                for (let item of _data["declaredNestedTypes"])
                    this.declaredNestedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                this.declaredProperties = [];
                for (let item of _data["declaredProperties"])
                    this.declaredProperties.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                this.implementedInterfaces = [];
                for (let item of _data["implementedInterfaces"])
                    this.implementedInterfaces.push(Type.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined;
        data["module"] = this.module ? this.module.toJSON() : undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item.toJSON());
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item.toJSON());
        }
        return data;
    }
}
exports.TypeInfo = TypeInfo;
class TypeObjectKeyValuePair {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"] ? Type.fromJS(_data["key"]) : undefined;
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TypeObjectKeyValuePair();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : undefined;
        data["value"] = this.value;
        return data;
    }
}
exports.TypeObjectKeyValuePair = TypeObjectKeyValuePair;
class UnavailabilityRecord {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.times = [];
            this.actions = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.staffMemberId = _data["staffMemberId"];
            this.type = _data["type"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.status = _data["status"];
            this.preferredHours = _data["preferredHours"] ? LoadedPreferredHours.fromJS(_data["preferredHours"]) : undefined;
            this.note = _data["note"];
            if (Array.isArray(_data["times"])) {
                this.times = [];
                for (let item of _data["times"])
                    this.times.push(UnavailabilityTime.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [];
                for (let item of _data["actions"])
                    this.actions.push(Action.fromJS(item));
            }
            this.automaticallyApprove = _data["automaticallyApprove"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailabilityRecord();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffMemberId"] = this.staffMemberId;
        data["type"] = this.type;
        data["from"] = this.from;
        data["to"] = this.to;
        data["status"] = this.status;
        data["preferredHours"] = this.preferredHours ? this.preferredHours.toJSON() : undefined;
        data["note"] = this.note;
        if (Array.isArray(this.times)) {
            data["times"] = [];
            for (let item of this.times)
                data["times"].push(item.toJSON());
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["automaticallyApprove"] = this.automaticallyApprove;
        return data;
    }
}
exports.UnavailabilityRecord = UnavailabilityRecord;
class UnavailabilityRecordUpdateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailabilityRecordUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}
exports.UnavailabilityRecordUpdateRequest = UnavailabilityRecordUpdateRequest;
class UnavailabilityTime {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.reason = _data["reason"];
            this.day = _data["day"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailabilityTime();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from;
        data["to"] = this.to;
        data["reason"] = this.reason;
        data["day"] = this.day;
        return data;
    }
}
exports.UnavailabilityTime = UnavailabilityTime;
class Unit {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.unitType = _data["unitType"];
            this.ratio = _data["ratio"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.masterId = _data["masterId"];
            this.pgId = _data["pgId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitType"] = this.unitType;
        data["ratio"] = this.ratio;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["masterId"] = this.masterId;
        data["pgId"] = this.pgId;
        return data;
    }
}
exports.Unit = Unit;
class UnitModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.unitType = _data["unitType"];
            this.ratio = _data["ratio"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitType"] = this.unitType;
        data["ratio"] = this.ratio;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.UnitModel = UnitModel;
class UpdateEndDateRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.end = _data["end"] ? dayjs(_data["end"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEndDateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["end"] = this.end ? this.end.toISOString() : undefined;
        return data;
    }
}
exports.UpdateEndDateRequest = UpdateEndDateRequest;
class UpdateProfileBindingModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileBindingModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}
exports.UpdateProfileBindingModel = UpdateProfileBindingModel;
class UpdateStaffPosMemberRoleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.posIdentifier = _data["posIdentifier"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStaffPosMemberRoleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["posIdentifier"] = this.posIdentifier;
        data["name"] = this.name;
        return data;
    }
}
exports.UpdateStaffPosMemberRoleRequest = UpdateStaffPosMemberRoleRequest;
var VariationActionType;
(function (VariationActionType) {
    VariationActionType[VariationActionType["Add"] = "Add"] = "Add";
    VariationActionType[VariationActionType["Subtract"] = "Subtract"] = "Subtract";
})(VariationActionType || (exports.VariationActionType = VariationActionType = {}));
var VariationUnitType;
(function (VariationUnitType) {
    VariationUnitType[VariationUnitType["Currency"] = "Currency"] = "Currency";
    VariationUnitType[VariationUnitType["Percent"] = "Percent"] = "Percent";
})(VariationUnitType || (exports.VariationUnitType = VariationUnitType = {}));
class WaitHandle {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.handle = _data["handle"] ? IntPtr.fromJS(_data["handle"]) : undefined;
            this.safeWaitHandle = _data["safeWaitHandle"] ? SafeWaitHandle.fromJS(_data["safeWaitHandle"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WaitHandle();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["handle"] = this.handle ? this.handle.toJSON() : undefined;
        data["safeWaitHandle"] = this.safeWaitHandle ? this.safeWaitHandle.toJSON() : undefined;
        return data;
    }
}
exports.WaitHandle = WaitHandle;
class WebSocketManager {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isWebSocketRequest = _data["isWebSocketRequest"];
            if (Array.isArray(_data["webSocketRequestedProtocols"])) {
                this.webSocketRequestedProtocols = [];
                for (let item of _data["webSocketRequestedProtocols"])
                    this.webSocketRequestedProtocols.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WebSocketManager();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isWebSocketRequest"] = this.isWebSocketRequest;
        if (Array.isArray(this.webSocketRequestedProtocols)) {
            data["webSocketRequestedProtocols"] = [];
            for (let item of this.webSocketRequestedProtocols)
                data["webSocketRequestedProtocols"].push(item);
        }
        return data;
    }
}
exports.WebSocketManager = WebSocketManager;
class X500DistinguishedName {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.oid = _data["oid"] ? Oid.fromJS(_data["oid"]) : undefined;
            this.rawData = _data["rawData"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new X500DistinguishedName();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid ? this.oid.toJSON() : undefined;
        data["rawData"] = this.rawData;
        data["name"] = this.name;
        return data;
    }
}
exports.X500DistinguishedName = X500DistinguishedName;
class X509Certificate2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.handle = _data["handle"] ? IntPtr.fromJS(_data["handle"]) : undefined;
            this.issuer = _data["issuer"];
            this.subject = _data["subject"];
            this.serialNumberBytes = _data["serialNumberBytes"] ? ByteReadOnlyMemory.fromJS(_data["serialNumberBytes"]) : undefined;
            this.archived = _data["archived"];
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [];
                for (let item of _data["extensions"])
                    this.extensions.push(X509Extension.fromJS(item));
            }
            this.friendlyName = _data["friendlyName"];
            this.hasPrivateKey = _data["hasPrivateKey"];
            this.privateKey = _data["privateKey"] ? AsymmetricAlgorithm.fromJS(_data["privateKey"]) : undefined;
            this.issuerName = _data["issuerName"] ? X500DistinguishedName.fromJS(_data["issuerName"]) : undefined;
            this.notAfter = _data["notAfter"] ? dayjs(_data["notAfter"].toString()) : undefined;
            this.notBefore = _data["notBefore"] ? dayjs(_data["notBefore"].toString()) : undefined;
            this.publicKey = _data["publicKey"] ? PublicKey.fromJS(_data["publicKey"]) : undefined;
            this.rawData = _data["rawData"];
            this.rawDataMemory = _data["rawDataMemory"] ? ByteReadOnlyMemory.fromJS(_data["rawDataMemory"]) : undefined;
            this.serialNumber = _data["serialNumber"];
            this.signatureAlgorithm = _data["signatureAlgorithm"] ? Oid.fromJS(_data["signatureAlgorithm"]) : undefined;
            this.subjectName = _data["subjectName"] ? X500DistinguishedName.fromJS(_data["subjectName"]) : undefined;
            this.thumbprint = _data["thumbprint"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new X509Certificate2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["handle"] = this.handle ? this.handle.toJSON() : undefined;
        data["issuer"] = this.issuer;
        data["subject"] = this.subject;
        data["serialNumberBytes"] = this.serialNumberBytes ? this.serialNumberBytes.toJSON() : undefined;
        data["archived"] = this.archived;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item.toJSON());
        }
        data["friendlyName"] = this.friendlyName;
        data["hasPrivateKey"] = this.hasPrivateKey;
        data["privateKey"] = this.privateKey ? this.privateKey.toJSON() : undefined;
        data["issuerName"] = this.issuerName ? this.issuerName.toJSON() : undefined;
        data["notAfter"] = this.notAfter ? this.notAfter.toISOString() : undefined;
        data["notBefore"] = this.notBefore ? this.notBefore.toISOString() : undefined;
        data["publicKey"] = this.publicKey ? this.publicKey.toJSON() : undefined;
        data["rawData"] = this.rawData;
        data["rawDataMemory"] = this.rawDataMemory ? this.rawDataMemory.toJSON() : undefined;
        data["serialNumber"] = this.serialNumber;
        data["signatureAlgorithm"] = this.signatureAlgorithm ? this.signatureAlgorithm.toJSON() : undefined;
        data["subjectName"] = this.subjectName ? this.subjectName.toJSON() : undefined;
        data["thumbprint"] = this.thumbprint;
        data["version"] = this.version;
        return data;
    }
}
exports.X509Certificate2 = X509Certificate2;
class X509Extension {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.oid = _data["oid"] ? Oid.fromJS(_data["oid"]) : undefined;
            this.rawData = _data["rawData"];
            this.critical = _data["critical"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new X509Extension();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["oid"] = this.oid ? this.oid.toJSON() : undefined;
        data["rawData"] = this.rawData;
        data["critical"] = this.critical;
        return data;
    }
}
exports.X509Extension = X509Extension;
class Body {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.grant_type = _data["grant_type"];
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.scope = _data["Scope"];
            this.client_id = _data["client_id"];
            this.client_secret = _data["client_secret"];
            this.refresh_token = _data["refresh_token"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["grant_type"] = this.grant_type;
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["Scope"] = this.scope;
        data["client_id"] = this.client_id;
        data["client_secret"] = this.client_secret;
        data["refresh_token"] = this.refresh_token;
        return data;
    }
}
exports.Body = Body;
class Body2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.grant_type = _data["grant_type"];
            this.username = _data["Username"];
            this.password = _data["Password"];
            this.scope = _data["Scope"];
            this.client_id = _data["client_id"];
            this.client_secret = _data["client_secret"];
            this.refresh_token = _data["refresh_token"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["grant_type"] = this.grant_type;
        data["Username"] = this.username;
        data["Password"] = this.password;
        data["Scope"] = this.scope;
        data["client_id"] = this.client_id;
        data["client_secret"] = this.client_secret;
        data["refresh_token"] = this.refresh_token;
        return data;
    }
}
exports.Body2 = Body2;
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
